/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type AccountActivation = {
  __typename?: 'AccountActivation';
  business: Business;
  client?: Maybe<Client>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  sentEmail?: Maybe<SentEmail>;
  updatedAt: Scalars['DateTimeISO']['output'];
  used?: Maybe<Scalars['Boolean']['output']>;
};

export enum AccountType {
  Artisan = 'Artisan',
  Business = 'Business',
  Homeowner = 'Homeowner'
}

export type AddCategorySubscriptionPackagePriceIntervalChange = {
  discount: Scalars['Float']['input'];
  interval: SubscriptionInterval;
};

export type AddJobsToOrderInput = {
  cartItems: Array<OrderCartItem>;
  location: JobLocationData;
};

export type AddLocationInput = {
  area: Scalars['String']['input'];
  buildingNumber: Scalars['String']['input'];
  city: Scalars['String']['input'];
  landmark: Scalars['String']['input'];
  location: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
};

export type AddOrganizationFacilityContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type AddRewardPointChangeInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  point: Scalars['Int']['input'];
  tradesmanId: Scalars['String']['input'];
};

export type AddRewardPointChangeResponse = IResponse & {
  __typename?: 'AddRewardPointChangeResponse';
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type Address = {
  __typename?: 'Address';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  contactPerson?: Maybe<ContactPerson>;
  createdAt: Scalars['DateTimeISO']['output'];
  formattedAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  location?: Maybe<Point>;
  placeId?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type AddressInput = {
  address: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<Array<Scalars['Float']['input']>>;
  formattedAddress: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type Admin = {
  __typename?: 'Admin';
  authProviderId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  roles: Array<Role>;
  userId: Scalars['String']['output'];
};

export type AdminCreateHomeownerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  leadSource?: InputMaybe<LeadSource>;
  location?: InputMaybe<ClientLocation>;
  otherLeadSourceText?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type AdminEmployerJobAdEdge = Edge & {
  __typename?: 'AdminEmployerJobAdEdge';
  cursor: Scalars['String']['output'];
  node: EmployerJobAd;
};

export type AdminEmployerJobAdsResponse = Edges & {
  __typename?: 'AdminEmployerJobAdsResponse';
  edges: Array<AdminEmployerJobAdEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type AdminJobAdNotificationEntry = {
  __typename?: 'AdminJobAdNotificationEntry';
  eligibleProsCount: Scalars['Int']['output'];
  jobAdId: Scalars['String']['output'];
  matchedProsCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type AdminJobAdNotificationResponse = {
  __typename?: 'AdminJobAdNotificationResponse';
  dryRun: Scalars['Boolean']['output'];
  entries: Array<AdminJobAdNotificationEntry>;
  totalJobAds: Scalars['Int']['output'];
  totalNotificationsSent: Scalars['Int']['output'];
};

export type AdminProsWithinReachEdge = Edge & {
  __typename?: 'AdminProsWithinReachEdge';
  cursor: Scalars['String']['output'];
  node: Pro;
};

export type AdminProsWithinReachResponse = Edges & {
  __typename?: 'AdminProsWithinReachResponse';
  edges: Array<AdminProsWithinReachEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type AdminRoleData = {
  __typename?: 'AdminRoleData';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AdminUpdateHomeownerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AggregateOrder = {
  __typename?: 'AggregateOrder';
  client: OrderUser;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  inspectionPayment?: Maybe<Payment>;
  isAssigned: Scalars['Boolean']['output'];
  isCompleted: Scalars['Boolean']['output'];
  jobs: Array<Job>;
  orderCode: Scalars['String']['output'];
};

export type AgreementAcceptance = {
  __typename?: 'AgreementAcceptance';
  hash: Scalars['String']['output'];
  signedAt: Scalars['DateTimeISO']['output'];
  signedBy: Scalars['String']['output'];
};

export type AgreementCheckResult = {
  __typename?: 'AgreementCheckResult';
  accepted: Scalars['Boolean']['output'];
  agreementId?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
};

export enum AgreementType {
  PrivacyPolicy = 'PRIVACY_POLICY',
  ServiceLevelAgreement = 'SERVICE_LEVEL_AGREEMENT',
  TermsOfUse = 'TERMS_OF_USE',
  TermsOfUseAndPrivacyPolicy = 'TERMS_OF_USE_AND_PRIVACY_POLICY'
}

export type AllServiceCategory = {
  __typename?: 'AllServiceCategory';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isVisible: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  proTitle?: Maybe<Scalars['String']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  subCategoryIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type AllServiceSubCategory = {
  __typename?: 'AllServiceSubCategory';
  categoryId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  requestCount?: Maybe<Scalars['Float']['output']>;
  taskIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type AllServices = {
  __typename?: 'AllServices';
  allCategories?: Maybe<Array<AllServiceCategory>>;
  allServiceTasks: Array<Task>;
  allSubCategories?: Maybe<Array<AllServiceSubCategory>>;
};

export type AnalyticsDateRange = {
  endDate: Scalars['DateTimeISO']['input'];
  startDate: Scalars['DateTimeISO']['input'];
};

export type AnnouncementSmsStats = {
  __typename?: 'AnnouncementSmsStats';
  delivered: Scalars['Float']['output'];
  failed: Scalars['Float']['output'];
  pending: Scalars['Float']['output'];
  sent: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type ApplicantSnapshot = {
  __typename?: 'ApplicantSnapshot';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  yearsOfExperience?: Maybe<Scalars['Float']['output']>;
};

export type ApplicantUnlockRequest = {
  __typename?: 'ApplicantUnlockRequest';
  applicants: Array<BaseJobApplicant>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  invoice: Invoice;
  organization: Organization;
  status: ApplicantUnlockRequestStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum ApplicantUnlockRequestStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type ApplicantUnlockResponse = {
  __typename?: 'ApplicantUnlockResponse';
  accessCode: Scalars['String']['output'];
  authorizationUrl: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  unlockRequestId: Scalars['String']['output'];
};

export enum ApplicationStatus {
  Drafted = 'DRAFTED',
  Hired = 'HIRED',
  OfferAccepted = 'OFFER_ACCEPTED',
  OfferDeclined = 'OFFER_DECLINED',
  OfferMade = 'OFFER_MADE',
  Rejected = 'REJECTED',
  Shortlisted = 'SHORTLISTED',
  Submitted = 'SUBMITTED',
  Viewed = 'VIEWED'
}

/** Arguments for applying a scheduled plan spec transition immediately */
export type ApplyPlanSpecTransitionImmediatelyArgs = {
  /** Transition intent ID to apply immediately */
  intentId: Scalars['String']['input'];
};

export type ApproveAssignmentPaymentInput = {
  assignmentPaymentId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};

export type ApproveRefundRequestInput = {
  providerId: Scalars['String']['input'];
  refundRequestId: Scalars['String']['input'];
};

export type ArtisanClient = {
  __typename?: 'ArtisanClient';
  address: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  user: WhatsappUser;
};

export type ArtisanInvoice = {
  createdAt: Scalars['DateTimeISO']['output'];
  from: FromDetails;
  invoiceNumber: Scalars['Int']['output'];
  labor?: Maybe<Scalars['Float']['output']>;
  materials: Array<ArtisanInvoiceMaterial>;
  recipientAccountNumber?: Maybe<Scalars['String']['output']>;
  status: ArtisanInvoiceStatus;
  task?: Maybe<ArtisanInvoiceTask>;
  to?: Maybe<ToDetails>;
  updatedAt: Scalars['DateTimeISO']['output'];
  user: WhatsappUser;
};

export type ArtisanInvoiceMaterial = {
  __typename?: 'ArtisanInvoiceMaterial';
  name: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  unitCost: Scalars['Float']['output'];
};

export enum ArtisanInvoiceStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type ArtisanInvoiceTask = {
  __typename?: 'ArtisanInvoiceTask';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AssignJobsToTradesmanInput = {
  date: Scalars['DateTimeISO']['input'];
  jobIds: Array<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  tradesmanId: Scalars['String']['input'];
};

export type AssignmentConflict = {
  __typename?: 'AssignmentConflict';
  assignment: TradesmanAssignment;
  type: ScheduleConflictType;
};

export type AssignmentPayment = {
  __typename?: 'AssignmentPayment';
  assignment: TradesmanAssignment;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  order: Order;
  tradesman?: Maybe<Tradesman>;
  transfer: Transfer;
  type: AssignmentPaymentTypes;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type AssignmentPaymentEdge = Edge & {
  __typename?: 'AssignmentPaymentEdge';
  cursor: Scalars['String']['output'];
  node: AssignmentPayment;
};

export type AssignmentPaymentStatus = {
  __typename?: 'AssignmentPaymentStatus';
  labor: Scalars['Boolean']['output'];
  materials: Scalars['Boolean']['output'];
  transportation: Scalars['Boolean']['output'];
};

export enum AssignmentPaymentTypes {
  Labor = 'LABOR',
  Materials = 'MATERIALS',
  Transportation = 'TRANSPORTATION'
}

export enum AssignmentProgress {
  Assigned = 'ASSIGNED',
  ClientInspection = 'CLIENT_INSPECTION',
  ClientInspectionCompleted = 'CLIENT_INSPECTION_COMPLETED',
  Completed = 'COMPLETED',
  FinalQuote = 'FINAL_QUOTE',
  MaterialsPurchased = 'MATERIALS_PURCHASED',
  NotStarted = 'NOT_STARTED',
  PreInspection = 'PRE_INSPECTION',
  UnAssigned = 'UN_ASSIGNED'
}

export enum Availability {
  Available = 'AVAILABLE',
  Engaged = 'ENGAGED',
  Tentative = 'TENTATIVE'
}

export type AverageLaborHackJobsRatings = {
  __typename?: 'AverageLaborHackJobsRatings';
  averageAppearanceRating: Scalars['Float']['output'];
  averageBehaviorRating: Scalars['Float']['output'];
  averagePostServiceCleanUpRating: Scalars['Float']['output'];
  averageProperToolUsageRating: Scalars['Float']['output'];
  averagePunctualityRating: Scalars['Float']['output'];
};

export type BackfillResponse = {
  __typename?: 'BackfillResponse';
  message: Scalars['String']['output'];
};

/** background check details for a user */
export type BackgroundCheck = {
  __typename?: 'BackgroundCheck';
  /** Guarantors for user */
  guarantors: Array<Guarantor>;
  id: Scalars['String']['output'];
  isComplete: Scalars['Boolean']['output'];
  /** Referees for this user */
  referees: Array<Referee>;
  userId: Scalars['String']['output'];
};

export type BankAccountInformation = {
  __typename?: 'BankAccountInformation';
  accountName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  bankName?: Maybe<Scalars['String']['output']>;
};

export type BankAccountInformationInput = {
  accountNumber: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
  proId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  referrerId?: InputMaybe<Scalars['String']['input']>;
};

export type BaseJobApplicant = {
  __typename?: 'BaseJobApplicant';
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isUnlocked: Scalars['Boolean']['output'];
  jobTitle: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  pro?: Maybe<Pro>;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  yearsOfExperience?: Maybe<Scalars['Float']['output']>;
};

export type BasicResponse = {
  __typename?: 'BasicResponse';
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BatchUpdateCandidateStatusDto = {
  candidateIds: Array<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  status: TalentPoolCandidateStatus;
};

/** Billing period information */
export type BillingPeriodInfo = {
  __typename?: 'BillingPeriodInfo';
  /** Current billing period end date */
  currentPeriodEnd?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Current billing period start date */
  currentPeriodStart?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Whether currently in grace period */
  isInGracePeriod?: Maybe<Scalars['Boolean']['output']>;
  /** Whether currently in trial period */
  isInTrial?: Maybe<Scalars['Boolean']['output']>;
  /** When the next billing would begin */
  nextBillingDate?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type BillingPeriodRecord = {
  __typename?: 'BillingPeriodRecord';
  invoice?: Maybe<Invoice>;
  isTrial: Scalars['Boolean']['output'];
  periodEnd?: Maybe<Scalars['DateTimeISO']['output']>;
  periodStart: Scalars['DateTimeISO']['output'];
  quotaUsage: QuotaUsage;
};

/** Action taken for a single organization during bulk plan spec transition */
export enum BulkPlanSpecTransitionAction {
  DowngradeIntentUpdated = 'DOWNGRADE_INTENT_UPDATED',
  Failed = 'FAILED',
  IntentCreated = 'INTENT_CREATED',
  Skipped = 'SKIPPED',
  SkippedDowngradePending = 'SKIPPED_DOWNGRADE_PENDING',
  TransitionedImmediately = 'TRANSITIONED_IMMEDIATELY',
  TransitionIntentUpdated = 'TRANSITION_INTENT_UPDATED'
}

/** Status and results of a bulk plan spec transition job */
export type BulkPlanSpecTransitionJob = {
  __typename?: 'BulkPlanSpecTransitionJob';
  failureCount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  processedCount: Scalars['Float']['output'];
  results: Array<BulkPlanSpecTransitionResultEntry>;
  sourceSpecId: Scalars['String']['output'];
  status: BulkPlanSpecTransitionJobStatus;
  successCount: Scalars['Float']['output'];
  targetSpecId: Scalars['String']['output'];
  totalCount: Scalars['Float']['output'];
};

/** Status of a bulk plan spec transition job */
export enum BulkPlanSpecTransitionJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  PartiallyCompleted = 'PARTIALLY_COMPLETED'
}

/** Result of a single organization transition within a bulk operation */
export type BulkPlanSpecTransitionResultEntry = {
  __typename?: 'BulkPlanSpecTransitionResultEntry';
  action: BulkPlanSpecTransitionAction;
  error?: Maybe<Scalars['String']['output']>;
  intentId?: Maybe<Scalars['String']['output']>;
  newSubscriptionId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
};

export type Business = {
  __typename?: 'Business';
  activated?: Maybe<Scalars['Boolean']['output']>;
  activationDeliveryStatus?: Maybe<SentEmailDeliveryStatus>;
  clients: Array<Client>;
  createdAt: Scalars['DateTimeISO']['output'];
  crmId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  listId: Scalars['Float']['output'];
  location?: Maybe<BusinessLocation>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type BusinessEdge = Edge & {
  __typename?: 'BusinessEdge';
  cursor: Scalars['String']['output'];
  node: Business;
};

export type BusinessLocation = {
  __typename?: 'BusinessLocation';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type BusinessMetadata = {
  __typename?: 'BusinessMetadata';
  activated?: Maybe<Scalars['Boolean']['output']>;
};

export type BusinessMetadataInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CanadaBasicApplication = {
  __typename?: 'CanadaBasicApplication';
  canCoverMinimumDeposit?: Maybe<Scalars['Boolean']['output']>;
  citizenship: CanadaBasicApplicationCitizenship;
  contributionAmountInCAD?: Maybe<Scalars['Float']['output']>;
  countryOfStudy: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  educationLevel: CanadaBasicApplicationEducationLevel;
  graduationYear: Scalars['Float']['output'];
  hasInternationalPassport: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  intendedCourseOfStudy: CanadaBasicApplicationCourseOfStudy;
  intendedProficiencyTestDate?: Maybe<Scalars['DateTimeISO']['output']>;
  intendedStudyResumptionDate: Scalars['DateTimeISO']['output'];
  needsLoan: Scalars['Boolean']['output'];
  passportExpiryDate?: Maybe<Scalars['DateTimeISO']['output']>;
  passportIssueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  pro: Pro;
  takenEnglishProficiencyTest: Scalars['Boolean']['output'];
  testCompletionScore?: Maybe<Scalars['Float']['output']>;
  testCompletionYear?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum CanadaBasicApplicationCitizenship {
  Nigerian = 'NIGERIAN',
  Other = 'OTHER'
}

export enum CanadaBasicApplicationCourseOfStudy {
  Bim = 'BIM',
  CarpentryAndRenovationTechnician = 'CARPENTRY_AND_RENOVATION_TECHNICIAN',
  CncTechnician = 'CNC_TECHNICIAN',
  ConstructionEngineeringTechnician = 'CONSTRUCTION_ENGINEERING_TECHNICIAN',
  ConstructionManagement = 'CONSTRUCTION_MANAGEMENT',
  ElectricalTechniques = 'ELECTRICAL_TECHNIQUES',
  ElectromechanicalEngineeringTechnician = 'ELECTROMECHANICAL_ENGINEERING_TECHNICIAN',
  HeatingRefrigerationAcTechnician = 'HEATING_REFRIGERATION_AC_TECHNICIAN',
  WeldingTechniques = 'WELDING_TECHNIQUES'
}

export enum CanadaBasicApplicationEducationLevel {
  Bachelors = 'BACHELORS',
  Doctorate = 'DOCTORATE',
  Hnd = 'HND',
  Kcse = 'KCSE',
  Masters = 'MASTERS',
  Ond = 'OND',
  Ssce = 'SSCE'
}

export type CancelTransferRequestInput = {
  transferRequestId: Scalars['String']['input'];
};

export type CardAuthorization = {
  __typename?: 'CardAuthorization';
  authorizationCode?: Maybe<Scalars['String']['output']>;
  bank?: Maybe<Scalars['String']['output']>;
  bin?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  checkoutUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  customerCode?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  expMonth?: Maybe<Scalars['String']['output']>;
  expYear?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isStandalone: Scalars['Boolean']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  refundErrorMessage?: Maybe<Scalars['String']['output']>;
  refundStatus?: Maybe<Scalars['String']['output']>;
  refundTransactionReference?: Maybe<Scalars['String']['output']>;
  status: CardAuthorizationStatus;
  transactionReference: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum CardAuthorizationStatus {
  Authorized = 'AUTHORIZED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

/** The Category model */
export type Category = {
  __typename?: 'Category';
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packages?: Maybe<Array<CategorySubscriptionPackage>>;
  priority: Scalars['Float']['output'];
  proTitle?: Maybe<Scalars['String']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  subCategoryIds?: Maybe<Array<Scalars['String']['output']>>;
  systemKey?: Maybe<CategorySystemKey>;
};


/** The Category model */
export type CategoryPackagesArgs = {
  includeCustomPackages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategorySubscriptionPackage = {
  __typename?: 'CategorySubscriptionPackage';
  baseInterval: SubscriptionInterval;
  basePrice: CategorySubscriptionPackagePrice;
  category: Category;
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isCustom?: Maybe<Scalars['Boolean']['output']>;
  isVisible: Scalars['Boolean']['output'];
  maximumCalls: Scalars['Float']['output'];
  minimumPlanPrice?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  otherIntervals?: Maybe<Array<SubscriptionInterval>>;
  plans: Array<CategorySubscriptionPackagePlan>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type CategorySubscriptionPackagePlan = {
  __typename?: 'CategorySubscriptionPackagePlan';
  costBreakdown: CategorySubscriptionPackagePlanCostBreakdown;
  createdAt: Scalars['DateTimeISO']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  interval: SubscriptionInterval;
  package: CategorySubscriptionPackage;
  price: CategorySubscriptionPackagePrice;
  providerCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type CategorySubscriptionPackagePlanCostBreakdownArgs = {
  discount?: InputMaybe<CategorySubscriptionPackagePlanCostBreakdownDiscountOptions>;
};

export type CategorySubscriptionPackagePlanCostBreakdown = {
  __typename?: 'CategorySubscriptionPackagePlanCostBreakdown';
  discount: Scalars['Float']['output'];
  subTotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  transactionFee?: Maybe<Scalars['Float']['output']>;
};

export type CategorySubscriptionPackagePlanCostBreakdownDiscountOptions = {
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  percentage: Scalars['Float']['input'];
};

export type CategorySubscriptionPackagePrice = {
  __typename?: 'CategorySubscriptionPackagePrice';
  breakdown: CategorySubscriptionPackagePriceBreakdown;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  package: CategorySubscriptionPackage;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type CategorySubscriptionPackagePriceBreakdown = {
  __typename?: 'CategorySubscriptionPackagePriceBreakdown';
  serviceCharge: Scalars['Float']['output'];
  vendorFee: Scalars['Float']['output'];
};

export enum CategorySystemKey {
  OrderFallback = 'ORDER_FALLBACK'
}

export type CensoredApplicant = {
  __typename?: 'CensoredApplicant';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  yearsOfExperience?: Maybe<Scalars['Float']['output']>;
};

export type Certificate = {
  __typename?: 'Certificate';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  issuedAt: Scalars['DateTimeISO']['output'];
  pro: Pro;
  tradeLevel: TradeLevel;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type Certification = {
  __typename?: 'Certification';
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  requirements: Array<CertificationRequirement>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type CertificationRequirement = {
  __typename?: 'CertificationRequirement';
  certification: Certification;
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lmsCourseId?: Maybe<Scalars['String']['output']>;
  lmsId?: Maybe<Scalars['String']['output']>;
  maximumScore: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  passingScore: Scalars['Float']['output'];
  type: CertificationRequirementType;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum CertificationRequirementType {
  Certification = 'CERTIFICATION',
  PracticalAssessment = 'PRACTICAL_ASSESSMENT',
  TheoreticalAssessment = 'THEORETICAL_ASSESSMENT'
}

/** The type of subscription change being requested */
export enum ChangeRequestType {
  Downgrade = 'DOWNGRADE',
  FreeToPaid = 'FREE_TO_PAID',
  Upgrade = 'UPGRADE'
}

export type CheckAssignmentPaymentStatusResponse = IResponse & {
  __typename?: 'CheckAssignmentPaymentStatusResponse';
  data: AssignmentPaymentStatus;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type CheckTradesmenAvailabilityByDate = {
  date: Scalars['DateTimeISO']['input'];
  tradesmanIds: Array<Scalars['String']['input']>;
};

export type Checklists = {
  __typename?: 'Checklists';
  startInspection?: Maybe<ProAssignmentChecklist>;
  startJob?: Maybe<ProAssignmentChecklist>;
};

export type Client = {
  __typename?: 'Client';
  addresses?: Maybe<Array<Address>>;
  authProviderId?: Maybe<Scalars['String']['output']>;
  billingAddressId?: Maybe<Scalars['String']['output']>;
  business?: Maybe<Business>;
  businessId?: Maybe<Scalars['String']['output']>;
  businessMetadata?: Maybe<BusinessMetadata>;
  clientProfile?: Maybe<ClientProfile>;
  createdAt: Scalars['DateTimeISO']['output'];
  defaultLocationId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  /** @deprecated Use userId instead */
  firebaseUserId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isBillableRecurrently: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  lastNotificationViewedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  leadSource: LeadSource;
  locations: Array<Location>;
  marketingCampaign?: Maybe<MarketingCampaign>;
  otherLeadSourceText?: Maybe<Scalars['String']['output']>;
  paymentProviderCode?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  referrer?: Maybe<Referrer>;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['String']['output'];
};

export type ClientDetails = {
  __typename?: 'ClientDetails';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type ClientEdge = Edge & {
  __typename?: 'ClientEdge';
  cursor: Scalars['String']['output'];
  node: Client;
};

export type ClientLocation = {
  area?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  landmark?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
};

export type ClientLocationData = {
  __typename?: 'ClientLocationData';
  defaultLocationId?: Maybe<Scalars['String']['output']>;
  locations: Array<Location>;
};

export type ClientOrderListItem = {
  __typename?: 'ClientOrderListItem';
  assigned: Scalars['String']['output'];
  categories: Array<Scalars['String']['output']>;
  categoryList: Array<Category>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  inspectionFeePaid: Scalars['Boolean']['output'];
  orderCode: Scalars['String']['output'];
  status: OrderStatus;
  taskCount: Scalars['Int']['output'];
  totalCost?: Maybe<Scalars['Float']['output']>;
};

export type ClientProfile = {
  __typename?: 'ClientProfile';
  createdAt: Scalars['DateTimeISO']['output'];
  homeowner?: Maybe<Homeowner>;
  id: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  ownerType: ClientProfileOwnerType;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum ClientProfileEnum {
  Business = 'BUSINESS',
  Homeowner = 'HOMEOWNER'
}

export enum ClientProfileOwnerType {
  Homeowner = 'HOMEOWNER',
  Organization = 'ORGANIZATION'
}

export type ClientRefundData = {
  accountNumber: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
};

export type ClientStatistics = {
  __typename?: 'ClientStatistics';
  all: Scalars['Float']['output'];
  new: Scalars['Float']['output'];
};

export enum CommunicationChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type CommunityAnnouncement = {
  __typename?: 'CommunityAnnouncement';
  communicationChannels: Array<CommunicationChannel>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: OrganizationUser;
  id: Scalars['String']['output'];
  jobOpportunity?: Maybe<CommunityJobOpportunity>;
  organization: Organization;
  publishedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status: CommunityAnnouncementStatus;
  targetSegments: Array<CommunitySegment>;
  title: Scalars['String']['output'];
  type: CommunityAnnouncementType;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum CommunityAnnouncementStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export enum CommunityAnnouncementType {
  GeneralUpdate = 'GENERAL_UPDATE',
  JobOpportunity = 'JOB_OPPORTUNITY',
  TrainingEvent = 'TRAINING_EVENT'
}

export type CommunityInviteMetadataResponse = {
  __typename?: 'CommunityInviteMetadataResponse';
  generatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  isValid: Scalars['Boolean']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
};

export type CommunityInviteOnboardingContextResponse = {
  __typename?: 'CommunityInviteOnboardingContextResponse';
  firstName?: Maybe<Scalars['String']['output']>;
  flowType: InviteJoinFlowType;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationReferralCode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
};

export enum CommunityInviteRedirectStrategy {
  Auth0 = 'AUTH0'
}

export type CommunityJobApplication = {
  __typename?: 'CommunityJobApplication';
  applicant: BaseJobApplicant;
  applicantSnapshot: ApplicantSnapshot;
  certifications: Array<JobApplicationCertification>;
  createdAt: Scalars['DateTimeISO']['output'];
  education: Array<JobApplicationEducation>;
  employmentHistory: Array<JobApplicationEmploymentHistoryItem>;
  enhancementRequested: Scalars['Boolean']['output'];
  hiringTerms?: Maybe<EmploymentHiringTerms>;
  id: Scalars['ID']['output'];
  jobOpportunity: CommunityJobOpportunity;
  organization: Organization;
  pro: Pro;
  projectHistory: Array<JobApplicationProjectHistoryItem>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  status: ApplicationStatus;
  trainingCommunityMember: TrainingCommunityMember;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type CommunityJobOpportunity = {
  __typename?: 'CommunityJobOpportunity';
  applicationDeadline?: Maybe<Scalars['DateTimeISO']['output']>;
  applications: Array<CommunityJobApplication>;
  canApply: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  duration?: Maybe<DurationDetails>;
  employmentType: EmploymentType;
  hasApplied: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  location: EmployerJobAdLocation;
  organization: Organization;
  salary?: Maybe<SalaryDetails>;
  tags: Array<JobAdTag>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type CommunityManagementDemoRequestDto = {
  communitySize: Scalars['String']['input'];
  communityTalent: Array<CommunityTalent>;
  digitalToolsUsed?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  majorChallenges: Scalars['String']['input'];
  organization: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  preferredDemoDate: Scalars['DateTimeISO']['input'];
  preferredDemoTime: Scalars['String']['input'];
  roleInOrganization: Scalars['String']['input'];
  typeOfCommunity: Scalars['String']['input'];
};

export type CommunityManagementSalesConversationRequestDto = {
  communitySize: Scalars['String']['input'];
  communityTalent: Array<CommunityTalent>;
  digitalToolsUsed?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  majorChallenges: Scalars['String']['input'];
  organization: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  preferredSalesConversationDate: Scalars['DateTimeISO']['input'];
  preferredSalesConversationTime: Scalars['String']['input'];
  roleInOrganization: Scalars['String']['input'];
  typeOfCommunity: Scalars['String']['input'];
};

export type CommunityManagerSubscription = {
  __typename?: 'CommunityManagerSubscription';
  activatedAt: Scalars['DateTimeISO']['output'];
  freeTrialExpiresAt: Scalars['DateTimeISO']['output'];
  paidAt?: Maybe<Scalars['DateTimeISO']['output']>;
  paymentMethod?: Maybe<OrganizationToolPaymentMethod>;
  paymentNotes?: Maybe<Scalars['String']['output']>;
  paymentReference?: Maybe<Scalars['String']['output']>;
  subscriptionExpiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CommunityManagerSubscriptionStatusResponse = {
  __typename?: 'CommunityManagerSubscriptionStatusResponse';
  daysRemaining: Scalars['Float']['output'];
  hasAccess: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  subscription?: Maybe<CommunityManagerSubscription>;
};

export type CommunitySegment = {
  __typename?: 'CommunitySegment';
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: OrganizationUser;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  members: Array<TrainingCommunityMember>;
  organization: Organization;
  status: CommunitySegmentStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum CommunitySegmentStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum CommunityTalent {
  Alumni = 'ALUMNI',
  CurrentStudents = 'CURRENT_STUDENTS',
  RecentGraduates = 'RECENT_GRADUATES'
}

export enum CompanySize {
  Enterprise = 'ENTERPRISE',
  ExtraLarge = 'EXTRA_LARGE',
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export type ConstructionProjectRequestDto = {
  contactInfo: ContactInfoInput;
  estimatedArtisanCount: Scalars['Float']['input'];
  includeMaterialsInCost?: InputMaybe<Scalars['Boolean']['input']>;
  intendedDuration: SimpleDuration;
  organizationInfo?: InputMaybe<OrganizationInfoInput>;
  otherTrade?: InputMaybe<Scalars['String']['input']>;
  projectLocation: Scalars['String']['input'];
  trades: Array<ConstructionTrade>;
  willProvideMaterials: Scalars['Boolean']['input'];
};

export enum ConstructionTrade {
  Carpentry = 'CARPENTRY',
  Electrical = 'ELECTRICAL',
  Masonry = 'MASONRY',
  Other = 'OTHER',
  Painting = 'PAINTING',
  Plumbing = 'PLUMBING',
  SolarInstallation = 'SOLAR_INSTALLATION',
  Welding = 'WELDING'
}

export type Contact = {
  __typename?: 'Contact';
  location: Location;
  notes?: Maybe<Scalars['String']['output']>;
};

export type ContactInfoInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type Contract = {
  __typename?: 'Contract';
  agreedRate: Scalars['Float']['output'];
  categoryId: Scalars['String']['output'];
  contractInterval: ContractInterval;
  contractLength: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  endDate?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  nonBillableDates?: Maybe<Array<Scalars['String']['output']>>;
  nonWorkingDays?: Maybe<Array<Scalars['String']['output']>>;
  overtimeDates?: Maybe<Array<Scalars['DateTimeISO']['output']>>;
  payments: Array<ContractPayment>;
  pro?: Maybe<Tradesman>;
  proLevel: Scalars['Float']['output'];
  recruitment: ContractRecruitment;
  requestedStartDate: Scalars['DateTimeISO']['output'];
  startDate?: Maybe<Scalars['DateTimeISO']['output']>;
  status: ContractStatus;
  terminatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ContractConflict = {
  __typename?: 'ContractConflict';
  contract: Contract;
  type: ScheduleConflictType;
};

export type ContractDetails = {
  __typename?: 'ContractDetails';
  interval: ContractInterval;
  length: Scalars['Float']['output'];
};

export type ContractDetailsInput = {
  interval: ContractInterval;
  length: Scalars['Float']['input'];
};

/** The contract interval */
export enum ContractInterval {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS'
}

export type ContractPayment = {
  __typename?: 'ContractPayment';
  for: Scalars['String']['output'];
  invoice?: Maybe<Invoice>;
};

export type ContractPayout = {
  __typename?: 'ContractPayout';
  breakdown: ContractPayoutBreakdown;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  override?: Maybe<ContractPayoutOverride>;
  reimbursements: Array<ContractPayoutReimbursement>;
  transfer: Transfer;
  updatedAt: Scalars['DateTimeISO']['output'];
  worksheet: ContractWorksheet;
};

export type ContractPayoutBreakdown = {
  __typename?: 'ContractPayoutBreakdown';
  gross: Scalars['Float']['output'];
  net: Scalars['Float']['output'];
  tax?: Maybe<Scalars['Float']['output']>;
};

export type ContractPayoutOverride = {
  __typename?: 'ContractPayoutOverride';
  amount?: Maybe<Scalars['Float']['output']>;
  reason: Scalars['String']['output'];
  tax?: Maybe<Scalars['Float']['output']>;
};

export type ContractPayoutOverrideInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  reason: Scalars['String']['input'];
  tax?: InputMaybe<Scalars['Float']['input']>;
};

export type ContractPayoutReimbursement = {
  __typename?: 'ContractPayoutReimbursement';
  createdAt: Scalars['DateTimeISO']['output'];
  excludeTax?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  invoice: Invoice;
  payout: ContractPayout;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ContractQuotation = {
  __typename?: 'ContractQuotation';
  contractRecruitmentId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  items: Array<ContractQuotationItem>;
  status: QuotationStatus;
};

export type ContractQuotationItem = {
  __typename?: 'ContractQuotationItem';
  categoryId: Scalars['String']['output'];
  contractDetails: ContractDetails;
  isActive: Scalars['Boolean']['output'];
  level: Scalars['Float']['output'];
  proCount: Scalars['Float']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  requestedStartDate: Scalars['DateTimeISO']['output'];
  workdays: Scalars['Float']['output'];
};

export type ContractQuotationItemInput = {
  categoryId: Scalars['String']['input'];
  contractDetails: ContractDetailsInput;
  isActive: Scalars['Boolean']['input'];
  level: Scalars['Float']['input'];
  proCount: Scalars['Float']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  requestedStartDate: Scalars['DateTimeISO']['input'];
  workdays: Scalars['Float']['input'];
};

export type ContractRecruitment = {
  __typename?: 'ContractRecruitment';
  activeQuotation?: Maybe<ContractQuotation>;
  billingAddress?: Maybe<Location>;
  client: Client;
  clientProfile: ClientProfileEnum;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  jobs: Array<RecruitmentJob>;
  location: LocationData;
  paymentSchedule: PaymentSchedule;
  paymentSettings?: Maybe<RecruitmentPaymentSettings>;
  proRecruitmentContracts: Array<ProRecruitmentContract>;
  quotations?: Maybe<Array<ContractQuotation>>;
  recruitmentDiscountValue?: Maybe<Scalars['Float']['output']>;
  recruitmentType: RecruitmentType;
  requests: Array<RecruitmentRequest>;
  status: RecruitmentRequestStatus;
};

export enum ContractStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING'
}

export type ContractWorksheet = {
  __typename?: 'ContractWorksheet';
  contract: ProRecruitmentContract;
  expectedUnitAmount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  payout?: Maybe<ContractPayout>;
  payroll: RecruitmentPayroll;
  unitAmount: Scalars['Int']['output'];
};

export type CreateAdminInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  roles: Array<Role>;
};

export type CreateBusinessClientInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCanadaBasicApplicationInput = {
  canCoverMinimumDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  citizenship: CanadaBasicApplicationCitizenship;
  contributionAmountInCAD?: InputMaybe<Scalars['Float']['input']>;
  countryOfStudy: Scalars['String']['input'];
  educationLevel: CanadaBasicApplicationEducationLevel;
  graduationYear: Scalars['Float']['input'];
  hasInternationalPassport: Scalars['Boolean']['input'];
  intendedCourseOfStudy: CanadaBasicApplicationCourseOfStudy;
  intendedProficiencyTestDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  intendedStudyResumptionDate: Scalars['DateTimeISO']['input'];
  needsLoan: Scalars['Boolean']['input'];
  passportExpiryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  passportIssueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  takenEnglishProficiencyTest: Scalars['Boolean']['input'];
  testCompletionScore?: InputMaybe<Scalars['Float']['input']>;
  testCompletionYear?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateCertificationInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  requirements: Array<CreateCertificationRequirementInput>;
};

export type CreateCertificationRequirementInput = {
  description: Scalars['String']['input'];
  lmsCourseExternalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  passingScore: Scalars['Float']['input'];
  type: CertificationRequirementType;
};

export type CreateClientInput = {
  businessMetadata?: InputMaybe<BusinessMetadataInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isBusinessClient?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  leadSource?: InputMaybe<LeadSource>;
  location?: InputMaybe<ClientLocation>;
  otherLeadSourceText?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClientResponse = {
  __typename?: 'CreateClientResponse';
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type CreateCommunityAnnouncementInput = {
  communicationChannels: Array<CommunicationChannel>;
  content: Scalars['String']['input'];
  jobOpportunityId?: InputMaybe<Scalars['String']['input']>;
  targetSegmentIds: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: CommunityAnnouncementType;
};

export type CreateCommunityJobApplicationDto = {
  certificationItems?: Array<CreateJobApplicationCertificationDto>;
  educationItems?: Array<CreateJobApplicationEducationDto>;
  employmentHistoryItems?: Array<CreateJobApplicationEmploymentHistoryDto>;
  jobOpportunityId: Scalars['String']['input'];
  projectHistoryItems?: Array<CreateJobApplicationProjectHistoryDto>;
};

export type CreateCommunityJobOpportunityInput = {
  applicationDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  duration?: InputMaybe<DurationDetailsInput>;
  employmentType: EmploymentType;
  location: JobLocationInput;
  salary?: InputMaybe<SalaryDetailsInput>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type CreateCommunityManagerPaymentRequestArgs = {
  billingFrequency: Scalars['String']['input'];
  message: Scalars['String']['input'];
  preferredDate?: InputMaybe<Scalars['String']['input']>;
  preferredTime?: InputMaybe<Scalars['String']['input']>;
  requestType: Scalars['String']['input'];
};

export type CreateCommunitySegmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  memberIds: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateContactsInput = {
  guarantors: Array<GuarantorInput>;
  referees: Array<RefereeInput>;
};

export type CreateContractRecruitmentInput = {
  businessId?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  clientProfile: ClientProfileEnum;
  location: LocationDataInput;
  paymentSchedule: PaymentSchedule;
  recruitmentType: RecruitmentType;
  requests: Array<RecruitmentRequestInput>;
};

export type CreateHomeownerInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leadSource: LeadSource;
  otherLeadSourceText?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIdentityVerificationDto = {
  dateOfBirth: Scalars['DateTimeISO']['input'];
  identificationNumber: Scalars['String']['input'];
  proId: Scalars['String']['input'];
  type: MeansOfIdentification;
};

export type CreateInviteInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  level?: InputMaybe<Scalars['Float']['input']>;
  userType: UserType;
};

export type CreateJobApplicationCertificationDto = {
  issuedAt: Scalars['DateTimeISO']['input'];
  issuedBy: Scalars['String']['input'];
  issuerCertificationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateJobApplicationDto = {
  ad: Scalars['String']['input'];
  certificationItems: Array<CreateJobApplicationCertificationDto>;
  educationItems: Array<CreateJobApplicationEducationDto>;
  email: Scalars['String']['input'];
  employmentHistoryItems: Array<CreateJobApplicationEmploymentHistoryDto>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  projectHistoryItems: Array<CreateJobApplicationProjectHistoryDto>;
  yearsOfExperience: Scalars['Float']['input'];
};

export type CreateJobApplicationEducationDto = {
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  qualification: EducationLevel;
  schoolName: Scalars['String']['input'];
};

export type CreateJobApplicationEmploymentHistoryDto = {
  companyName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  jobTitle: Scalars['String']['input'];
  media?: InputMaybe<Array<JobApplicationMediaItemInput>>;
  startedAt: Scalars['DateTimeISO']['input'];
};

export type CreateJobApplicationProjectHistoryDto = {
  description: Scalars['String']['input'];
  endedAt: Scalars['DateTimeISO']['input'];
  media?: InputMaybe<Array<JobApplicationMediaItemInput>>;
  name: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  videos?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateMarketplaceRequestInput = {
  jobs: Array<CreateMarketplaceRequestJobInput>;
  location: LocationDataInput;
};

export type CreateMarketplaceRequestJobInput = {
  /** A description of the job to help the pros make a decision. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The number of pros required for this job. */
  proCount: Scalars['Float']['input'];
  schedule: CreateMarketplaceRequestJobScheduleInput;
  /** The trade id. This can be gotten from the trades query. Only trades that are enabled for the marketplace can be used. */
  tradeId: Scalars['String']['input'];
};

export type CreateMarketplaceRequestJobScheduleInput = {
  end: Scalars['DateTimeISO']['input'];
  /** An array of dates the pro(s) are not required to work within the start and end dates. To ignore all occurences of a weekday, see the workDays field. */
  offDates?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  start: Scalars['DateTimeISO']['input'];
  /** An array of days in week the pro(s) are required to work. For example: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'] means the pros are not needed weekends. */
  workDays: Array<Scalars['String']['input']>;
};

export type CreateMaterialsInvoiceInput = {
  allowedPaymentProviders: Array<Scalars['String']['input']>;
  assignmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  commissionPercentage?: InputMaybe<Scalars['Float']['input']>;
  customMaterialCommissionCap?: InputMaybe<Scalars['Float']['input']>;
  jobUpdates?: InputMaybe<Array<JobInvoiceDetailsItem>>;
  quotationId?: InputMaybe<Scalars['String']['input']>;
  splits?: InputMaybe<Array<Scalars['Float']['input']>>;
  vatApplicationScope?: InputMaybe<VatApplicationScope>;
};

export type CreateMyOrganizationClientProfileInput = {
  billingAddress: OrganizationClientProfileBillingAddressInput;
  billingName: Scalars['String']['input'];
  contactOrganizationUserId: Scalars['String']['input'];
};

export type CreateOrderHandlingQuotationItem = {
  jobId: Scalars['String']['input'];
  labor?: InputMaybe<Scalars['Float']['input']>;
  materials?: InputMaybe<Array<CreateOrderHandlingQuotationItemMaterial>>;
};

export type CreateOrderHandlingQuotationItemMaterial = {
  name: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  unitPrice: Scalars['Float']['input'];
};

export type CreateOrganizationDetailsInput = {
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationFacilityInput = {
  address: OrganizationFacilityAddressInput;
  name: Scalars['String']['input'];
};

export type CreateOrganizationOneTimeRequestInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facilityContactId: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
  otherCategoryText?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTimeISO']['input'];
};

export type CreateOrganizationPlanSubscriptionChangeRequestResponse = {
  __typename?: 'CreateOrganizationPlanSubscriptionChangeRequestResponse';
  accessCode: Scalars['String']['output'];
  changeRequestId: Scalars['String']['output'];
  checkoutUrl: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
};

export type CreateOrganizationTalentPoolDto = {
  communityMemberIds: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateOrganizationUserInviteOutput = {
  __typename?: 'CreateOrganizationUserInviteOutput';
  expiresAt: Scalars['DateTimeISO']['output'];
  inviteUrl: Scalars['String']['output'];
};

export type CreateProFromInviteInput = {
  accountNumber: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  location?: InputMaybe<ProLocation>;
  phoneNumber: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type CreateProRecruitmentContractInput = {
  paymentAmount: Scalars['Int']['input'];
  paymentMethod: PaymentMethod;
  proId: Scalars['String']['input'];
  recruitmentJobId: Scalars['String']['input'];
  startDate: Scalars['DateTimeISO']['input'];
  unitMeasured: Scalars['String']['input'];
};

export type CreateProductFeedbackDto = {
  feedback: Scalars['String']['input'];
  product: LaborHackProduct;
};

export type CreateRefundRequestInput = {
  clientRefundData?: InputMaybe<ClientRefundData>;
  jobsToRefund: Array<JobToRefund>;
  orderId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  tradesmanPointChanges: Array<PointChange>;
};

export type CreateReviewInput = {
  appearance: Scalars['Float']['input'];
  assignmentId: Scalars['String']['input'];
  behavior: Scalars['Float']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
  postServiceCleanUp: Scalars['Float']['input'];
  properToolUsage: Scalars['Float']['input'];
  punctuality: Scalars['Float']['input'];
};

export type CreateThirdPartyInput = {
  adminEmail: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  representedOrganizationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateThirdPartyIntegratorResponse = {
  __typename?: 'CreateThirdPartyIntegratorResponse';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  integrator: ThirdPartyIntegrator;
};

export type CreateTradeInput = {
  categoryId: Scalars['String']['input'];
  certificationId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateTradesmanInput = {
  accountNumber: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
  categoryId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  level: Scalars['Int']['input'];
  location?: InputMaybe<TradesmanLocation>;
  phoneNumber: Scalars['String']['input'];
  taxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTrainingCommunityProgramInput = {
  enableLogBookReporting: Scalars['Boolean']['input'];
  endDate: Scalars['String']['input'];
  invitedSupervisorEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  logBookReportingFrequency?: InputMaybe<LogBookReportingFrequency>;
  name: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  supervisorIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateWaitlistedBusinessInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CustomLocation = {
  area?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  landmark?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomSubscriptionRequestAccountType {
  Artisan = 'Artisan',
  Business = 'Business',
  Homeowner = 'Homeowner'
}

export type DefaultResponse = {
  __typename?: 'DefaultResponse';
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type DigestRecipientEntry = {
  __typename?: 'DigestRecipientEntry';
  email: Scalars['String']['output'];
  jobAdCount: Scalars['Int']['output'];
  jobAdTitles: Array<Scalars['String']['output']>;
  recipientType: Scalars['String']['output'];
};

export type DirectDebitAuthorization = {
  __typename?: 'DirectDebitAuthorization';
  accessCode: Scalars['String']['output'];
  bank?: Maybe<Scalars['String']['output']>;
  checkoutUrl: Scalars['String']['output'];
  client: Client;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: DirectDebitAuthorizationStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** The status of a direct debit authorization */
export enum DirectDebitAuthorizationStatus {
  Active = 'ACTIVE',
  ClientApproved = 'CLIENT_APPROVED',
  Initialized = 'INITIALIZED'
}

export type DiscardedJobApplication = {
  __typename?: 'DiscardedJobApplication';
  ad: EmployerJobAd;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  pro: Pro;
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Information about a scheduled downgrade */
export type DowngradeInfo = {
  __typename?: 'DowngradeInfo';
  /** When the downgrade will take effect */
  effectiveDate: Scalars['DateTimeISO']['output'];
  /** Whether a card-less trial exists (downgrades not supported for card-less trials) */
  isCardlessTrial?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is a trial downgrade (immediate payment required) */
  isTrialDowngrade: Scalars['Boolean']['output'];
};

/** The status of a plan downgrade intent */
export enum DowngradeIntentStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  PendingCancellation = 'PENDING_CANCELLATION',
  Scheduled = 'SCHEDULED'
}

export type DurationDetails = {
  __typename?: 'DurationDetails';
  type: DurationType;
  value: Scalars['Float']['output'];
};

export type DurationDetailsInput = {
  type: DurationType;
  value: Scalars['Float']['input'];
};

export enum DurationType {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS',
  Years = 'YEARS'
}

export type Edge = {
  cursor: Scalars['String']['output'];
};

export type Edges = {
  pageInfo: PageInfo;
};

export type EditAdminInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type EditClientInput = {
  businessMetadata?: InputMaybe<BusinessMetadataInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastNotificationViewedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type EditCustomTaskInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EditSubCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subCategoryId?: InputMaybe<Scalars['String']['input']>;
};

export type EditTaskInput = {
  description: Scalars['String']['input'];
  estimatedCost: Scalars['Float']['input'];
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type EditTradesmanInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  taxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum EducationLevel {
  Bachelors = 'BACHELORS',
  Doctorate = 'DOCTORATE',
  Hnd = 'HND',
  Jssce = 'JSSCE',
  Kcse = 'KCSE',
  Masters = 'MASTERS',
  Nabteb = 'NABTEB',
  Ond = 'OND',
  Ssce = 'SSCE'
}

export type EmployerAdmin = {
  __typename?: 'EmployerAdmin';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  organizationUser: OrganizationUser;
  userId: Scalars['String']['output'];
};

export type EmployerJobAd = {
  __typename?: 'EmployerJobAd';
  adminDisabledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  applicationDeadline?: Maybe<Scalars['DateTimeISO']['output']>;
  applications: Array<EmployerJobApplication>;
  canApply: Scalars['Boolean']['output'];
  categories: Array<Category>;
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  duration?: Maybe<DurationDetails>;
  employmentType: EmploymentType;
  hasApplied: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  location: EmployerJobAdLocation;
  /** @deprecated We no longer support this field */
  numberOfCandidates?: Maybe<Scalars['Int']['output']>;
  organization: Organization;
  outsourced: Scalars['Boolean']['output'];
  postedBy: EmployerAdmin;
  principal?: Maybe<EmployerJobAdPrincipal>;
  reach?: Maybe<ReachDetails>;
  /** @deprecated Use salaryDetails instead */
  salary?: Maybe<Scalars['Float']['output']>;
  salaryDetails?: Maybe<SalaryDetails>;
  shortlistFinalizedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  shortlistedApplications: Array<EmployerJobApplication>;
  status: EmployerJobAdStatus;
  stoppedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  tags: Array<JobAdTag>;
  thirdParty?: Maybe<EmployerJobAdThirdParty>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  visibility: JobVisibility;
};

export type EmployerJobAdLocation = {
  __typename?: 'EmployerJobAdLocation';
  area: Scalars['String']['output'];
  country: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type EmployerJobAdPrincipal = {
  __typename?: 'EmployerJobAdPrincipal';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
};

export enum EmployerJobAdStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED',
  Stopped = 'STOPPED'
}

export type EmployerJobAdThirdParty = {
  __typename?: 'EmployerJobAdThirdParty';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownerOrganization: Organization;
  representedOrganization: Organization;
};

export enum EmployerJobAdsDateFilter {
  AllTime = 'ALL_TIME',
  LastMonth = 'LAST_MONTH',
  LastWeek = 'LAST_WEEK',
  Yesterday = 'YESTERDAY'
}

export type EmployerJobApplication = {
  __typename?: 'EmployerJobApplication';
  ad: EmployerJobAd;
  applicant: BaseJobApplicant;
  applicantSnapshot: ApplicantSnapshot;
  certifications: Array<JobApplicationCertification>;
  createdAt: Scalars['DateTimeISO']['output'];
  education: Array<JobApplicationEducation>;
  employmentHistory: Array<JobApplicationEmploymentHistoryItem>;
  enhancementRequested: Scalars['Boolean']['output'];
  hiringTerms?: Maybe<EmploymentHiringTerms>;
  id: Scalars['String']['output'];
  isFormBased?: Maybe<Scalars['Boolean']['output']>;
  isShortlisted: Scalars['Boolean']['output'];
  offers: Array<EmployerJobApplicationOffer>;
  organization: Organization;
  pro?: Maybe<Pro>;
  projectHistory: Array<JobApplicationProjectHistoryItem>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  status: ApplicationStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type EmployerJobApplicationOffer = {
  __typename?: 'EmployerJobApplicationOffer';
  acceptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  application: EmployerJobApplication;
  cancelledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  declinedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  declinedReason?: Maybe<Scalars['String']['output']>;
  employmentType: EmploymentType;
  id: Scalars['String']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  salary: Scalars['Float']['output'];
  startDate: Scalars['DateTimeISO']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum EmploymentContractUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type EmploymentHiringTerms = {
  __typename?: 'EmploymentHiringTerms';
  contractLength?: Maybe<Scalars['Int']['output']>;
  contractUnit?: Maybe<EmploymentContractUnit>;
  employmentType: EmploymentType;
  salary?: Maybe<Scalars['Float']['output']>;
  salaryUnit?: Maybe<EmploymentSalaryUnit>;
  startDate?: Maybe<Scalars['DateTimeISO']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EmploymentHiringTermsInput = {
  contractLength?: InputMaybe<Scalars['Int']['input']>;
  contractUnit?: InputMaybe<EmploymentContractUnit>;
  employmentType: EmploymentType;
  salary?: InputMaybe<Scalars['Float']['input']>;
  salaryUnit?: InputMaybe<EmploymentSalaryUnit>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum EmploymentSalaryUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  LumpSum = 'LUMP_SUM',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export enum EmploymentStatus {
  Employed = 'EMPLOYED',
  SelfEmployed = 'SELF_EMPLOYED',
  Student = 'STUDENT',
  Unemployed = 'UNEMPLOYED'
}

export enum EmploymentType {
  Contract = 'CONTRACT',
  FullTime = 'FULL_TIME'
}

export type EnableOrganizationApiAccessResponse = {
  __typename?: 'EnableOrganizationApiAccessResponse';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export enum EventTypes {
  AdminActivatedEmployerJobAd = 'ADMIN_ACTIVATED_EMPLOYER_JOB_AD',
  AdminChangedJobAdApplicationDeadline = 'ADMIN_CHANGED_JOB_AD_APPLICATION_DEADLINE',
  AdminDisabledEmployerJobAd = 'ADMIN_DISABLED_EMPLOYER_JOB_AD',
  AdminRejectedEmployerJobAd = 'ADMIN_REJECTED_EMPLOYER_JOB_AD',
  ArtisanAssistBankDetailsSubmitted = 'ARTISAN_ASSIST_BANK_DETAILS_SUBMITTED',
  ArtisanAssistBusinessProfileCreated = 'ARTISAN_ASSIST_BUSINESS_PROFILE_CREATED',
  ArtisanAssistClientUpdated = 'ARTISAN_ASSIST_CLIENT_UPDATED',
  ArtisanAssistInvoiceCancelled = 'ARTISAN_ASSIST_INVOICE_CANCELLED',
  ArtisanAssistInvoiceClientDetailsSet = 'ARTISAN_ASSIST_INVOICE_CLIENT_DETAILS_SET',
  ArtisanAssistInvoiceCreated = 'ARTISAN_ASSIST_INVOICE_CREATED',
  ArtisanAssistInvoiceDraftStarted = 'ARTISAN_ASSIST_INVOICE_DRAFT_STARTED',
  ArtisanAssistInvoiceJobDescriptionSet = 'ARTISAN_ASSIST_INVOICE_JOB_DESCRIPTION_SET',
  ArtisanAssistInvoiceLaborFeeSet = 'ARTISAN_ASSIST_INVOICE_LABOR_FEE_SET',
  ArtisanAssistInvoiceMaterialsSet = 'ARTISAN_ASSIST_INVOICE_MATERIALS_SET',
  ArtisanAssistInvoicePaymentReceived = 'ARTISAN_ASSIST_INVOICE_PAYMENT_RECEIVED',
  ArtisanAssistProAccountCreated = 'ARTISAN_ASSIST_PRO_ACCOUNT_CREATED',
  ArtisanAssistUserCreated = 'ARTISAN_ASSIST_USER_CREATED',
  CommunityAnnouncementCreated = 'COMMUNITY_ANNOUNCEMENT_CREATED',
  CommunityAnnouncementPublished = 'COMMUNITY_ANNOUNCEMENT_PUBLISHED',
  CommunityJobApplicationHired = 'COMMUNITY_JOB_APPLICATION_HIRED',
  CommunityJobApplicationRejected = 'COMMUNITY_JOB_APPLICATION_REJECTED',
  CommunityJobApplicationSubmitted = 'COMMUNITY_JOB_APPLICATION_SUBMITTED',
  CommunityJobOpportunityCreated = 'COMMUNITY_JOB_OPPORTUNITY_CREATED',
  CommunityManagementDemoRequestTaskCreated = 'COMMUNITY_MANAGEMENT_DEMO_REQUEST_TASK_CREATED',
  CommunityManagementSalesConversationTaskCreated = 'COMMUNITY_MANAGEMENT_SALES_CONVERSATION_TASK_CREATED',
  CommunityManagerPaymentReceived = 'COMMUNITY_MANAGER_PAYMENT_RECEIVED',
  CommunityManagerPaymentRequestCreated = 'COMMUNITY_MANAGER_PAYMENT_REQUEST_CREATED',
  CommunitySegmentCreated = 'COMMUNITY_SEGMENT_CREATED',
  CustomSubscriptionRequestCreated = 'CUSTOM_SUBSCRIPTION_REQUEST_CREATED',
  CvPrefillDataConfirmed = 'CV_PREFILL_DATA_CONFIRMED',
  CvPrefillExtractionFailed = 'CV_PREFILL_EXTRACTION_FAILED',
  CvPrefillExtractionSucceeded = 'CV_PREFILL_EXTRACTION_SUCCEEDED',
  CvPrefillPhotosAdded = 'CV_PREFILL_PHOTOS_ADDED',
  EligibleForStudyWorkOpportunity = 'ELIGIBLE_FOR_STUDY_WORK_OPPORTUNITY',
  EmployerJobAdCreated = 'EMPLOYER_JOB_AD_CREATED',
  EmployerJobAdResumed = 'EMPLOYER_JOB_AD_RESUMED',
  EmployerJobAdShortlistFinalized = 'EMPLOYER_JOB_AD_SHORTLIST_FINALIZED',
  EmployerJobAdShortlistNotified = 'EMPLOYER_JOB_AD_SHORTLIST_NOTIFIED',
  EmployerJobAdStopped = 'EMPLOYER_JOB_AD_STOPPED',
  EmployerJobAdStoppedForPlanAlignment = 'EMPLOYER_JOB_AD_STOPPED_FOR_PLAN_ALIGNMENT',
  EmployerJobApplicationEnhancementRequested = 'EMPLOYER_JOB_APPLICATION_ENHANCEMENT_REQUESTED',
  EmployerJobApplicationHired = 'EMPLOYER_JOB_APPLICATION_HIRED',
  EmployerJobApplicationRejected = 'EMPLOYER_JOB_APPLICATION_REJECTED',
  EmployerJobApplicationRemovedFromShortlist = 'EMPLOYER_JOB_APPLICATION_REMOVED_FROM_SHORTLIST',
  EmployerJobApplicationShortlisted = 'EMPLOYER_JOB_APPLICATION_SHORTLISTED',
  EmployerJobApplicationShortlistFinalized = 'EMPLOYER_JOB_APPLICATION_SHORTLIST_FINALIZED',
  EmployerJobApplicationStarted = 'EMPLOYER_JOB_APPLICATION_STARTED',
  EmployerJobApplicationSubmitted = 'EMPLOYER_JOB_APPLICATION_SUBMITTED',
  EnquiryCreated = 'ENQUIRY_CREATED',
  EnterprisePlanActivatedByAdmin = 'ENTERPRISE_PLAN_ACTIVATED_BY_ADMIN',
  ExternalAssessmentCreated = 'EXTERNAL_ASSESSMENT_CREATED',
  FreePlanCreated = 'FREE_PLAN_CREATED',
  FullTimeProSalaryUpdated = 'FULL_TIME_PRO_SALARY_UPDATED',
  GuestJobApplicantProRegistration = 'GUEST_JOB_APPLICANT_PRO_REGISTRATION',
  IdentitySubmissionDeclined = 'IDENTITY_SUBMISSION_DECLINED',
  IdentitySubmissionVerified = 'IDENTITY_SUBMISSION_VERIFIED',
  IneligibleForStudyWorkOpportunity = 'INELIGIBLE_FOR_STUDY_WORK_OPPORTUNITY',
  InterviewRequirementCancelled = 'INTERVIEW_REQUIREMENT_CANCELLED',
  InvoiceDiscountApplied = 'INVOICE_DISCOUNT_APPLIED',
  InvoiceDiscountUsed = 'INVOICE_DISCOUNT_USED',
  JobAdNotificationPreferencesCreated = 'JOB_AD_NOTIFICATION_PREFERENCES_CREATED',
  JobAdNotificationPreferencesUpdated = 'JOB_AD_NOTIFICATION_PREFERENCES_UPDATED',
  JobApplicationCvPrefillExtractionFailed = 'JOB_APPLICATION_CV_PREFILL_EXTRACTION_FAILED',
  JobApplicationCvPrefillExtractionSucceeded = 'JOB_APPLICATION_CV_PREFILL_EXTRACTION_SUCCEEDED',
  JobApplicationReminderEmailSent = 'JOB_APPLICATION_REMINDER_EMAIL_SENT',
  LaborpassCompleted = 'LABORPASS_COMPLETED',
  LaborFeePaid = 'LABOR_FEE_PAID',
  LlmTokenUsage = 'LLM_TOKEN_USAGE',
  OfflinePaymentConfirmed = 'OFFLINE_PAYMENT_CONFIRMED',
  OfflineTransferConfirmed = 'OFFLINE_TRANSFER_CONFIRMED',
  OnboardingCompleted = 'ONBOARDING_COMPLETED',
  OrganizationUserDisabled = 'ORGANIZATION_USER_DISABLED',
  OrganizationUserDisabledForPlanAlignment = 'ORGANIZATION_USER_DISABLED_FOR_PLAN_ALIGNMENT',
  OrganizationUserEnabled = 'ORGANIZATION_USER_ENABLED',
  OrganizationUserInviteCancelled = 'ORGANIZATION_USER_INVITE_CANCELLED',
  OrganizationUserRoleChanged = 'ORGANIZATION_USER_ROLE_CHANGED',
  OutOfLagosHomeownerRequestAttempt = 'OUT_OF_LAGOS_HOMEOWNER_REQUEST_ATTEMPT',
  ProjectOutsourcingTaskCreated = 'PROJECT_OUTSOURCING_TASK_CREATED',
  ProAcceptedMarketplaceJob = 'PRO_ACCEPTED_MARKETPLACE_JOB',
  ProAcceptedRecruitmentJob = 'PRO_ACCEPTED_RECRUITMENT_JOB',
  ProAccountMerged = 'PRO_ACCOUNT_MERGED',
  ProBackgroundCheckSubmitted = 'PRO_BACKGROUND_CHECK_SUBMITTED',
  ProBankDetailsSubmitted = 'PRO_BANK_DETAILS_SUBMITTED',
  ProCompletedAssessment = 'PRO_COMPLETED_ASSESSMENT',
  ProDeclinedMarketplaceJob = 'PRO_DECLINED_MARKETPLACE_JOB',
  ProIdentityVerificationReminderEmailSent = 'PRO_IDENTITY_VERIFICATION_REMINDER_EMAIL_SENT',
  ProNotifiedOfJobAdShortlisting = 'PRO_NOTIFIED_OF_JOB_AD_SHORTLISTING',
  ProPortfolioReminderEmailSent = 'PRO_PORTFOLIO_REMINDER_EMAIL_SENT',
  ProShortlistedForMarketplaceJob = 'PRO_SHORTLISTED_FOR_MARKETPLACE_JOB',
  ProShortlistedForRecruitmentJob = 'PRO_SHORTLISTED_FOR_RECRUITMENT_JOB',
  ProTrackAdded = 'PRO_TRACK_ADDED',
  ProTrialStarted = 'PRO_TRIAL_STARTED',
  ProWebsiteCertificationAdded = 'PRO_WEBSITE_CERTIFICATION_ADDED',
  ProWebsiteCertificationRemoved = 'PRO_WEBSITE_CERTIFICATION_REMOVED',
  ProWebsiteCertificationUpdated = 'PRO_WEBSITE_CERTIFICATION_UPDATED',
  ProWebsiteEducationAdded = 'PRO_WEBSITE_EDUCATION_ADDED',
  ProWebsiteEducationRemoved = 'PRO_WEBSITE_EDUCATION_REMOVED',
  ProWebsiteEducationUpdated = 'PRO_WEBSITE_EDUCATION_UPDATED',
  ProWebsiteEmploymentHistoryAdded = 'PRO_WEBSITE_EMPLOYMENT_HISTORY_ADDED',
  ProWebsiteEmploymentHistoryRemoved = 'PRO_WEBSITE_EMPLOYMENT_HISTORY_REMOVED',
  ProWebsiteEmploymentHistoryUpdated = 'PRO_WEBSITE_EMPLOYMENT_HISTORY_UPDATED',
  ProWebsiteProfileGenerated = 'PRO_WEBSITE_PROFILE_GENERATED',
  ProWebsiteWorkExperienceAdded = 'PRO_WEBSITE_WORK_EXPERIENCE_ADDED',
  ProWebsiteWorkExperienceRemoved = 'PRO_WEBSITE_WORK_EXPERIENCE_REMOVED',
  ProWebsiteWorkExperienceUpdated = 'PRO_WEBSITE_WORK_EXPERIENCE_UPDATED',
  RecruitmentConsultationTaskCreated = 'RECRUITMENT_CONSULTATION_TASK_CREATED',
  RecruitToolSalesConversationTaskCreated = 'RECRUIT_TOOL_SALES_CONVERSATION_TASK_CREATED',
  RelevantJobAdNotificationEmailSent = 'RELEVANT_JOB_AD_NOTIFICATION_EMAIL_SENT',
  RequirementAttemptPaid = 'REQUIREMENT_ATTEMPT_PAID',
  RequirementCompleted = 'REQUIREMENT_COMPLETED',
  RequirementScheduled = 'REQUIREMENT_SCHEDULED',
  RequirementStarted = 'REQUIREMENT_STARTED',
  RequirementWaived = 'REQUIREMENT_WAIVED',
  StartedFixMeRegistration = 'STARTED_FIX_ME_REGISTRATION',
  StudyWorkAbroadPreferredCourseUpdated = 'STUDY_WORK_ABROAD_PREFERRED_COURSE_UPDATED',
  SubscriptionCancelled = 'SUBSCRIPTION_CANCELLED',
  TalentPoolCandidateHired = 'TALENT_POOL_CANDIDATE_HIRED',
  TalentPoolCandidateInvitedToInterview = 'TALENT_POOL_CANDIDATE_INVITED_TO_INTERVIEW',
  TalentPoolCandidateViewed = 'TALENT_POOL_CANDIDATE_VIEWED',
  TalentPoolInstanceViewed = 'TALENT_POOL_INSTANCE_VIEWED',
  TalentPoolOrganizationUserInviteCreated = 'TALENT_POOL_ORGANIZATION_USER_INVITE_CREATED',
  TalentPoolShared = 'TALENT_POOL_SHARED',
  TradeLevelCompleted = 'TRADE_LEVEL_COMPLETED',
  TradeLevelUnlocked = 'TRADE_LEVEL_UNLOCKED',
  TradeStarted = 'TRADE_STARTED',
  WhatsappProEmailAuthSet = 'WHATSAPP_PRO_EMAIL_AUTH_SET',
  WrongReferralCodeUsed = 'WRONG_REFERRAL_CODE_USED'
}

export enum ExternalProTradeRequirementStatus {
  AwaitingResult = 'AWAITING_RESULT',
  AwaitingUpload = 'AWAITING_UPLOAD',
  Failed = 'FAILED',
  NotPaid = 'NOT_PAID',
  Passed = 'PASSED'
}

export type FacilityMaintenanceRequestDto = {
  contactInfo: ContactInfoInput;
  facilityLocation: Scalars['String']['input'];
  maintenanceFrequency?: InputMaybe<MaintenanceFrequency>;
  organizationInfo?: InputMaybe<OrganizationInfoInput>;
  otherService?: InputMaybe<Scalars['String']['input']>;
  planType: MaintenancePlanType;
  services: Array<FacilityService>;
};

export enum FacilityService {
  Carpentry = 'CARPENTRY',
  Cleaning = 'CLEANING',
  Electrical = 'ELECTRICAL',
  Fumigation = 'FUMIGATION',
  Hvac = 'HVAC',
  Other = 'OTHER',
  Painting = 'PAINTING',
  Plumbing = 'PLUMBING'
}

export type FilledArtisanInvoice = ArtisanInvoice & IArtisanInvoice & {
  __typename?: 'FilledArtisanInvoice';
  createdAt: Scalars['DateTimeISO']['output'];
  from: FromDetails;
  invoiceNumber: Scalars['Int']['output'];
  labor: Scalars['Float']['output'];
  materials: Array<ArtisanInvoiceMaterial>;
  recipientAccountNumber: Scalars['String']['output'];
  status: ArtisanInvoiceStatus;
  task: ArtisanInvoiceTask;
  to: ToDetails;
  updatedAt: Scalars['DateTimeISO']['output'];
  user: WhatsappUser;
};

export type FinalizeAssignmentPaymentInput = {
  assignmentPaymentId: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};

export type FinalizeJoinByCommunityInviteResponse = {
  __typename?: 'FinalizeJoinByCommunityInviteResponse';
  organizationReferralCode?: Maybe<Scalars['String']['output']>;
  redirectTo?: Maybe<Scalars['String']['output']>;
  status: FinalizeJoinByCommunityInviteStatus;
};

export enum FinalizeJoinByCommunityInviteStatus {
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Mismatch = 'MISMATCH',
  Success = 'SUCCESS'
}

export type FromDetails = {
  __typename?: 'FromDetails';
  address?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export type GenerateInspectionInvoiceResponse = {
  __typename?: 'GenerateInspectionInvoiceResponse';
  invoice: Invoice;
  url?: Maybe<Scalars['String']['output']>;
};

export type GetAdminRolesResponse = {
  __typename?: 'GetAdminRolesResponse';
  data: Array<AdminRoleData>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetAssignmentScheduleInput = {
  categoryId: Scalars['String']['input'];
  endDate: Scalars['DateTimeISO']['input'];
  startDate: Scalars['DateTimeISO']['input'];
};

export type GetAssignmentScheduleResponse = IResponse & {
  __typename?: 'GetAssignmentScheduleResponse';
  data: Array<Scalars['DateTimeISO']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetBankAccountInformationResponse = IResponse & {
  __typename?: 'GetBankAccountInformationResponse';
  data: BankAccountInformation;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetClientLocationsResponse = IResponse & {
  __typename?: 'GetClientLocationsResponse';
  data: ClientLocationData;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetClientResponse = IResponse & {
  __typename?: 'GetClientResponse';
  data: Client;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetClientStatisticsResponse = IResponse & {
  __typename?: 'GetClientStatisticsResponse';
  data: ClientStatistics;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetInvoicePaymentLinkResponse = IResponse & {
  __typename?: 'GetInvoicePaymentLinkResponse';
  data: InvoicePaymentLink;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetInvoiceResponse = IResponse & {
  __typename?: 'GetInvoiceResponse';
  data: Invoice;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetMyPreviouslyUsedTradesmenResponse = IResponse & {
  __typename?: 'GetMyPreviouslyUsedTradesmenResponse';
  data: Array<PreviouslyUsedTradesman>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetNotificationsResponse = {
  __typename?: 'GetNotificationsResponse';
  lastViewedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  notifications: Array<UserNotification>;
};

export type GetOrderStatisticsResponse = IResponse & {
  __typename?: 'GetOrderStatisticsResponse';
  data: OrderStatistics;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetRefundRequestResponse = IResponse & {
  __typename?: 'GetRefundRequestResponse';
  data: Refund;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetTradesmanAssignmentResponse = {
  __typename?: 'GetTradesmanAssignmentResponse';
  data: TradesmanAssignment;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetTradesmanAssignmentsResponse = {
  __typename?: 'GetTradesmanAssignmentsResponse';
  data: Array<TradesmanAssignment>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetTradesmanProfileResponse = IResponse & {
  __typename?: 'GetTradesmanProfileResponse';
  data: TradesmanProfile;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetTradesmanResponse = IResponse & {
  __typename?: 'GetTradesmanResponse';
  data: Tradesman;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetTradesmanScheduleResponse = IResponse & {
  __typename?: 'GetTradesmanScheduleResponse';
  data: Array<Scalars['DateTimeISO']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetTradesmanWithAvailabilityByCategoryInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTimeISO']['input'];
};

export type GetUserByPhoneNumberResponse = IResponse & {
  __typename?: 'GetUserByPhoneNumberResponse';
  data: User;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

/** A guarantor for a user */
export type Guarantor = {
  __typename?: 'Guarantor';
  companyAddress: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  relationship: Scalars['String']['output'];
};

export type GuarantorInput = {
  companyAddress: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  relationship: Scalars['String']['input'];
};

export type HireAnalytics = {
  __typename?: 'HireAnalytics';
  adsWithHireCount: Scalars['Float']['output'];
  adsWithoutHireCount: Scalars['Float']['output'];
  hireRate: Scalars['String']['output'];
  totalAds: Scalars['Float']['output'];
};

export type Homeowner = {
  __typename?: 'Homeowner';
  addresses?: Maybe<Array<Address>>;
  billingAddress?: Maybe<Address>;
  clientProfile?: Maybe<ClientProfile>;
  createdAt: Scalars['DateTimeISO']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  marketingCampaign?: Maybe<MarketingCampaign>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['String']['output'];
};

export type HomeownerEdge = Edge & {
  __typename?: 'HomeownerEdge';
  cursor: Scalars['String']['output'];
  node: Homeowner;
};

export type HomeownerRequest = {
  __typename?: 'HomeownerRequest';
  address?: Maybe<Address>;
  category?: Maybe<Category>;
  client?: Maybe<Client>;
  clientProfile?: Maybe<ClientProfile>;
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<HomeownerRequestTaskFrequency>;
  homeowner?: Maybe<Homeowner>;
  id: Scalars['String']['output'];
  invoice?: Maybe<Invoice>;
  isComplete: Scalars['Boolean']['output'];
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadSource?: Maybe<LeadSource>;
  order?: Maybe<Order>;
  otherCategoryText?: Maybe<Scalars['String']['output']>;
  otherLeadSourceText?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<Payment>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<CategorySubscriptionPackagePlan>;
  startDate?: Maybe<Scalars['DateTimeISO']['output']>;
  subscription?: Maybe<SubscriptionRequest>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type HomeownerRequestPaymentCost = {
  __typename?: 'HomeownerRequestPaymentCost';
  charge: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  totalCost: Scalars['Float']['output'];
};

export enum HomeownerRequestTaskFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Weekly = 'WEEKLY'
}

export type IArtisanInvoice = {
  createdAt: Scalars['DateTimeISO']['output'];
  from: FromDetails;
  invoiceNumber: Scalars['Int']['output'];
  labor?: Maybe<Scalars['Float']['output']>;
  materials: Array<ArtisanInvoiceMaterial>;
  recipientAccountNumber?: Maybe<Scalars['String']['output']>;
  status: ArtisanInvoiceStatus;
  task?: Maybe<ArtisanInvoiceTask>;
  to?: Maybe<ToDetails>;
  updatedAt: Scalars['DateTimeISO']['output'];
  user: WhatsappUser;
};

export type ILocation = {
  area?: Maybe<Scalars['String']['output']>;
  buildingNumber?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  landmark?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
};

export type IResponse = {
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type IdentityVerification = {
  __typename?: 'IdentityVerification';
  createdAt: Scalars['DateTimeISO']['output'];
  dateOfBirth: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  identificationDocument?: Maybe<Scalars['String']['output']>;
  identificationNumber: Scalars['String']['output'];
  issues?: Maybe<Array<IdentityVerificationIssue>>;
  photo?: Maybe<Scalars['String']['output']>;
  pro: Pro;
  providerIssues?: Maybe<Array<IdentityVerificationProviderIssue>>;
  returnedDateOfBirth?: Maybe<Scalars['DateTimeISO']['output']>;
  returnedFullName?: Maybe<Scalars['String']['output']>;
  returnedIdentificationDocument?: Maybe<Scalars['String']['output']>;
  returnedPhoneNumber?: Maybe<Scalars['String']['output']>;
  returnedPhoto?: Maybe<Scalars['String']['output']>;
  status: IdentityVerificationStatus;
  type: MeansOfIdentification;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type IdentityVerificationIssue = {
  __typename?: 'IdentityVerificationIssue';
  code: IdentityVerificationIssueCode;
  message: Scalars['String']['output'];
};

export enum IdentityVerificationIssueCode {
  DobMismatch = 'DOB_MISMATCH',
  DuplicateId = 'DUPLICATE_ID',
  InvalidId = 'INVALID_ID',
  NameMismatch = 'NAME_MISMATCH',
  PhoneMismatch = 'PHONE_MISMATCH'
}

export type IdentityVerificationProviderIssue = {
  __typename?: 'IdentityVerificationProviderIssue';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum IdentityVerificationStatus {
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export type ImportCompletedOrderInput = {
  amountPaid: Scalars['Float']['input'];
  bankName?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  clientProfileId: Scalars['String']['input'];
  completedAt: Scalars['DateTimeISO']['input'];
  externalSerialNumber: Scalars['String']['input'];
  facility?: InputMaybe<InlineFacilityInput>;
  facilityContact?: InputMaybe<InlineFacilityContactInput>;
  facilityContactId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  items: Array<ImportedOrderItem>;
  paymentProvider?: ImportPaymentProvider;
  referenceFileKey: Scalars['String']['input'];
  taskDescription: Scalars['String']['input'];
  taskName: Scalars['String']['input'];
  tradesmanId: Scalars['String']['input'];
  transactionDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  transactionReference?: InputMaybe<Scalars['String']['input']>;
};

export type ImportFacilityAddressInput = {
  address: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  formattedAddress: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Payment provider to use when importing a completed order */
export enum ImportPaymentProvider {
  Offline = 'OFFLINE',
  OrganizationWallet = 'ORGANIZATION_WALLET'
}

export type ImportedInvoiceData = {
  __typename?: 'ImportedInvoiceData';
  externalSerialNumber: Scalars['String']['output'];
  referenceFileKey: Scalars['String']['output'];
};

export type ImportedInvoiceUploadUrl = {
  __typename?: 'ImportedInvoiceUploadUrl';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ImportedOrderItem = {
  labor?: InputMaybe<Scalars['Float']['input']>;
  materials?: InputMaybe<Array<ImportedOrderMaterial>>;
};

export type ImportedOrderMaterial = {
  name: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  unitPrice: Scalars['Float']['input'];
};

export enum IncomeLevel {
  Between_30KAnd_50K = 'BETWEEN_30K_AND_50K',
  Between_50KAnd_70K = 'BETWEEN_50K_AND_70K',
  Between_70KAnd_100K = 'BETWEEN_70K_AND_100K',
  Between_100KAnd_150K = 'BETWEEN_100K_AND_150K',
  Between_150KAnd_200K = 'BETWEEN_150K_AND_200K',
  Over_200K = 'OVER_200K',
  Under_30K = 'UNDER_30K'
}

export enum Industry {
  AerospaceAndDefense = 'AerospaceAndDefense',
  AgricultureAndForestry = 'AgricultureAndForestry',
  ArtsDesignAndFashion = 'ArtsDesignAndFashion',
  Automotive = 'Automotive',
  Construction = 'Construction',
  Consulting = 'Consulting',
  Education = 'Education',
  EnergyAndUtilities = 'EnergyAndUtilities',
  EnvironmentalServices = 'EnvironmentalServices',
  FinanceAndBanking = 'FinanceAndBanking',
  FoodAndBeverage = 'FoodAndBeverage',
  GovernmentAndPublicAdministration = 'GovernmentAndPublicAdministration',
  Healthcare = 'Healthcare',
  HospitalityAndTourism = 'HospitalityAndTourism',
  LawAndLegalServices = 'LawAndLegalServices',
  Manufacturing = 'Manufacturing',
  MarketingAndAdvertising = 'MarketingAndAdvertising',
  MediaAndEntertainment = 'MediaAndEntertainment',
  NonprofitAndSocialServices = 'NonprofitAndSocialServices',
  Other = 'Other',
  PharmaceuticalAndBiotechnology = 'PharmaceuticalAndBiotechnology',
  RealEstate = 'RealEstate',
  Retail = 'Retail',
  TechnologyAndInformationServices = 'TechnologyAndInformationServices',
  Telecommunications = 'Telecommunications',
  TransportationAndLogistics = 'TransportationAndLogistics'
}

export type InitialiseJoinByCommunityInviteInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  inviteToken: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
};

export type InitialiseJoinByCommunityInviteResponse = {
  __typename?: 'InitialiseJoinByCommunityInviteResponse';
  flowType: InviteJoinFlowType;
  inviteJoinSessionToken: Scalars['String']['output'];
  loginHint: Scalars['String']['output'];
  redirectStrategy: CommunityInviteRedirectStrategy;
};

export type InitializeCardAuthorizationResponse = {
  __typename?: 'InitializeCardAuthorizationResponse';
  accessCode: Scalars['String']['output'];
  cardAuthorizationId: Scalars['String']['output'];
  checkoutUrl: Scalars['String']['output'];
};

export type InitiateAssignmentPaymentInput = {
  assignmentId: Scalars['String']['input'];
  purpose: AssignmentPaymentTypes;
};

/** Result of initiating a plan downgrade */
export type InitiateDowngradeResult = {
  __typename?: 'InitiateDowngradeResult';
  /** Checkout URL for trial downgrades (requires immediate payment) */
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  /** The created downgrade intent */
  intent: OrganizationPlanDowngradeIntent;
  /** Payment ID for trial downgrades */
  paymentId?: Maybe<Scalars['String']['output']>;
};

/** Arguments for initiating a plan downgrade */
export type InitiateOrganizationPlanDowngradeArgs = {
  /** Billing interval for the new plan */
  interval: SubscriptionInterval;
  /** Target plan specification ID */
  specId: Scalars['String']['input'];
};

export type InlineFacilityContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type InlineFacilityInput = {
  address: ImportFacilityAddressInput;
  name: Scalars['String']['input'];
};

export type IntervalDiscount = {
  __typename?: 'IntervalDiscount';
  discountPercentage: Scalars['Float']['output'];
  interval: SubscriptionInterval;
};

export type IntervalDiscountInput = {
  discountPercentage: Scalars['Float']['input'];
  interval: SubscriptionInterval;
};

export type Invite = {
  __typename?: 'Invite';
  category?: Maybe<Category>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  level?: Maybe<Scalars['Float']['output']>;
  token: Scalars['String']['output'];
  used: Scalars['Boolean']['output'];
  userType: UserType;
};

export enum InviteJoinFlowType {
  ExistingMember = 'EXISTING_MEMBER',
  NewUser = 'NEW_USER'
}

export type Invoice = {
  __typename?: 'Invoice';
  allowedPaymentProviders: Array<Scalars['String']['output']>;
  appliedDiscount?: Maybe<InvoiceDiscount>;
  assignments?: Maybe<Array<TradesmanAssignment>>;
  canceled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  due?: Maybe<Scalars['DateTimeISO']['output']>;
  handlingQuotation?: Maybe<OrderHandlingQuotation>;
  hasAtLeastOnePayment: Scalars['Boolean']['output'];
  homeownerRequest?: Maybe<HomeownerRequest>;
  id: Scalars['String']['output'];
  importedInvoiceData?: Maybe<ImportedInvoiceData>;
  inspectionAmount?: Maybe<Scalars['Float']['output']>;
  invoiceDate: Scalars['DateTimeISO']['output'];
  invoiceNumber: Scalars['Float']['output'];
  isFullyPaid: Scalars['Boolean']['output'];
  marketplaceRequest?: Maybe<MarketplaceRequest>;
  options?: Maybe<InvoiceOptions>;
  order?: Maybe<Order>;
  payment?: Maybe<Payment>;
  pricing?: Maybe<InvoicePricing>;
  recipient: Recipient;
  recruitment?: Maybe<ContractRecruitment>;
  recruitmentData?: Maybe<Array<RecruitmentData>>;
  recruitmentRequestId?: Maybe<Scalars['String']['output']>;
  reimbursements?: Maybe<Array<ContractPayoutReimbursement>>;
  renderingData?: Maybe<InvoiceRenderingData>;
  sent: Scalars['Boolean']['output'];
  splitPayments?: Maybe<Array<SplitPayment>>;
  subscription?: Maybe<SubscriptionRequest>;
  totalCost: Scalars['Float']['output'];
  type?: Maybe<InvoiceType>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type InvoiceDetails = {
  __typename?: 'InvoiceDetails';
  labor?: Maybe<Scalars['Float']['output']>;
  materials?: Maybe<Array<InvoiceMaterial>>;
};

export type InvoiceDiscount = {
  __typename?: 'InvoiceDiscount';
  accessType: InvoiceDiscountAccessType;
  balance?: Maybe<Scalars['Float']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  expirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  isAutoApplied?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  validInvoiceTypes?: Maybe<Array<InvoiceType>>;
  value: Scalars['Float']['output'];
  valueCap?: Maybe<Scalars['Float']['output']>;
};

export enum InvoiceDiscountAccessType {
  Invite = 'INVITE',
  Leadsource = 'LEADSOURCE',
  Open = 'OPEN',
  Referral = 'REFERRAL'
}

export type InvoiceEdge = Edge & {
  __typename?: 'InvoiceEdge';
  cursor: Scalars['String']['output'];
  node: Invoice;
};

export type InvoiceItemsSection = {
  __typename?: 'InvoiceItemsSection';
  rows: Array<InvoiceLineRow>;
  title?: Maybe<Scalars['String']['output']>;
};

export type InvoiceLineItemCell = {
  __typename?: 'InvoiceLineItemCell';
  subText?: Maybe<Array<Scalars['String']['output']>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type InvoiceLineRow = {
  __typename?: 'InvoiceLineRow';
  cells: Array<InvoiceLineItemCell>;
};

export type InvoiceMaterial = {
  __typename?: 'InvoiceMaterial';
  name: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type InvoiceMaterialInput = {
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  unitPrice: Scalars['Float']['input'];
};

export type InvoiceNotificationPayload = NotificationPayload & {
  __typename?: 'InvoiceNotificationPayload';
  event: NotificationEvent;
  invoice: NotificationPayloadInvoice;
  order: NotificationPayloadOrder;
};

export type InvoiceOptions = {
  __typename?: 'InvoiceOptions';
  commissionPercentage: Scalars['Float']['output'];
  materialCommissionCap?: Maybe<Scalars['Float']['output']>;
  vatApplicationScope?: Maybe<VatApplicationScope>;
};

export type InvoicePaymentLink = {
  __typename?: 'InvoicePaymentLink';
  paymentUrl: Scalars['String']['output'];
};

export type InvoicePricing = {
  __typename?: 'InvoicePricing';
  cost: Scalars['Float']['output'];
  options?: Maybe<InvoicePricingOptions>;
  serviceCharge: Scalars['Float']['output'];
};

export type InvoicePricingOptions = {
  __typename?: 'InvoicePricingOptions';
  hideServiceCharge?: Maybe<Scalars['Boolean']['output']>;
  ignoreTax?: Maybe<Scalars['Boolean']['output']>;
  isReadonly?: Maybe<Scalars['Boolean']['output']>;
  taxOnServiceChargeOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type InvoiceRenderingData = {
  __typename?: 'InvoiceRenderingData';
  headers: Array<Scalars['String']['output']>;
  sections: Array<InvoiceItemsSection>;
};

export enum InvoiceType {
  ContractPayoutReimbursement = 'CONTRACT_PAYOUT_REIMBURSEMENT',
  Inspection = 'INSPECTION',
  MarketplaceRequestMatch = 'MARKETPLACE_REQUEST_MATCH',
  Materials = 'MATERIALS',
  Recruitment = 'RECRUITMENT',
  RecruitmentMatch = 'RECRUITMENT_MATCH',
  Subscription = 'SUBSCRIPTION'
}

/** The Job Model */
export type Job = {
  __typename?: 'Job';
  assignedTradesman?: Maybe<Tradesman>;
  completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  contact: Contact;
  custom?: Maybe<JobCustomTask>;
  finalCost?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  invoiceDetails?: Maybe<InvoiceDetails>;
  jobCode: Scalars['String']['output'];
  payment?: Maybe<Payment>;
  progressLog?: Maybe<Array<JobProgressLog>>;
  status: Status;
  task?: Maybe<Task>;
};

export enum JobAdCommunicationMethod {
  Email = 'EMAIL',
  Sms = 'SMS',
  Whatsapp = 'WHATSAPP'
}

export type JobAdNotificationDigestResponse = {
  __typename?: 'JobAdNotificationDigestResponse';
  dryRun: Scalars['Boolean']['output'];
  recipients: Array<DigestRecipientEntry>;
  totalJobAdsMatched: Scalars['Int']['output'];
  totalRecipients: Scalars['Int']['output'];
};

export type JobAdNotificationsPreferences = {
  __typename?: 'JobAdNotificationsPreferences';
  categories: Array<Category>;
  communicationMethods: Array<JobAdCommunicationMethod>;
  employmentTypes: Array<EmploymentType>;
  pro: Pro;
};

export type JobAdShortlist = {
  __typename?: 'JobAdShortlist';
  applications: Array<EmployerJobApplication>;
  approvedApplications: Array<EmployerJobApplication>;
  approvedApplicationsCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: EmployerAdmin;
  finalizedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  finalizedBy?: Maybe<EmployerAdmin>;
  id: Scalars['String']['output'];
  isFinalized: Scalars['Boolean']['output'];
  isSent: Scalars['Boolean']['output'];
  jobAd: EmployerJobAd;
  sentAt?: Maybe<Scalars['DateTimeISO']['output']>;
  sentBy?: Maybe<EmployerAdmin>;
  updatedAt: Scalars['DateTimeISO']['output'];
  version: Scalars['Int']['output'];
};

export type JobAdTag = {
  __typename?: 'JobAdTag';
  description?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type JobApplicantApplication = {
  __typename?: 'JobApplicantApplication';
  ad?: Maybe<EmployerJobAd>;
  applicantSnapshot: ApplicantSnapshot;
  certifications: Array<JobApplicationCertification>;
  communityJobOpportunity?: Maybe<CommunityJobOpportunity>;
  createdAt: Scalars['DateTimeISO']['output'];
  education: Array<JobApplicationEducation>;
  employmentHistory: Array<JobApplicationEmploymentHistoryItem>;
  enhancementRequested: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  jobOpportunity?: Maybe<CommunityJobOpportunity>;
  projectHistory: Array<JobApplicationProjectHistoryItem>;
  status: ApplicationStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type JobApplicationCertification = {
  __typename?: 'JobApplicationCertification';
  createdAt: Scalars['DateTimeISO']['output'];
  id?: Maybe<Scalars['String']['output']>;
  issuedAt: Scalars['DateTimeISO']['output'];
  issuedBy: Scalars['String']['output'];
  issuerCertificationId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type JobApplicationEducation = {
  __typename?: 'JobApplicationEducation';
  createdAt: Scalars['DateTimeISO']['output'];
  fieldOfStudy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  qualification: EducationLevel;
  schoolName: Scalars['String']['output'];
};

export type JobApplicationEmploymentHistoryItem = {
  __typename?: 'JobApplicationEmploymentHistoryItem';
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  endedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
  media: Array<JobApplicationMediaItem>;
  startedAt: Scalars['DateTimeISO']['output'];
};

export type JobApplicationMediaItem = {
  __typename?: 'JobApplicationMediaItem';
  key: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  originalUrl: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
};

export type JobApplicationMediaItemInput = {
  key: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type JobApplicationProjectHistoryItem = {
  __typename?: 'JobApplicationProjectHistoryItem';
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  endedAt: Scalars['DateTimeISO']['output'];
  id?: Maybe<Scalars['String']['output']>;
  media: Array<JobApplicationMediaItem>;
  name: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  videos: Array<Scalars['String']['output']>;
};

/** The Custom order */
export type JobCustomTask = {
  __typename?: 'JobCustomTask';
  categoryId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  resourceUrl?: Maybe<Scalars['String']['output']>;
  subCategoryId?: Maybe<Scalars['String']['output']>;
};

/** The Custom order */
export type JobCustomTaskInput = {
  categoryId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  resourceUrl?: InputMaybe<Scalars['String']['input']>;
  subCategoryId?: InputMaybe<Scalars['String']['input']>;
};

export type JobImage = {
  data: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type JobInvoiceDetailsItem = {
  jobId: Scalars['String']['input'];
  labor?: InputMaybe<Scalars['Int']['input']>;
  materials?: InputMaybe<Array<InvoiceMaterialInput>>;
};

/** The location of Job */
export type JobLocationData = {
  customLocation?: InputMaybe<CustomLocation>;
  id?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  scheduledDate: Scalars['DateTimeISO']['input'];
};

export type JobLocationInput = {
  area: Scalars['String']['input'];
  country: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type JobProgressLog = {
  __typename?: 'JobProgressLog';
  update: Progress;
  user: User;
};

export type JobTaskInput = {
  categoryId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type JobToRefund = {
  amount: Scalars['Float']['input'];
  assignmentId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
};

/** The visibility of the job ad */
export enum JobVisibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum LaborHackProduct {
  Recruiter = 'RECRUITER',
  Training = 'TRAINING'
}

export type LaborhackJobRatings = {
  __typename?: 'LaborhackJobRatings';
  appearance: Scalars['Float']['output'];
  behavior: Scalars['Float']['output'];
  postServiceCleanUp: Scalars['Float']['output'];
  properToolUsage: Scalars['Float']['output'];
  punctuality: Scalars['Float']['output'];
};

/** map coordinates */
export type LatLong = {
  __typename?: 'LatLong';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type LatLongInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type Lead = {
  __typename?: 'Lead';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};

export enum LeadSource {
  Advertisement = 'Advertisement',
  EventOrExhibition = 'Event_or_Exhibition',
  FriendOrReferral = 'Friend_or_Referral',
  GoogleAd = 'Google_Ad',
  Herconomy = 'Herconomy',
  Influencers = 'Influencers',
  LaborHackMarketer = 'LaborHack_Marketer',
  MarketingFlyer = 'Marketing_Flyer',
  Newspaper = 'Newspaper',
  OnlineSearch = 'Online_Search',
  Other = 'Other',
  Radio = 'Radio',
  SalesTeam = 'Sales_Team',
  SocialMedia = 'Social_Media',
  Tv = 'TV',
  Voucher = 'Voucher',
  WordOfMouth = 'Word_of_Mouth',
  Youtube = 'Youtube'
}

export type ListAdminsResponse = IResponse & {
  __typename?: 'ListAdminsResponse';
  data: Array<Admin>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type ListAllTradesmenSearch = {
  by: ListAllTradesmenSearchBy;
  query: Scalars['String']['input'];
};

export enum ListAllTradesmenSearchBy {
  Location = 'LOCATION'
}

export type ListAssignmentPaymentFilters = {
  showOlderTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  transferStatus?: InputMaybe<TransferStatus>;
};

export type ListAssignmentPaymentResponse = Edges & {
  __typename?: 'ListAssignmentPaymentResponse';
  edges: Array<AssignmentPaymentEdge>;
  pageInfo: PageInfo;
};

export type ListAssignmentPaymentSearch = {
  type: ListAssignmentPaymentSearchTypes;
  value: Scalars['String']['input'];
};

/** Search types for list assignment payment */
export enum ListAssignmentPaymentSearchTypes {
  OrderCode = 'ORDER_CODE'
}

export type ListBankItem = {
  __typename?: 'ListBankItem';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ListBanksResponse = IResponse & {
  __typename?: 'ListBanksResponse';
  data: Array<ListBankItem>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type ListBusinessesFilters = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryStatus?: InputMaybe<Array<SentEmailDeliveryStatus>>;
};

export type ListBusinessesResponse = Edges & {
  __typename?: 'ListBusinessesResponse';
  edges: Array<BusinessEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ListClientsResponse = Edges & {
  __typename?: 'ListClientsResponse';
  edges: Array<ClientEdge>;
  pageInfo: PageInfo;
};

export type ListHomeownersResponse = Edges & {
  __typename?: 'ListHomeownersResponse';
  edges: Array<HomeownerEdge>;
  pageInfo: PageInfo;
};

export type ListInvoiceResponse = Edges & {
  __typename?: 'ListInvoiceResponse';
  edges: Array<InvoiceEdge>;
  pageInfo: PageInfo;
};

export type ListOrdersResponse = Edges & {
  __typename?: 'ListOrdersResponse';
  edges: Array<OrderEdge>;
  pageInfo: PageInfo;
};

export type ListProCertificationsFilters = {
  certificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  identityVerified?: InputMaybe<Scalars['Boolean']['input']>;
  onlineAssessmentPassed?: InputMaybe<Scalars['Boolean']['input']>;
  uploaded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListProCertificationsResponse = Edges & {
  __typename?: 'ListProCertificationsResponse';
  edges: Array<ProCertificationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ListProTradeRequirementsFilters = {
  assessmentType?: InputMaybe<Array<TradeRequirementType>>;
  externalStatus?: InputMaybe<Array<ExternalProTradeRequirementStatus>>;
  identityVerificationStatus?: InputMaybe<Array<ListProsIdentityVerificationStatus>>;
  requirementIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListProTradeRequirementsResponse = Edges & {
  __typename?: 'ListProTradeRequirementsResponse';
  edges: Array<ProTradeRequirementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ListProTradeRequirementsSearch = {
  by: ListProTradeRequirementsSearchBy;
  query: Scalars['String']['input'];
};

export enum ListProTradeRequirementsSearchBy {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export type ListProTradeRequirementsSort = {
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  by: ListProTradeRequirementsSortBy;
};

export enum ListProTradeRequirementsSortBy {
  CreatedAt = 'CREATED_AT'
}

export type ListProsFilters = {
  acquisitionChannel?: InputMaybe<Array<Scalars['String']['input']>>;
  alternativeToPracticalInterviewStatus?: InputMaybe<Array<ListProsTestStatus>>;
  backgroundCheckComplete?: InputMaybe<Scalars['Boolean']['input']>;
  bankAccountSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  channelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  conversionPath?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedProIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hasJobScheduleConflict?: InputMaybe<Array<ListProsForRecruitmentJobScheduleConflict>>;
  identityVerificationIssueCode?: InputMaybe<Array<ListProsIdentityVerificationIssueCode>>;
  identityVerificationStatus?: InputMaybe<Array<ListProsIdentityVerificationStatus>>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  leadSource?: InputMaybe<Array<Scalars['String']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  onboardingCompleted?: InputMaybe<Array<Scalars['String']['input']>>;
  paidForPriorLearningAttempts?: InputMaybe<Scalars['Boolean']['input']>;
  paidForSoftSkillsAttempts?: InputMaybe<Scalars['Boolean']['input']>;
  priorLearningTestStatus?: InputMaybe<Array<ListProsTestStatus>>;
  softSkillsTrainingStatus?: InputMaybe<Array<ListProsTestStatus>>;
  tracks?: InputMaybe<Array<ProTrack>>;
  tradeId?: InputMaybe<Scalars['String']['input']>;
  tradeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ListProsForRecruitmentJobScheduleConflict {
  Available = 'AVAILABLE',
  HasConflict = 'HAS_CONFLICT'
}

export enum ListProsIdentityVerificationIssueCode {
  DobMismatch = 'DOB_MISMATCH',
  DuplicateId = 'DUPLICATE_ID',
  NameMismatch = 'NAME_MISMATCH',
  NotAvailable = 'NOT_AVAILABLE',
  PhoneMismatch = 'PHONE_MISMATCH'
}

export enum ListProsIdentityVerificationStatus {
  Declined = 'DECLINED',
  NotSubmitted = 'NOT_SUBMITTED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export type ListProsResponse = Edges & {
  __typename?: 'ListProsResponse';
  edges: Array<ProEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};


export type ListProsResponseTotalCountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ListProsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ListProsSearch>;
  sort?: InputMaybe<ListProsSort>;
};

export type ListProsSearch = {
  by: ListProsSearchBy;
  query: Scalars['String']['input'];
};

export enum ListProsSearchBy {
  Address = 'ADDRESS',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  PhoneNumber = 'PHONE_NUMBER',
  Referrer = 'REFERRER'
}

export type ListProsSort = {
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  by: ListProsSortBy;
};

export enum ListProsSortBy {
  CreatedAt = 'CREATED_AT',
  FirstName = 'FIRST_NAME',
  IdentityVerificationSubmittedAt = 'IDENTITY_VERIFICATION_SUBMITTED_AT',
  LastName = 'LAST_NAME'
}

export enum ListProsTestStatus {
  AwaitingResult = 'AWAITING_RESULT',
  Failed = 'FAILED',
  NotStarted = 'NOT_STARTED',
  NotTaken = 'NOT_TAKEN',
  Passed = 'PASSED',
  Scheduled = 'SCHEDULED'
}

export type ListRefundRequestsInput = {
  order?: InputMaybe<Scalars['String']['input']>;
};

export type ListRefundRequestsResponse = IResponse & {
  __typename?: 'ListRefundRequestsResponse';
  data: Array<Refund>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type ListTradesFilters = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
};

export type ListTradesmanResponse = IResponse & {
  __typename?: 'ListTradesmanResponse';
  data: Array<Tradesman>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type ListTradesmanWithAvailabilityResponse = IResponse & {
  __typename?: 'ListTradesmanWithAvailabilityResponse';
  data: Array<TradesmanWithAvailability>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

/** The Location Model */
export type Location = ILocation & {
  __typename?: 'Location';
  area: Scalars['String']['output'];
  buildingNumber?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  landmark?: Maybe<Scalars['String']['output']>;
  location: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
};

export type LocationData = {
  __typename?: 'LocationData';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  coordinates?: Maybe<LatLong>;
  placeId: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type LocationDataInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  coordinates?: InputMaybe<LatLongInput>;
  placeId: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type LocationSchedule = {
  __typename?: 'LocationSchedule';
  locationId: Scalars['String']['output'];
  scheduledDate: Scalars['DateTimeISO']['output'];
};

export enum LogBookReportingFrequency {
  Daily = 'DAILY',
  Weekly = 'WEEKLY'
}

export type LogEventContextFieldArgs = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum MaintenanceFrequency {
  Biweekly = 'BIWEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum MaintenancePlanType {
  OneOff = 'ONE_OFF',
  Routine = 'ROUTINE'
}

export type MarkOrganizationToolAsPaidDetails = {
  amount: Scalars['Float']['input'];
  paymentMethod: OrganizationToolPaymentMethod;
  paymentNotes?: InputMaybe<Scalars['String']['input']>;
  paymentReference: Scalars['String']['input'];
};

export enum MarketingCampaign {
  Fixme = 'FIXME'
}

export type MarketingSubscriber = {
  __typename?: 'MarketingSubscriber';
  createdAt: Scalars['DateTimeISO']['output'];
  emailAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type MarketplaceConflict = {
  __typename?: 'MarketplaceConflict';
  marketplaceJob: MarketplaceJob;
  type: ScheduleConflictType;
};

export type MarketplaceJob = {
  __typename?: 'MarketplaceJob';
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  matches: Array<MarketplaceMatch>;
  proCount: Scalars['Float']['output'];
  pros: Array<Pro>;
  request: MarketplaceRequest;
  schedule: MarketplaceJobSchedule;
  shortlist?: Maybe<MarketplaceJobShortlist>;
  trade: Trade;
};

export type MarketplaceJobSchedule = {
  __typename?: 'MarketplaceJobSchedule';
  /** This is the date the job ends. */
  end: Scalars['DateTimeISO']['output'];
  /** An array of dates the pro(s) are not required to work. */
  offDates?: Maybe<Array<Scalars['DateTimeISO']['output']>>;
  /** This is the date the job starts. */
  start: Scalars['DateTimeISO']['output'];
  /** An array of days in week the pro(s) are required to work. For example: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]. */
  workDays: Array<Scalars['String']['output']>;
};

export type MarketplaceJobShortlist = {
  __typename?: 'MarketplaceJobShortlist';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  job: MarketplaceJob;
  shortlistedPros: Array<MarketplaceJobShortlistedPro>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum MarketplaceJobShortlistStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type MarketplaceJobShortlistedPro = {
  __typename?: 'MarketplaceJobShortlistedPro';
  pro: Pro;
  status: MarketplaceJobShortlistStatus;
};

/** keeps track of a pro that matches a marketplace job under request */
export type MarketplaceMatch = {
  __typename?: 'MarketplaceMatch';
  pro: MarketplaceMatchPro;
  relevantSkills: Array<ProSkill>;
};

export type MarketplaceMatchPro = {
  __typename?: 'MarketplaceMatchPro';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** a marketplace request */
export type MarketplaceRequest = {
  __typename?: 'MarketplaceRequest';
  business: Business;
  client: Client;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  /** the jobs for this request */
  jobs: Array<MarketplaceJob>;
  location: LocationData;
  /** the invoice for this request */
  matchingFeeInvoice?: Maybe<Invoice>;
};

export enum MeansOfIdentification {
  Bvn = 'BVN',
  DriversLicense = 'DRIVERS_LICENSE',
  Nin = 'NIN',
  Passport = 'PASSPORT',
  VotersCard = 'VOTERS_CARD'
}

export type MonthYear = {
  __typename?: 'MonthYear';
  month: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

export type MonthYearInput = {
  month: Scalars['Float']['input'];
  year: Scalars['Float']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptAgreement: Scalars['Boolean']['output'];
  acceptEmploymentOffer: EmployerJobApplicationOffer;
  acceptMyQuotation: OrderHandlingQuotation;
  acceptMyQuotationForClientProfile: OrderHandlingQuotation;
  acceptOrderHandlingQuotation: OrderHandlingQuotation;
  acceptOrganizationUserInvite: OrganizationUser;
  activateCommunityManager: Scalars['Boolean']['output'];
  activateJob: DefaultResponse;
  activateProRecruitmentContract: ProRecruitmentContract;
  /** Activate a card-less trial subscription by adding a card. Creates Paystack subscription. */
  activateSubscriptionWithCard: OrganizationPlanSubscription;
  addAllProsToMailingList: Scalars['JSONObject']['output'];
  addApplicationToJobAdShortlistApproved: Scalars['Boolean']['output'];
  addApplicationsToJobAdShortlist: JobAdShortlist;
  addCategorySubscriptionPackagePrice: CategorySubscriptionPackagePrice;
  addClientProfileToInvoiceDiscountInviteList: InvoiceDiscount;
  addClientToInvoiceDiscountInviteList: InvoiceDiscount;
  addCommentToLogBookEntry?: Maybe<TrainingCommunityProgramStudentLogBookEntry>;
  addDiscountToProTradeLevelPayment: ProTradeLevelPayment;
  addJobsToOrder: Order;
  addLocation: Location;
  addLocationForClient: Location;
  addOrganizationFacilityContact: OrganizationFacilityContact;
  /** @deprecated tradesmen are no longer in use */
  addPaymentProviderInformation: PaymentProviderInformation;
  addPorfolioWorkHistoryItem: Scalars['Boolean']['output'];
  addPortfolioCertification: Scalars['Boolean']['output'];
  addPortfolioEducation: PortfolioEducation;
  addPortfolioEmploymentHistoryItem: PortfolioEmploymentHistoryItem;
  addProPaymentInformation: Pro;
  /** @deprecated use addProPaymentInformation instead */
  addProPaymentProviderInformation: PaymentProviderInformation;
  /** @deprecated use adminAddProPaymentInformation instead */
  addProPaymentProviderInformationForPro: PaymentProviderInformation;
  addProPhoneNumber: Pro;
  addProToAssignment: TradesmanAssignment;
  addProToMarketplaceJob: MarketplaceJob;
  addProToRecruitmentJob: RecruitmentJob;
  addProTradeRequirementResult: ProTradeRequirement;
  addProsToRecruitmentShortlist: RecruitmentJobShortlist;
  addProsToShortlist: MarketplaceJobShortlist;
  addRewardPointChange: AddRewardPointChangeResponse;
  addSubscriber: MarketingSubscriber;
  addThirdPartyIntegratorPolicy: ThirdPartyIntegrator;
  addTrackToPro: Pro;
  addTradeToPro: Pro;
  addTrainingCommunityProgramLogBookEntry: TrainingCommunityProgramStudentLogBookEntry;
  adminActivateEmployerJobAd: EmployerJobAd;
  adminAddProPaymentInformation: Pro;
  adminAddReferrerPaymentInformation: Referrer;
  adminChangeJobAdApplicationDeadline: EmployerJobAd;
  adminCreateHomeowner: Homeowner;
  adminDisableEmployerJobAd: EmployerJobAd;
  /** Admin-initiated wallet funding: generates an invoice with offline payment driver for an organization. */
  adminInitiateWalletFunding: WalletFundingResponse;
  /** Recompute tags and keywords for active public job ads that have not been processed yet. Uses LLM pipeline. Admin only. */
  adminRecomputeActiveJobAdTagsAndKeywords: BackfillResponse;
  adminRejectEmployerJobAd: EmployerJobAd;
  adminRemoveJobAdApplicationDeadline: EmployerJobAd;
  /** Send notification emails to matching pros for all active public job ads. Defaults to dry run mode. Admin only. */
  adminSendActiveJobAdNotifications: AdminJobAdNotificationResponse;
  adminUpdateClient: DefaultResponse;
  adminUpdateHomeowner: Homeowner;
  applyInvoiceDiscountCode: Invoice;
  /** Apply a scheduled plan spec transition intent immediately */
  applyPlanSpecTransitionImmediately: OrganizationPlanSpecTransitionIntent;
  approveAssignmentPayment: DefaultResponse;
  approveContractPayout: ContractPayout;
  approveContractQuotation: ContractQuotation;
  approveReferrerPayout: ReferrerPayout;
  approveRefundRequest: DefaultResponse;
  approveSubscriptionRequestCallPayout: SubscriptionRequestCallPayout;
  approveThirdPartyIntegratorPayout: ThirdPartyIntegratorPayout;
  archiveCommunityAnnouncement: CommunityAnnouncement;
  archiveJob: DefaultResponse;
  assignContract: Contract;
  assignJobsToTradesman: DefaultResponse;
  assignProToSubscriptionRequestCall: SubscriptionRequestCall;
  assignTrainingCommunityProgramLogBookSupervisor: TrainingCommunityProgram;
  attachReferrerToClient: Client;
  attachTagsToProsWithNoTags: Scalars['Boolean']['output'];
  /** Backfill free plan subscriptions for organizations without subscriptions. Runs asynchronously. Admin only. */
  backfillOrganizationSubscriptions: BackfillResponse;
  batchUpdateTalentPoolCandidateStatus: Array<TalentPoolCandidate>;
  blockAUser: Scalars['String']['output'];
  cancelEmploymentOffer: EmployerJobApplicationOffer;
  cancelExpiredSubscriptions: Scalars['Boolean']['output'];
  /** Cancels an interview requirement for a pro. This ideally should only be used as an override when the event is in the past. NOTE: This does not cancel the event in Calendly. */
  cancelInterviewRequirementEvent: ProTradeRequirement;
  cancelInvoice: Invoice;
  cancelMyInterviewRequirement: ProTradeRequirement;
  cancelOrder: Order;
  cancelOrderHandlingQuotation: OrderHandlingQuotation;
  /** Cancel a pending or scheduled downgrade intent */
  cancelOrganizationPlanDowngrade: Scalars['Boolean']['output'];
  cancelOrganizationUserInvite: Scalars['Boolean']['output'];
  cancelRefundRequest: DefaultResponse;
  cancelTradesmanVisit: TradesmanAssignmentVisit;
  cancelTradesmanVisitForClientProfile: TradesmanAssignmentVisit;
  cancelTransferRequest: Transfer;
  changeBusinessEmail: Business;
  changeClientEmail: Client;
  changeCustomTaskCategory: Job;
  changeDefaultAccountNumber: PaymentProviderInformation;
  changeDiscountedTrade: Scalars['Boolean']['output'];
  /** Change the organization plan subscription to a different plan. */
  changeOrganizationPlanSubscription: OrganizationPlanSubscription;
  changeOrganizationUserRole: OrganizationUser;
  checkAndUpdateOnboardingStatus: Scalars['Boolean']['output'];
  checkAndUpdateOnboardingStatusForPros: Array<Scalars['String']['output']>;
  clientGenerateInspectionInvoice: GenerateInspectionInvoiceResponse;
  completeBackgroundChecksForEligiblePros: Array<Scalars['String']['output']>;
  confirmBrokenTransfer: Scalars['Boolean']['output'];
  confirmHomeownerRequestPayment: HomeownerRequest;
  confirmInvoicePayment: DefaultResponse;
  confirmOfflineInvoicePayment: Invoice;
  confirmOfflineTransfer: Transfer;
  confirmProStudyWorkOpportunityPayment: ProStudyWorkOpportunity;
  confirmProTradeLevelPayment: ProTradeLevelPayment;
  confirmQueuedTransfers: Scalars['Boolean']['output'];
  confirmTradeRequirementPayment: ProTradeRequirementPayment;
  convertWaitlistedBusinessesToBusinessess: Scalars['Boolean']['output'];
  copyTradesmenToPro: Scalars['Boolean']['output'];
  correctOutsourcedJobAdOwningOrganization: Scalars['Boolean']['output'];
  createAdmin: DefaultResponse;
  createAgreementVersion: OrganizationAgreement;
  createAssignmentInspectionInvoice: UpdateAssignmentResponse;
  createBackgroundCheckForPro: BackgroundCheck;
  createCanadaBasicApplication: CanadaBasicApplication;
  createCertificatesForProsWhoHaveEarnedThemButDontHaveCertificates: Scalars['Boolean']['output'];
  createCertification: Certification;
  createClient: DefaultResponse;
  createCommunityAnnouncement: CommunityAnnouncement;
  createCommunityJobApplication: CommunityJobApplication;
  createCommunityJobOpportunity: CommunityJobOpportunity;
  createCommunityManagementDemoRequestTask: Scalars['String']['output'];
  createCommunityManagementSalesConversationTask: Scalars['String']['output'];
  createCommunityManagerPaymentRequest: Scalars['String']['output'];
  createCommunitySegment: CommunitySegment;
  createContacts: BackgroundCheck;
  createContractPayoutReimbursementInvoice: Array<ContractPayoutReimbursement>;
  createContractRecruitment: ContractRecruitment;
  createContractRecruitmentRequestMatchInvoice: Invoice;
  createContractWorksheet: ContractWorksheet;
  /** Create a new organization plan specification with Paystack plan codes for all subscription intervals */
  createCustomOrganizationPlanSpec: OrganizationPlanSpec;
  createCustomSubscriptionRequest: Scalars['Boolean']['output'];
  createEmployerAdmin: EmployerAdmin;
  createEmployerJobAd: EmployerJobAd;
  createEmployerJobAdPrincipal: EmployerJobAdPrincipal;
  createEmployerJobAdThirdParty: EmployerJobAdThirdParty;
  createEmploymentHistoryItemsFromHiredApplications: Array<EmployerJobApplication>;
  createEmploymentOffer: EmployerJobApplicationOffer;
  createEnquiry: Scalars['Boolean']['output'];
  createHomeowner: CreateClientResponse;
  /** @deprecated Use startHomeownerRequest instead */
  createHomeownerRequest: HomeownerRequest;
  createIdentityVerification: IdentityVerification;
  createInspectionInvoice: Invoice;
  createInvite: Invite;
  createJobAdNotificationPreferences: JobAdNotificationsPreferences;
  createJobAdShortlistVersion: JobAdShortlist;
  createLead: Lead;
  createMarketplaceRequest: MarketplaceRequest;
  createMarketplacerequestMatchInvoice: MarketplaceRequest;
  createMaterialsInvoice: Invoice;
  createMyOrganizationClientProfile: ClientProfile;
  createMyThirdPartyIntegrator: CreateThirdPartyIntegratorResponse;
  createNewCategory: Scalars['Boolean']['output'];
  createOrderForClient: Order;
  createOrderForClientProfile: Order;
  createOrderHandlingQuotation: OrderHandlingQuotation;
  createOrganization: Organization;
  createOrganizationFacility: OrganizationFacility;
  createOrganizationOneTimeRequest: OrganizationOneTimeRequest;
  /**
   * Create a new organization plan specification with Paystack plan codes for all subscription intervals
   * @deprecated Use createCustomOrganizationPlanSpec instead
   */
  createOrganizationPlanSpec: OrganizationPlanSpec;
  createOrganizationPlanSubscriptionChangeRequest: CreateOrganizationPlanSubscriptionChangeRequestResponse;
  createOrganizationTalentPool: OrganizationTalentPool;
  createOrganizationUser: OrganizationUser;
  createOrganizationUserInvite: CreateOrganizationUserInviteOutput;
  createOutreachSource: OutreachSource;
  createPayoutsForCallsThatAreNotPartOfAnyPayout: Array<SubscriptionRequestCallPayout>;
  createProApplication: ProApplication;
  createProCertificationResult: ProCertificationResult;
  createProFromInvite: Tradesman;
  createProRecruitmentContractsForMatch: ProRecruitmentContract;
  createProStudyWorkOpportunity: ProStudyWorkOpportunity;
  createProductFeedback: ProductFeedback;
  /** @deprecated Use createConstructionProjectRequestTask, createFacilityMaintenanceRequestTask, or createRenovationProjectRequestTask instead */
  createProjectOutsourcingTask: Scalars['String']['output'];
  createQuotation: ContractQuotation;
  createRecruitToolSalesConversationTask: Scalars['String']['output'];
  createRecruiterEarlyAccessInvite: RecruiterEarlyAccessInvite;
  createRecruiterJobApplication: EmployerJobApplication;
  createRecruiterJobApplicationLoggedIn: EmployerJobApplication;
  createRecruiterJobApplicationNotLoggedIn: EmployerJobApplication;
  createRecruitmentConsultationTask: Scalars['String']['output'];
  createRecruitmentPayroll: RecruitmentPayroll;
  createRecruitmentShortlist: RecruitmentJobShortlist;
  createReferral: DefaultResponse;
  createReferrer: Referrer;
  createRefundRequest: DefaultResponse;
  /** @deprecated Use `createTradesmanAssignmentReview` instead */
  createReview: DefaultResponse;
  createShortlist: MarketplaceJobShortlist;
  createSubCategory: Scalars['Boolean']['output'];
  createSubscription: SubscriptionRequest;
  createSubscriptionRequestCall: SubscriptionRequestCall;
  createTask: Scalars['Boolean']['output'];
  createThirdPartyIntegrator: CreateThirdPartyIntegratorResponse;
  createTrade: Trade;
  createTradesman: DefaultResponse;
  createTradesmanAssignmentReview: DefaultResponse;
  createTradesmanAssignmentReviewForClientProfile: Review;
  createTradesmanAssignmentVisit: TradesmanAssignmentVisit;
  createTrainingCommunityAdmin: TrainingCommunityAdmin;
  createTrainingCommunityMember: TrainingCommunityMember;
  createTrainingCommunityProfile: TrainingCommunityAdmin;
  createTrainingCommunityProgram: TrainingCommunityProgram;
  createTrainingEarlyAccessInvite: TrainingEarlyAccessInvite;
  declineEmploymentOffer: EmployerJobApplicationOffer;
  deleteAssignment: UpdateAssignmentResponse;
  deleteCategory: Scalars['String']['output'];
  deleteClient: Client;
  deleteMarketplaceRequest: MarketplaceRequest;
  deleteOrder: DefaultResponse;
  deletePro: Scalars['Boolean']['output'];
  deleteTrade: Trade;
  directChargeInvoice: Scalars['Boolean']['output'];
  disableOrganizationApiAccess: Scalars['Boolean']['output'];
  disableOrganizationUser?: Maybe<OrganizationUser>;
  /** Dry run the job ad notification digest. Returns what would be sent without actually sending emails or recording sends. Admin only. */
  dryRunJobAdNotificationDigest: JobAdNotificationDigestResponse;
  editAdmin: DefaultResponse;
  editCategory: Scalars['String']['output'];
  editCustomTask: Job;
  editInspectionInvoice: Invoice;
  editPortfolioCertification: PortfolioCertification;
  editPortfolioEducation: PortfolioEducation;
  editPortfolioEmploymentHistoryItem: PortfolioEmploymentHistoryItem;
  editPortfolioWorkHistoryItem: PortfolioWorkHistoryItem;
  editSubCategory: Scalars['String']['output'];
  editTask: Scalars['String']['output'];
  editTradesman: DefaultResponse;
  enableMyOrganizationProduct?: Maybe<Organization>;
  enableOrganizationApiAccess: EnableOrganizationApiAccessResponse;
  enableOrganizationUser?: Maybe<OrganizationUser>;
  enrollPaidAssessmentsNotEnrolled: Scalars['Float']['output'];
  ensureClientsHaveAppropriateRoles: Scalars['Boolean']['output'];
  finalizeAssignmentPayment: DefaultResponse;
  finalizeContractPayout: ContractPayout;
  finalizeHomeownerRequest: HomeownerRequest;
  finalizeHomeownerRequestAsHomeowner: HomeownerRequest;
  finalizeJobAdShortlist: Scalars['Boolean']['output'];
  finalizeJoinByCommunityInvite: FinalizeJoinByCommunityInviteResponse;
  finalizeReferrerPayout: ReferrerPayout;
  finalizeRefundRequest: DefaultResponse;
  finalizeSubscriptionRequestCallPayout: SubscriptionRequestCallPayout;
  finalizeThirdPartyIntegratorPayout: ThirdPartyIntegratorPayout;
  fixAccountActivations: Scalars['Boolean']['output'];
  fixDuplicateClientAccounts: Client;
  fixMaskedApplicantData: Scalars['Boolean']['output'];
  fixOplSoftskillsCompletionForPro: Scalars['Boolean']['output'];
  fixProTradeStart: ProTradeLevelPayment;
  generateExternalProviderPlans: Scalars['Boolean']['output'];
  generateFormBasedApplications: Array<EmployerJobApplication>;
  /** Generate all organization plan specifications (FREE, STANDARD, GROWTH) based on predefined constants. Skips plans that already exist. */
  generateOrganizationPlans: Array<OrganizationPlanSpec>;
  generatePortfolioOverview: Pro;
  generateSoftSkillsForOPLPros: Scalars['Boolean']['output'];
  generateTestPros: Array<Pro>;
  getInvoicePaymentLink: GetInvoicePaymentLinkResponse;
  getListOfCommunityOutReachOPLPros: Array<Scalars['String']['output']>;
  handleSuccessfulCardAuthorization: Scalars['Boolean']['output'];
  hideClientLocation: DefaultResponse;
  importCompletedOrder: Order;
  initialiseJoinByCommunityInvite: InitialiseJoinByCommunityInviteResponse;
  initializeCardAuthorizationForOrganization: InitializeCardAuthorizationResponse;
  initializeDirectDebitAuthorization: Scalars['String']['output'];
  initiateApplicantsUnlock: ApplicantUnlockResponse;
  initiateAssignmentPayment: DefaultResponse;
  /** Initiate a plan downgrade for the organization */
  initiateOrganizationPlanDowngrade: InitiateDowngradeResult;
  initiateProTradeLevelPayment: ProTradeLevelPayment;
  initiateProTradeLevelPaymentByPro: ProTradeLevelPayment;
  initiateProTradeRequirementRetake: ProTradeLevelPayment;
  initiateProTradeRequirementRetakeByPro: ProTradeLevelPayment;
  /** Initiate a wallet funding request. Returns Paystack checkout data for direct payment, or an invoice URL when generateInvoiceOnly is true. */
  initiateWalletFunding: WalletFundingResponse;
  linkExistingProsToTrainingCommunityMembersByEmail: Scalars['Boolean']['output'];
  logEvent: Scalars['Boolean']['output'];
  logOutOfLagosHomeownerRequestAttempt: Scalars['Boolean']['output'];
  markApplicationAsViewed: EmployerJobApplication;
  markBusinessAsApproved: AccountActivation;
  markOrganizationCommunityManagerAsPaid: Scalars['Boolean']['output'];
  markProCertificationAsUploaded: ProCertification;
  markProTradeRequirementAsProcessed: ProTradeRequirement;
  markRecruitmentShortlistedProAcceptance: RecruitmentJobShortlist;
  markRecruitmentShortlistedProDecline: RecruitmentJobShortlist;
  markShortlistedProAcceptance: MarketplaceJobShortlist;
  markShortlistedProDecline: MarketplaceJobShortlist;
  markTradesmanVisitArrival: TradesmanAssignmentVisit;
  markUse: ProTradeLevelDiscount;
  mergeAssignments: TradesmanAssignment;
  mergeClientAccounts: Client;
  mergeOrganizations: Organization;
  mergeSoftskillsProTradeRequirementsForPros: Array<Scalars['String']['output']>;
  migrateClientsToAuth0: Scalars['Boolean']['output'];
  modifyOrganizationUser: OrganizationUser;
  moveProsWithAValidAttemptToAwaitingResult: Scalars['Boolean']['output'];
  /** Notify the shortlist for a job ad */
  notifyEmployerJobAdShortlist: Scalars['Boolean']['output'];
  prefillPortfolioFromCV: PrefillPortfolioResponse;
  proJobCompleted: TradesmanAssignment;
  proJobInspected: TradesmanAssignment;
  proJobInspectionStart: TradesmanAssignment;
  proJobStart: TradesmanAssignment;
  processOplSoftskillsCompletionIfConfirmedForPros: Scalars['Boolean']['output'];
  publishCommunityAnnouncement: CommunityAnnouncement;
  /** Initiates a purchase of SMS credits and returns the checkout URL */
  purchaseSMSCredits: Scalars['String']['output'];
  reEnableOrganizationApiAccess: Scalars['Boolean']['output'];
  refreshProTradeLevelPayment: ProTradeLevelPayment;
  regenerateOrganizationCommunityInvite: OrganizationCommunityInviteResponse;
  registerBusinessAsAdmin: Business;
  registerNewClient: CreateClientResponse;
  rejectCommunityJobApplication: CommunityJobApplication;
  rejectEmployerJobApplication: EmployerJobApplication;
  rejectMyQuotation: OrderHandlingQuotation;
  rejectMyQuotationForClientProfile: OrderHandlingQuotation;
  rejectOrderHandlingQuotation: OrderHandlingQuotation;
  removeApplicationFromJobAdShortlistApproved: Scalars['Boolean']['output'];
  removeApplicationsFromJobAdShortlist: JobAdShortlist;
  removeEmployerJobApplicationFromShortlist: EmployerJobApplication;
  removePortfolioCertification: PortfolioCertification;
  removePortfolioEducation: PortfolioEducation;
  removePortfolioEmploymentHistoryItem: PortfolioEmploymentHistoryItem;
  removePortfolioWorkHistoryItem: PortfolioWorkHistoryItem;
  removeProFromMarketplaceJob: MarketplaceJob;
  removeProFromRecruitmentJob: RecruitmentJob;
  removeProTradeRequirementResult: ProTradeRequirement;
  removeSubscriptionRequestCallPayout: Scalars['Boolean']['output'];
  replaceProInMarketplaceJob: MarketplaceJob;
  replaceProInRecruitmentJob: RecruitmentJob;
  requestConstructionProject: Scalars['String']['output'];
  requestEmployerJobApplicationEnhancement: EmployerJobApplication;
  /** Request an enterprise plan. Creates a ClickUp task for the sales team. */
  requestEnterprisePlan: Scalars['Boolean']['output'];
  requestFacilityMaintenance: Scalars['String']['output'];
  requestOnDemandService: ServiceRequestResponse;
  requestOtherService: ServiceRequestResponse;
  requestRenovationProject: Scalars['String']['output'];
  rescheduleInterviewRequirement: ProTradeRequirement;
  resendActivationEmail: AccountActivation;
  resendOrganizationUserInvite: CreateOrganizationUserInviteOutput;
  resendWaitlistedBusinessVerificationCode: WaitlistedBusiness;
  resumeEmployerJobAd: EmployerJobAd;
  reviewContractPayout: ContractPayout;
  reviewReferrerPayout: ReferrerPayout;
  reviewRefundRequest: DefaultResponse;
  reviewSubscriptionRequestCallPayout: SubscriptionRequestCallPayout;
  reviewThirdPartyIntegratorPayout: ThirdPartyIntegratorPayout;
  reviewUnpaidProTradeRequirementResults: Scalars['Boolean']['output'];
  rotateMyOrganizationApiSecret: RotateOrganizationApiSecretResponse;
  rotateMyThirdPartyIntegratorSecret: Scalars['String']['output'];
  rotateOrganizationApiSecret: RotateOrganizationApiSecretResponse;
  /** Trigger the job ad notification digest. Runs in the background — returns immediately. Check logs for progress. Admin only. */
  runJobAdNotificationDigest: Scalars['Boolean']['output'];
  saveBusiness: Business;
  scheduleInterviewRequirementWithCrm: ProTradeRequirement;
  sendContractQuotation: ContractQuotation;
  sendInvoiceToClient: DefaultResponse;
  sendJobAdShortlist: Scalars['Boolean']['output'];
  sendMarketplaceRequestMatchReport: MarketplaceRequest;
  sendOneTimePasscode: Scalars['String']['output'];
  sendOrderHandlingQuotation: OrderHandlingQuotation;
  sendSubscriptionCardAuthorizationRequest: Scalars['String']['output'];
  sendSummaryToProReferrers: Scalars['Boolean']['output'];
  setCommunityJobApplicationEmploymentHiringTerms: CommunityJobApplication;
  setDefaultProPhoneNumber: Pro;
  setEmploymentHiringTerms: EmployerJobApplication;
  setLocationAsDefault: DefaultResponse;
  setOrganizationVerificationStatus: Organization;
  setPaymentForSplitPaymentInvoice: Invoice;
  setPreferredCourseForProStudyWorkOpportunity: ProStudyWorkOpportunity;
  setProPaymentAmountForSubscriptionRequestCall: SubscriptionRequestCall;
  setProProfileOverview: Pro;
  setRoleOnExistingPros: Scalars['Boolean']['output'];
  setTalentPoolCandidateHiringTerms: TalentPoolCandidate;
  shareOrganizationTalentPool: Scalars['Boolean']['output'];
  shortlistEmployerJobApplication: EmployerJobApplication;
  startAssessment: ProTradeRequirement;
  startBillingForRecruitment: ContractRecruitment;
  startContractPayout: ContractPayout;
  startHomeownerRequest: HomeownerRequest;
  startHomeownerRequestAsHomeowner: HomeownerRequest;
  startHomeownerRequestPayment: HomeownerRequest;
  /** Start a new organization plan subscription. Card may be optional if plan allows card-less trials. */
  startOrganizationPlanSubscription: OrganizationPlanSubscription;
  startPayoutForSubscriptionRequestCalls: Array<SubscriptionRequestCallPayout>;
  startProPhoneNumberVerification: Scalars['String']['output'];
  startReferrerPayoutForAllReferrers: Array<Scalars['String']['output']>;
  startTradeRequirementPayment: ProTradeRequirementPayment;
  startTrainingCommunityProgram: Scalars['Boolean']['output'];
  stopEmployerJobAd: EmployerJobAd;
  submitIdentityInformation: IdentityVerification;
  submitProApplication: ProApplication;
  syncInterviewRequirements: Scalars['Boolean']['output'];
  syncInvoiceDiscountUses: Scalars['Boolean']['output'];
  /** Sync organization plan subscription quota usage. Runs asynchronously. Admin only. */
  syncOrganizationPlanSubscriptionQuotaUsage: BackfillResponse;
  syncProsWithLMS: Scalars['Boolean']['output'];
  syncSubscriptionRequestCallPayoutAmount: SubscriptionRequestCallPayout;
  syncTradesmanUserData: Scalars['Boolean']['output'];
  systemAdminCreateOrganizationTalentPool: OrganizationTalentPool;
  systemAdminCreateOrganizationUserInvite: CreateOrganizationUserInviteOutput;
  /** System-admin emergency downgrade to free for broken expired-trial subscriptions */
  systemAdminForceDowngradeOrganizationToFreePlan: SystemAdminForceDowngradeOrganizationToFreeResult;
  systemAdminResendOrganizationUserInvite: CreateOrganizationUserInviteOutput;
  systemAdminShareOrganizationTalentPool: Scalars['Boolean']['output'];
  terminateProRecruitmentContract: ProRecruitmentContract;
  togglePortfolioEmploymentHistoryItemPin: PortfolioEmploymentHistoryItem;
  togglePortfolioWorkHistoryItemPin: PortfolioWorkHistoryItem;
  /** Transition all organizations on a plan spec to a new version (runs in background) */
  transitionAllOrganizationsPlanSpec: BulkPlanSpecTransitionJob;
  /** Transition a single organization to a new plan spec version within the same family */
  transitionOrganizationPlanSpec: TransitionOrganizationPlanSpecResult;
  triggerGuestJobApplicantRegistrationReminders: Scalars['Boolean']['output'];
  triggerOneMonthPassedThirdPartyIntegratorPayouts: Scalars['Boolean']['output'];
  unBlockAUser: Scalars['String']['output'];
  updateAdminRoles: Admin;
  updateAssignmentPayment: DefaultResponse;
  updateAssignmentProgress: UpdateAssignmentResponse;
  updateCertification: Certification;
  updateCertificationRequirement: CertificationRequirement;
  updateClient: Client;
  updateCommunityAnnouncement: CommunityAnnouncement;
  updateCommunityJobOpportunity: CommunityJobOpportunity;
  updateCommunitySegment: CommunitySegment;
  updateContractQuotationItems: ContractQuotation;
  updateContractRecruitment: ContractRecruitment;
  updateFullTimeProSalary: RecruitmentJobShortlist;
  updateGuestApplicantUserId: Scalars['Boolean']['output'];
  updateHomeownerRequest: HomeownerRequest;
  updateHomeownerRequestAsHomeowner: HomeownerRequest;
  updateIdentityVerification: IdentityVerification;
  updateJobAdNotificationPreferences: JobAdNotificationsPreferences;
  updateJobFinalCost: DefaultResponse;
  updateLeadSourceForProsFromOPL: Array<Scalars['String']['output']>;
  updateMaterialsInvoice: Invoice;
  updateMultipleJobInvoiceDetails: DefaultResponse;
  updateMyOrganizationWebhookUrl: Scalars['Boolean']['output'];
  updateMyProApplication: ProApplication;
  updatePreferences: Preferences;
  updatePro: Pro;
  updateProApplication: ProApplication;
  updateProCertification: ProCertification;
  updateProRecruitmentContract: ProRecruitmentContract;
  updateProStudyWorkOpportunity: ProStudyWorkOpportunity;
  updateTalentPoolInstanceCandidateStatus: TalentPoolCandidate;
  updateTrade: Trade;
  updateTrainingCommunityProgram: TrainingCommunityProgram;
  updateUnlockedApplicantNotes: Scalars['Boolean']['output'];
  uploadExistingReturnedPhotos: Scalars['Boolean']['output'];
  user: User;
  verifyAndLinkUserToWhatsappGeneratedPro: Pro;
  verifyProPhoneNumber: BasicResponse;
  verifyWaitlistedBusinessVerificationCode: WaitlistedBusiness;
  viewTalentPoolCandidate: TalentPoolCandidate;
  viewTalentPoolInstance: OrganizationTalentPoolInstance;
  waitlistBusiness: WaitlistedBusiness;
  waiveInspectionFee: UpdateAssignmentResponse;
};


export type MutationAcceptAgreementArgs = {
  product: Scalars['String']['input'];
  type: AgreementType;
};


export type MutationAcceptEmploymentOfferArgs = {
  id: Scalars['String']['input'];
};


export type MutationAcceptMyQuotationArgs = {
  id: Scalars['String']['input'];
};


export type MutationAcceptMyQuotationForClientProfileArgs = {
  id: Scalars['String']['input'];
};


export type MutationAcceptOrderHandlingQuotationArgs = {
  id: Scalars['String']['input'];
};


export type MutationAcceptOrganizationUserInviteArgs = {
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationActivateJobArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationActivateProRecruitmentContractArgs = {
  createProRecruitmentContractInput: CreateProRecruitmentContractInput;
};


export type MutationActivateSubscriptionWithCardArgs = {
  cardAuthorizationId: Scalars['String']['input'];
};


export type MutationAddApplicationToJobAdShortlistApprovedArgs = {
  applicationId: Scalars['String']['input'];
  shortlistId: Scalars['String']['input'];
};


export type MutationAddApplicationsToJobAdShortlistArgs = {
  applicationIds: Array<Scalars['String']['input']>;
  shortlistId: Scalars['String']['input'];
};


export type MutationAddCategorySubscriptionPackagePriceArgs = {
  intervalUpdates?: InputMaybe<Array<AddCategorySubscriptionPackagePriceIntervalChange>>;
  packageId: Scalars['String']['input'];
  serviceCharge: Scalars['Float']['input'];
  vendorFee: Scalars['Float']['input'];
};


export type MutationAddClientProfileToInvoiceDiscountInviteListArgs = {
  clientProfileId: Scalars['String']['input'];
  discountId: Scalars['String']['input'];
};


export type MutationAddClientToInvoiceDiscountInviteListArgs = {
  clientId: Scalars['String']['input'];
  discountId: Scalars['String']['input'];
};


export type MutationAddCommentToLogBookEntryArgs = {
  date: Scalars['String']['input'];
  logBookId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type MutationAddDiscountToProTradeLevelPaymentArgs = {
  discountCode: Scalars['String']['input'];
  tradeLevelPaymentId: Scalars['String']['input'];
};


export type MutationAddJobsToOrderArgs = {
  orderId: Scalars['String']['input'];
  payload: AddJobsToOrderInput;
};


export type MutationAddLocationArgs = {
  input: AddLocationInput;
};


export type MutationAddLocationForClientArgs = {
  input: AddLocationInput;
  userId: Scalars['String']['input'];
};


export type MutationAddOrganizationFacilityContactArgs = {
  payload: AddOrganizationFacilityContactInput;
};


export type MutationAddPaymentProviderInformationArgs = {
  payload: BankAccountInformationInput;
  userId: Scalars['String']['input'];
};


export type MutationAddPorfolioWorkHistoryItemArgs = {
  budget?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  endedAt: Scalars['DateTimeISO']['input'];
  images: Array<JobImage>;
  name: Scalars['String']['input'];
  proDoesNotWishToDiscloseBudget: Scalars['Boolean']['input'];
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  videos: Array<Scalars['String']['input']>;
};


export type MutationAddPortfolioCertificationArgs = {
  issuedAt: Scalars['DateTimeISO']['input'];
  issuedBy: Scalars['String']['input'];
  issuerCertificationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddPortfolioEducationArgs = {
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  qualification: EducationLevel;
  schoolName: Scalars['String']['input'];
};


export type MutationAddPortfolioEmploymentHistoryItemArgs = {
  companyName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  images: Array<JobImage>;
  jobTitle: Scalars['String']['input'];
  monthlySalary?: InputMaybe<Scalars['Float']['input']>;
  proDoesNotWishToDiscloseMonthlySalary: Scalars['Boolean']['input'];
  startedAt: Scalars['DateTimeISO']['input'];
};


export type MutationAddProPaymentInformationArgs = {
  payload: BankAccountInformationInput;
};


export type MutationAddProPaymentProviderInformationArgs = {
  payload: BankAccountInformationInput;
};


export type MutationAddProPaymentProviderInformationForProArgs = {
  payload: BankAccountInformationInput;
};


export type MutationAddProPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationAddProToAssignmentArgs = {
  assignmentId: Scalars['String']['input'];
  proId: Scalars['String']['input'];
};


export type MutationAddProToMarketplaceJobArgs = {
  marketplaceJobId: Scalars['String']['input'];
  proId: Scalars['String']['input'];
};


export type MutationAddProToRecruitmentJobArgs = {
  proId: Scalars['String']['input'];
  recruitmentId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};


export type MutationAddProTradeRequirementResultArgs = {
  passed: Scalars['Boolean']['input'];
  proTradeRequirementId: Scalars['String']['input'];
  scores: Array<Scalars['Int']['input']>;
};


export type MutationAddProsToRecruitmentShortlistArgs = {
  proIds: Array<Scalars['String']['input']>;
  recruitmentId: Scalars['String']['input'];
  recruitmentRequestId: Scalars['String']['input'];
};


export type MutationAddProsToShortlistArgs = {
  proIds: Array<Scalars['String']['input']>;
  shortlistId: Scalars['String']['input'];
};


export type MutationAddRewardPointChangeArgs = {
  data: AddRewardPointChangeInput;
};


export type MutationAddSubscriberArgs = {
  email: Scalars['String']['input'];
};


export type MutationAddThirdPartyIntegratorPolicyArgs = {
  accountNumber: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
  remittanceInterval: RemittanceInterval;
  serviceFeeSharePercentage: Scalars['Float']['input'];
  thirdPartyIntegratorId: Scalars['String']['input'];
};


export type MutationAddTrackToProArgs = {
  track: ProTrack;
};


export type MutationAddTradeToProArgs = {
  tradeId: Scalars['String']['input'];
};


export type MutationAddTrainingCommunityProgramLogBookEntryArgs = {
  entry: TrainingCommunityProgramLogBookEntryInput;
  logBookId: Scalars['String']['input'];
};


export type MutationAdminActivateEmployerJobAdArgs = {
  id: Scalars['String']['input'];
};


export type MutationAdminAddProPaymentInformationArgs = {
  payload: BankAccountInformationInput;
  proId: Scalars['String']['input'];
};


export type MutationAdminAddReferrerPaymentInformationArgs = {
  payload: BankAccountInformationInput;
  referrerId: Scalars['String']['input'];
};


export type MutationAdminChangeJobAdApplicationDeadlineArgs = {
  id: Scalars['String']['input'];
  newDeadline: Scalars['DateTimeISO']['input'];
};


export type MutationAdminCreateHomeownerArgs = {
  data: AdminCreateHomeownerInput;
};


export type MutationAdminDisableEmployerJobAdArgs = {
  id: Scalars['String']['input'];
};


export type MutationAdminInitiateWalletFundingArgs = {
  amount: Scalars['Float']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationAdminRejectEmployerJobAdArgs = {
  id: Scalars['String']['input'];
};


export type MutationAdminRemoveJobAdApplicationDeadlineArgs = {
  id: Scalars['String']['input'];
};


export type MutationAdminSendActiveJobAdNotificationsArgs = {
  dryRun?: Scalars['Boolean']['input'];
};


export type MutationAdminUpdateClientArgs = {
  data: EditClientInput;
};


export type MutationAdminUpdateHomeownerArgs = {
  data: AdminUpdateHomeownerInput;
};


export type MutationApplyInvoiceDiscountCodeArgs = {
  discountCode: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  invoiceType?: InputMaybe<InvoiceType>;
};


export type MutationApplyPlanSpecTransitionImmediatelyArgs = {
  args: ApplyPlanSpecTransitionImmediatelyArgs;
};


export type MutationApproveAssignmentPaymentArgs = {
  input: ApproveAssignmentPaymentInput;
};


export type MutationApproveContractPayoutArgs = {
  payoutId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};


export type MutationApproveContractQuotationArgs = {
  id: Scalars['String']['input'];
};


export type MutationApproveReferrerPayoutArgs = {
  payoutId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};


export type MutationApproveRefundRequestArgs = {
  input: ApproveRefundRequestInput;
};


export type MutationApproveSubscriptionRequestCallPayoutArgs = {
  payoutId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};


export type MutationApproveThirdPartyIntegratorPayoutArgs = {
  payoutId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};


export type MutationArchiveCommunityAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
};


export type MutationArchiveJobArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationAssignContractArgs = {
  contractId: Scalars['String']['input'];
  proId: Scalars['String']['input'];
  proposed: ProposedContractInfo;
};


export type MutationAssignJobsToTradesmanArgs = {
  data: AssignJobsToTradesmanInput;
};


export type MutationAssignProToSubscriptionRequestCallArgs = {
  proId: Scalars['String']['input'];
  subscriptionRequestCallId: Scalars['String']['input'];
};


export type MutationAssignTrainingCommunityProgramLogBookSupervisorArgs = {
  programId: Scalars['String']['input'];
  shadowUserId?: InputMaybe<Scalars['String']['input']>;
  shadowUserPayload?: InputMaybe<ShadowUserPayload>;
  startsAt: Scalars['DateTimeISO']['input'];
  studentIds: Array<Scalars['String']['input']>;
};


export type MutationAttachReferrerToClientArgs = {
  clientId: Scalars['String']['input'];
  referralCode: Scalars['String']['input'];
};


export type MutationBatchUpdateTalentPoolCandidateStatusArgs = {
  input: BatchUpdateCandidateStatusDto;
};


export type MutationBlockAUserArgs = {
  uid: Scalars['String']['input'];
};


export type MutationCancelEmploymentOfferArgs = {
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelInterviewRequirementEventArgs = {
  eventId: Scalars['String']['input'];
  proId: Scalars['String']['input'];
  tradeRequirementId: Scalars['String']['input'];
};


export type MutationCancelInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
};


export type MutationCancelMyInterviewRequirementArgs = {
  eventId: Scalars['String']['input'];
  tradeRequirementId: Scalars['String']['input'];
};


export type MutationCancelOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationCancelOrderHandlingQuotationArgs = {
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelOrganizationPlanDowngradeArgs = {
  intentId: Scalars['String']['input'];
};


export type MutationCancelOrganizationUserInviteArgs = {
  inviteId: Scalars['String']['input'];
};


export type MutationCancelRefundRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationCancelTradesmanVisitArgs = {
  reason: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};


export type MutationCancelTradesmanVisitForClientProfileArgs = {
  reason: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};


export type MutationCancelTransferRequestArgs = {
  data: CancelTransferRequestInput;
};


export type MutationChangeBusinessEmailArgs = {
  id: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
};


export type MutationChangeClientEmailArgs = {
  id: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
};


export type MutationChangeCustomTaskCategoryArgs = {
  categoryId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
};


export type MutationChangeDefaultAccountNumberArgs = {
  accountNumber: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationChangeDiscountedTradeArgs = {
  discountId: Scalars['String']['input'];
  proId: Scalars['String']['input'];
  tradeId: Scalars['String']['input'];
};


export type MutationChangeOrganizationPlanSubscriptionArgs = {
  cardAuthorizationId?: InputMaybe<Scalars['String']['input']>;
  interval: SubscriptionInterval;
  planId: Scalars['String']['input'];
};


export type MutationChangeOrganizationUserRoleArgs = {
  newRole: OrganizationUserRole;
  organizationUserId: Scalars['String']['input'];
};


export type MutationCheckAndUpdateOnboardingStatusArgs = {
  proId: Scalars['String']['input'];
};


export type MutationClientGenerateInspectionInvoiceArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationConfirmBrokenTransferArgs = {
  transferId: Scalars['String']['input'];
};


export type MutationConfirmHomeownerRequestPaymentArgs = {
  homeownerRequestId: Scalars['String']['input'];
  transactionReference: Scalars['String']['input'];
};


export type MutationConfirmInvoicePaymentArgs = {
  invoiceId: Scalars['String']['input'];
  transactionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationConfirmOfflineInvoicePaymentArgs = {
  amount: Scalars['Float']['input'];
  bankName: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
  transactionDate: Scalars['DateTimeISO']['input'];
  transactionReference: Scalars['String']['input'];
};


export type MutationConfirmOfflineTransferArgs = {
  bankName: Scalars['String']['input'];
  transactionDate: Scalars['DateTimeISO']['input'];
  transactionReference: Scalars['String']['input'];
  transferId: Scalars['String']['input'];
};


export type MutationConfirmProStudyWorkOpportunityPaymentArgs = {
  id: Scalars['String']['input'];
};


export type MutationConfirmProTradeLevelPaymentArgs = {
  tradeLevelPaymentId: Scalars['String']['input'];
};


export type MutationConfirmTradeRequirementPaymentArgs = {
  proTradeRequirementPaymentId: Scalars['String']['input'];
};


export type MutationCorrectOutsourcedJobAdOwningOrganizationArgs = {
  dryRun: Scalars['Boolean']['input'];
  organizationUserId: Scalars['String']['input'];
};


export type MutationCreateAdminArgs = {
  data: CreateAdminInput;
};


export type MutationCreateAgreementVersionArgs = {
  content: Scalars['String']['input'];
  product: Scalars['String']['input'];
  type: AgreementType;
};


export type MutationCreateAssignmentInspectionInvoiceArgs = {
  allowedPaymentProviders: Array<Scalars['String']['input']>;
  amount: Scalars['Float']['input'];
  assignmentId: Scalars['String']['input'];
};


export type MutationCreateBackgroundCheckForProArgs = {
  payload: CreateContactsInput;
  proId: Scalars['String']['input'];
};


export type MutationCreateCanadaBasicApplicationArgs = {
  payload: CreateCanadaBasicApplicationInput;
};


export type MutationCreateCertificationArgs = {
  payload: CreateCertificationInput;
};


export type MutationCreateClientArgs = {
  data: CreateClientInput;
};


export type MutationCreateCommunityAnnouncementArgs = {
  input: CreateCommunityAnnouncementInput;
};


export type MutationCreateCommunityJobApplicationArgs = {
  input: CreateCommunityJobApplicationDto;
};


export type MutationCreateCommunityJobOpportunityArgs = {
  input: CreateCommunityJobOpportunityInput;
};


export type MutationCreateCommunityManagementDemoRequestTaskArgs = {
  communityManagementDemoRequestDto: CommunityManagementDemoRequestDto;
};


export type MutationCreateCommunityManagementSalesConversationTaskArgs = {
  communityManagementSalesConversationRequestDto: CommunityManagementSalesConversationRequestDto;
};


export type MutationCreateCommunityManagerPaymentRequestArgs = {
  payload: CreateCommunityManagerPaymentRequestArgs;
};


export type MutationCreateCommunitySegmentArgs = {
  input: CreateCommunitySegmentInput;
};


export type MutationCreateContactsArgs = {
  payload: CreateContactsInput;
};


export type MutationCreateContractPayoutReimbursementInvoiceArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationCreateContractRecruitmentArgs = {
  data: CreateContractRecruitmentInput;
};


export type MutationCreateContractRecruitmentRequestMatchInvoiceArgs = {
  recruitmentId: Scalars['String']['input'];
  recruitmentRequestId: Scalars['String']['input'];
};


export type MutationCreateContractWorksheetArgs = {
  contractId: Scalars['String']['input'];
  expectedUnitAmount: Scalars['Float']['input'];
  payrollId: Scalars['String']['input'];
  unitAmount: Scalars['Float']['input'];
};


export type MutationCreateCustomOrganizationPlanSpecArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  intervalDiscounts: Array<IntervalDiscountInput>;
  monthlyBasePrice: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  product: OrganizationProduct;
  quotas: OrganizationPlanSpecQuotasInput;
  requiresCardForTrial?: InputMaybe<Scalars['Boolean']['input']>;
  smsCredits: Scalars['Float']['input'];
  trialLengthInDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateCustomSubscriptionRequestArgs = {
  accountType: CustomSubscriptionRequestAccountType;
  categoryId: Scalars['String']['input'];
  duration: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  specificRequirements: Scalars['String']['input'];
};


export type MutationCreateEmployerJobAdArgs = {
  applicationDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  area: Scalars['String']['input'];
  categoryIds: Array<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  description: Scalars['String']['input'];
  duration?: InputMaybe<DurationDetailsInput>;
  employmentType: EmploymentType;
  jobVisibility: JobVisibility;
  organizationDetails?: InputMaybe<CreateOrganizationDetailsInput>;
  principalId?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<SalaryDetailsInput>;
  state: Scalars['String']['input'];
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  thirdPartyDetails?: InputMaybe<ThirdPartyDetailsInput>;
  title: Scalars['String']['input'];
};


export type MutationCreateEmployerJobAdPrincipalArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateEmployerJobAdThirdPartyArgs = {
  name: Scalars['String']['input'];
  representedOrganizationId: Scalars['String']['input'];
};


export type MutationCreateEmploymentOfferArgs = {
  applicationId: Scalars['String']['input'];
  employmentType: EmploymentType;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  salary: Scalars['Float']['input'];
  startDate: Scalars['DateTimeISO']['input'];
};


export type MutationCreateEnquiryArgs = {
  accountType: AccountType;
  email: Scalars['String']['input'];
  joinedMailingList: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationCreateHomeownerArgs = {
  data: CreateHomeownerInput;
};


export type MutationCreateHomeownerRequestArgs = {
  categoryId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  otherCategoryText?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateIdentityVerificationArgs = {
  input: CreateIdentityVerificationDto;
};


export type MutationCreateInspectionInvoiceArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  orderId: Scalars['String']['input'];
};


export type MutationCreateInviteArgs = {
  input: CreateInviteInput;
};


export type MutationCreateJobAdNotificationPreferencesArgs = {
  categoryIds: Array<Scalars['String']['input']>;
  communicationMethods: Array<JobAdCommunicationMethod>;
  employmentTypes: Array<EmploymentType>;
};


export type MutationCreateJobAdShortlistVersionArgs = {
  jobAdId: Scalars['String']['input'];
};


export type MutationCreateLeadArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
};


export type MutationCreateMarketplaceRequestArgs = {
  payload: CreateMarketplaceRequestInput;
};


export type MutationCreateMarketplacerequestMatchInvoiceArgs = {
  id: Scalars['String']['input'];
};


export type MutationCreateMaterialsInvoiceArgs = {
  input: CreateMaterialsInvoiceInput;
};


export type MutationCreateMyOrganizationClientProfileArgs = {
  payload: CreateMyOrganizationClientProfileInput;
};


export type MutationCreateMyThirdPartyIntegratorArgs = {
  name: Scalars['String']['input'];
  webhookUrl: Scalars['String']['input'];
};


export type MutationCreateNewCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateOrderForClientArgs = {
  billingAddressId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationCreateOrderForClientProfileArgs = {
  billingAddressId: Scalars['String']['input'];
  clientProfileId: Scalars['String']['input'];
};


export type MutationCreateOrderHandlingQuotationArgs = {
  assignmentIds: Array<Scalars['String']['input']>;
  expiresAt: Scalars['DateTimeISO']['input'];
  items: Array<CreateOrderHandlingQuotationItem>;
  notes?: InputMaybe<Scalars['String']['input']>;
  sendImmediately?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateOrganizationArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  products?: InputMaybe<Array<OrganizationProduct>>;
};


export type MutationCreateOrganizationFacilityArgs = {
  payload: CreateOrganizationFacilityInput;
};


export type MutationCreateOrganizationOneTimeRequestArgs = {
  payload: CreateOrganizationOneTimeRequestInput;
};


export type MutationCreateOrganizationPlanSpecArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  familyCode: Scalars['String']['input'];
  intervalDiscounts: Array<IntervalDiscountInput>;
  isDefault?: Scalars['Boolean']['input'];
  monthlyBasePrice: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  product: OrganizationProduct;
  quotas: OrganizationPlanSpecQuotasInput;
  requiresCardForTrial?: InputMaybe<Scalars['Boolean']['input']>;
  smsCredits: Scalars['Float']['input'];
  trialLengthInDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateOrganizationPlanSubscriptionChangeRequestArgs = {
  interval: SubscriptionInterval;
  specId: Scalars['String']['input'];
};


export type MutationCreateOrganizationTalentPoolArgs = {
  input: CreateOrganizationTalentPoolDto;
};


export type MutationCreateOrganizationUserArgs = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  role?: InputMaybe<OrganizationUserRole>;
};


export type MutationCreateOrganizationUserInviteArgs = {
  email: Scalars['String']['input'];
  inviteRole?: InputMaybe<OrganizationUserRole>;
};


export type MutationCreateOutreachSourceArgs = {
  payload: OutreachSourceInput;
};


export type MutationCreateProApplicationArgs = {
  input: SubmitProApplicationInput;
};


export type MutationCreateProCertificationResultArgs = {
  certificationRequirementId: Scalars['String']['input'];
  proCertificationId: Scalars['String']['input'];
  score: Scalars['Int']['input'];
};


export type MutationCreateProFromInviteArgs = {
  input: CreateProFromInviteInput;
};


export type MutationCreateProRecruitmentContractsForMatchArgs = {
  recruitmentId: Scalars['String']['input'];
};


export type MutationCreateProStudyWorkOpportunityArgs = {
  opportunityId: Scalars['String']['input'];
};


export type MutationCreateProductFeedbackArgs = {
  createProductFeedbackDto: CreateProductFeedbackDto;
};


export type MutationCreateProjectOutsourcingTaskArgs = {
  projectOutsourcingDto: ProjectOutsourcingDto;
};


export type MutationCreateQuotationArgs = {
  contractRecruitmentId: Scalars['String']['input'];
  useLastQuote?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateRecruitToolSalesConversationTaskArgs = {
  recruitToolSalesConversationRequestDto: RecruitToolSalesConversationRequestDto;
};


export type MutationCreateRecruiterEarlyAccessInviteArgs = {
  email: Scalars['String']['input'];
};


export type MutationCreateRecruiterJobApplicationArgs = {
  input: CreateJobApplicationDto;
};


export type MutationCreateRecruiterJobApplicationLoggedInArgs = {
  input: CreateJobApplicationDto;
};


export type MutationCreateRecruiterJobApplicationNotLoggedInArgs = {
  input: CreateJobApplicationDto;
};


export type MutationCreateRecruitmentConsultationTaskArgs = {
  recruitmentConsultationDto: RecruitmentConsultationDto;
};


export type MutationCreateRecruitmentPayrollArgs = {
  period: RecruitmentPayrollPeriodInput;
  recruitmentId: Scalars['String']['input'];
};


export type MutationCreateRecruitmentShortlistArgs = {
  proIds: Array<Scalars['String']['input']>;
  recruitmentId: Scalars['String']['input'];
  recruitmentRequestId: Scalars['String']['input'];
};


export type MutationCreateReferralArgs = {
  referredEmail: Scalars['String']['input'];
};


export type MutationCreateReferrerArgs = {
  referrerInput: ReferrerInput;
};


export type MutationCreateRefundRequestArgs = {
  data: CreateRefundRequestInput;
};


export type MutationCreateReviewArgs = {
  input: CreateReviewInput;
};


export type MutationCreateShortlistArgs = {
  jobId: Scalars['String']['input'];
  proIds: Array<Scalars['String']['input']>;
};


export type MutationCreateSubCategoryArgs = {
  input: SubCategoryInput;
};


export type MutationCreateSubscriptionArgs = {
  address: Scalars['String']['input'];
  category: Scalars['String']['input'];
  client: Scalars['String']['input'];
  homeownerRequest: Scalars['String']['input'];
  plan: Scalars['String']['input'];
  price?: InputMaybe<Scalars['String']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


export type MutationCreateSubscriptionRequestCallArgs = {
  dateOfAssignment: Scalars['DateTimeISO']['input'];
  subscriptionRequest: Scalars['String']['input'];
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateThirdPartyIntegratorArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  homeownerId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  webhookUrl: Scalars['String']['input'];
};


export type MutationCreateTradeArgs = {
  payload: CreateTradeInput;
};


export type MutationCreateTradesmanArgs = {
  input: CreateTradesmanInput;
};


export type MutationCreateTradesmanAssignmentReviewArgs = {
  input: CreateReviewInput;
};


export type MutationCreateTradesmanAssignmentReviewForClientProfileArgs = {
  input: CreateReviewInput;
};


export type MutationCreateTradesmanAssignmentVisitArgs = {
  assignmentId: Scalars['String']['input'];
  reason: VisitReason;
  visitDate: Scalars['String']['input'];
};


export type MutationCreateTrainingCommunityAdminArgs = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  trainingCommunityDescription?: InputMaybe<Scalars['String']['input']>;
  trainingCommunityName: Scalars['String']['input'];
};


export type MutationCreateTrainingCommunityMemberArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTrainingCommunityProgramArgs = {
  payload: CreateTrainingCommunityProgramInput;
};


export type MutationCreateTrainingEarlyAccessInviteArgs = {
  email: Scalars['String']['input'];
};


export type MutationDeclineEmploymentOfferArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationDeleteAssignmentArgs = {
  assignmentId: Scalars['String']['input'];
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteClientArgs = {
  clientId: Scalars['String']['input'];
};


export type MutationDeleteMarketplaceRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationDeleteProArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTradeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDirectChargeInvoiceArgs = {
  entityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};


export type MutationDisableOrganizationApiAccessArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationDisableOrganizationUserArgs = {
  organizationUserId: Scalars['String']['input'];
};


export type MutationEditAdminArgs = {
  data: EditAdminInput;
};


export type MutationEditCategoryArgs = {
  input: EditCategoryInput;
};


export type MutationEditCustomTaskArgs = {
  input: EditCustomTaskInput;
};


export type MutationEditInspectionInvoiceArgs = {
  allowedPaymentProviders?: InputMaybe<Array<Scalars['String']['input']>>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  invoiceId: Scalars['String']['input'];
};


export type MutationEditPortfolioCertificationArgs = {
  id: Scalars['String']['input'];
  issuedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  issuedBy?: InputMaybe<Scalars['String']['input']>;
  issuerCertificationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditPortfolioEducationArgs = {
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  qualification?: InputMaybe<EducationLevel>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditPortfolioEmploymentHistoryItemArgs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  existingImageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  images?: InputMaybe<Array<JobImage>>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  monthlySalary?: InputMaybe<Scalars['Float']['input']>;
  proDoesNotWishToDiscloseMonthlySalary?: InputMaybe<Scalars['Boolean']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


export type MutationEditPortfolioWorkHistoryItemArgs = {
  budget?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  existingImageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  images?: InputMaybe<Array<JobImage>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proDoesNotWishToDiscloseBudget?: InputMaybe<Scalars['Boolean']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  videos?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationEditSubCategoryArgs = {
  input: EditSubCategoryInput;
};


export type MutationEditTaskArgs = {
  input: EditTaskInput;
};


export type MutationEditTradesmanArgs = {
  data: EditTradesmanInput;
};


export type MutationEnableMyOrganizationProductArgs = {
  product: OrganizationProduct;
};


export type MutationEnableOrganizationApiAccessArgs = {
  organizationId: Scalars['String']['input'];
  webhookUrl: Scalars['String']['input'];
};


export type MutationEnableOrganizationUserArgs = {
  organizationUserId: Scalars['String']['input'];
};


export type MutationFinalizeAssignmentPaymentArgs = {
  input: FinalizeAssignmentPaymentInput;
};


export type MutationFinalizeContractPayoutArgs = {
  otp: Scalars['String']['input'];
  payoutId: Scalars['String']['input'];
};


export type MutationFinalizeHomeownerRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationFinalizeHomeownerRequestAsHomeownerArgs = {
  id: Scalars['String']['input'];
};


export type MutationFinalizeJobAdShortlistArgs = {
  shortlistId: Scalars['String']['input'];
};


export type MutationFinalizeJoinByCommunityInviteArgs = {
  sessionToken: Scalars['String']['input'];
};


export type MutationFinalizeReferrerPayoutArgs = {
  otp: Scalars['String']['input'];
  payoutId: Scalars['String']['input'];
};


export type MutationFinalizeRefundRequestArgs = {
  id: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};


export type MutationFinalizeSubscriptionRequestCallPayoutArgs = {
  otp: Scalars['String']['input'];
  payoutId: Scalars['String']['input'];
};


export type MutationFinalizeThirdPartyIntegratorPayoutArgs = {
  otp: Scalars['String']['input'];
  payoutId: Scalars['String']['input'];
};


export type MutationFixDuplicateClientAccountsArgs = {
  clientId: Scalars['String']['input'];
};


export type MutationFixMaskedApplicantDataArgs = {
  applicationIds: Array<Scalars['String']['input']>;
};


export type MutationFixOplSoftskillsCompletionForProArgs = {
  proId: Scalars['String']['input'];
};


export type MutationFixProTradeStartArgs = {
  discountCode: Scalars['String']['input'];
  proId: Scalars['String']['input'];
  tradeId: Scalars['String']['input'];
};


export type MutationGenerateSoftSkillsForOplProsArgs = {
  emails: Array<Scalars['String']['input']>;
};


export type MutationGenerateTestProsArgs = {
  count?: Scalars['Float']['input'];
};


export type MutationGetInvoicePaymentLinkArgs = {
  callback?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationHandleSuccessfulCardAuthorizationArgs = {
  paymentId: Scalars['String']['input'];
};


export type MutationHideClientLocationArgs = {
  locationId: Scalars['String']['input'];
};


export type MutationImportCompletedOrderArgs = {
  input: ImportCompletedOrderInput;
};


export type MutationInitialiseJoinByCommunityInviteArgs = {
  input: InitialiseJoinByCommunityInviteInput;
};


export type MutationInitializeCardAuthorizationForOrganizationArgs = {
  planId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInitiateApplicantsUnlockArgs = {
  applicantIds: Array<Scalars['String']['input']>;
};


export type MutationInitiateAssignmentPaymentArgs = {
  input: InitiateAssignmentPaymentInput;
};


export type MutationInitiateOrganizationPlanDowngradeArgs = {
  args: InitiateOrganizationPlanDowngradeArgs;
};


export type MutationInitiateProTradeLevelPaymentArgs = {
  proId: Scalars['String']['input'];
  tradeLevelId: Scalars['String']['input'];
};


export type MutationInitiateProTradeLevelPaymentByProArgs = {
  tradeLevelId: Scalars['String']['input'];
};


export type MutationInitiateProTradeRequirementRetakeArgs = {
  proId: Scalars['String']['input'];
  tradeRequirementId: Scalars['String']['input'];
};


export type MutationInitiateProTradeRequirementRetakeByProArgs = {
  tradeRequirementId: Scalars['String']['input'];
};


export type MutationInitiateWalletFundingArgs = {
  amount: Scalars['Float']['input'];
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  generateInvoiceOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationLogEventArgs = {
  context: Array<LogEventContextFieldArgs>;
  event: EventTypes;
};


export type MutationLogOutOfLagosHomeownerRequestAttemptArgs = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  email: Scalars['String']['input'];
  homeownerRequestId: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type MutationMarkApplicationAsViewedArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkBusinessAsApprovedArgs = {
  contacts?: InputMaybe<Array<CreateBusinessClientInput>>;
  token: Scalars['String']['input'];
};


export type MutationMarkOrganizationCommunityManagerAsPaidArgs = {
  details: MarkOrganizationToolAsPaidDetails;
  organizationId: Scalars['String']['input'];
};


export type MutationMarkProCertificationAsUploadedArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkProTradeRequirementAsProcessedArgs = {
  proTradeRequirementId: Scalars['String']['input'];
};


export type MutationMarkRecruitmentShortlistedProAcceptanceArgs = {
  addToJob?: InputMaybe<Scalars['Boolean']['input']>;
  potentialMonthlyGrossSalary?: InputMaybe<Scalars['Float']['input']>;
  proId: Scalars['String']['input'];
  shortlistId: Scalars['String']['input'];
};


export type MutationMarkRecruitmentShortlistedProDeclineArgs = {
  proId: Scalars['String']['input'];
  shortlistId: Scalars['String']['input'];
};


export type MutationMarkShortlistedProAcceptanceArgs = {
  addToJob?: InputMaybe<Scalars['Boolean']['input']>;
  proId: Scalars['String']['input'];
  shortlistId: Scalars['String']['input'];
};


export type MutationMarkShortlistedProDeclineArgs = {
  proId: Scalars['String']['input'];
  shortlistId: Scalars['String']['input'];
};


export type MutationMarkTradesmanVisitArrivalArgs = {
  visitId: Scalars['String']['input'];
};


export type MutationMarkUseArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  proId: Scalars['String']['input'];
  proTradeLevelDiscountId: Scalars['String']['input'];
};


export type MutationMergeAssignmentsArgs = {
  sources: Array<Scalars['String']['input']>;
  target: Scalars['String']['input'];
};


export type MutationMergeClientAccountsArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  primaryId: Scalars['String']['input'];
  secondaryId: Scalars['String']['input'];
};


export type MutationMergeOrganizationsArgs = {
  organizationToMergeId: Scalars['String']['input'];
  primaryOrganizationId: Scalars['String']['input'];
};


export type MutationModifyOrganizationUserArgs = {
  email: Scalars['String']['input'];
  newAuth0UserId: Scalars['String']['input'];
  organizationUserAuth0Id: Scalars['String']['input'];
};


export type MutationNotifyEmployerJobAdShortlistArgs = {
  jobAdId: Scalars['String']['input'];
};


export type MutationPrefillPortfolioFromCvArgs = {
  certificationItems: Array<PrefillCertificationInput>;
  educationItems: Array<PrefillEducationInput>;
  employmentHistoryItems: Array<PrefillEmploymentInput>;
  professionalSummary?: InputMaybe<Scalars['String']['input']>;
  workHistoryItems: Array<PrefillWorkHistoryInput>;
};


export type MutationProJobCompletedArgs = {
  assignmentId: Scalars['String']['input'];
};


export type MutationProJobInspectedArgs = {
  assignmentId: Scalars['String']['input'];
};


export type MutationProJobInspectionStartArgs = {
  assignmentId: Scalars['String']['input'];
  checklist: ProAssignmentChecklistInput;
};


export type MutationProJobStartArgs = {
  assignmentId: Scalars['String']['input'];
  checklist: ProAssignmentChecklistInput;
};


export type MutationPublishCommunityAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
};


export type MutationPurchaseSmsCreditsArgs = {
  amount: Scalars['Float']['input'];
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReEnableOrganizationApiAccessArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationRefreshProTradeLevelPaymentArgs = {
  tradeLevelPaymentId: Scalars['String']['input'];
};


export type MutationRegisterBusinessAsAdminArgs = {
  input: RegisterBusinessInput;
};


export type MutationRegisterNewClientArgs = {
  data: RegisterNewClientInput;
};


export type MutationRejectCommunityJobApplicationArgs = {
  applicationId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectEmployerJobApplicationArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectMyQuotationArgs = {
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectMyQuotationForClientProfileArgs = {
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectOrderHandlingQuotationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveApplicationFromJobAdShortlistApprovedArgs = {
  applicationId: Scalars['String']['input'];
  shortlistId: Scalars['String']['input'];
};


export type MutationRemoveApplicationsFromJobAdShortlistArgs = {
  applicationIds: Array<Scalars['String']['input']>;
  shortlistId: Scalars['String']['input'];
};


export type MutationRemoveEmployerJobApplicationFromShortlistArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemovePortfolioCertificationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemovePortfolioEducationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemovePortfolioEmploymentHistoryItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemovePortfolioWorkHistoryItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveProFromMarketplaceJobArgs = {
  marketplaceJobId: Scalars['String']['input'];
  proId: Scalars['String']['input'];
};


export type MutationRemoveProFromRecruitmentJobArgs = {
  proId: Scalars['String']['input'];
  recruitmentId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};


export type MutationRemoveProTradeRequirementResultArgs = {
  attemptId: Scalars['Float']['input'];
  proTradeRequirementId: Scalars['String']['input'];
};


export type MutationRemoveSubscriptionRequestCallPayoutArgs = {
  payoutId: Scalars['String']['input'];
};


export type MutationReplaceProInMarketplaceJobArgs = {
  existingProId: Scalars['String']['input'];
  marketplaceJobId: Scalars['String']['input'];
  replacementProId: Scalars['String']['input'];
};


export type MutationReplaceProInRecruitmentJobArgs = {
  existingProId: Scalars['String']['input'];
  recruitmentId: Scalars['String']['input'];
  replacementProId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};


export type MutationRequestConstructionProjectArgs = {
  constructionProjectRequestDto: ConstructionProjectRequestDto;
};


export type MutationRequestEmployerJobApplicationEnhancementArgs = {
  id: Scalars['String']['input'];
};


export type MutationRequestEnterprisePlanArgs = {
  message: Scalars['String']['input'];
};


export type MutationRequestFacilityMaintenanceArgs = {
  facilityMaintenanceRequestDto: FacilityMaintenanceRequestDto;
};


export type MutationRequestOnDemandServiceArgs = {
  input: OnDemandServiceRequestInput;
};


export type MutationRequestOtherServiceArgs = {
  input: OtherServiceRequestInput;
};


export type MutationRequestRenovationProjectArgs = {
  renovationProjectRequestDto: RenovationProjectRequestDto;
};


export type MutationRescheduleInterviewRequirementArgs = {
  oldEventId: Scalars['String']['input'];
  proTradeRequirementId: Scalars['String']['input'];
  scheduledFor: Scalars['String']['input'];
};


export type MutationResendActivationEmailArgs = {
  accountActivationId: Scalars['String']['input'];
};


export type MutationResendOrganizationUserInviteArgs = {
  inviteId: Scalars['String']['input'];
};


export type MutationResendWaitlistedBusinessVerificationCodeArgs = {
  id: Scalars['String']['input'];
};


export type MutationResumeEmployerJobAdArgs = {
  id: Scalars['String']['input'];
};


export type MutationReviewContractPayoutArgs = {
  override?: InputMaybe<ContractPayoutOverrideInput>;
  payoutId: Scalars['String']['input'];
};


export type MutationReviewReferrerPayoutArgs = {
  override?: InputMaybe<ReferrerPayoutOverrideInput>;
  payoutId: Scalars['String']['input'];
};


export type MutationReviewRefundRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationReviewSubscriptionRequestCallPayoutArgs = {
  override?: InputMaybe<SubscriptionRequestCallPayoutOverrideInput>;
  payoutId: Scalars['String']['input'];
};


export type MutationReviewThirdPartyIntegratorPayoutArgs = {
  override?: InputMaybe<ThirdPartyIntegratorPayoutOverrideInput>;
  payoutId: Scalars['String']['input'];
};


export type MutationRotateOrganizationApiSecretArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationSaveBusinessArgs = {
  input: SaveBusinessInput;
};


export type MutationScheduleInterviewRequirementWithCrmArgs = {
  proTradeRequirementId: Scalars['String']['input'];
  scheduledFor: Scalars['String']['input'];
};


export type MutationSendContractQuotationArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendInvoiceToClientArgs = {
  invoiceId: Scalars['String']['input'];
};


export type MutationSendJobAdShortlistArgs = {
  shortlistId: Scalars['String']['input'];
};


export type MutationSendMarketplaceRequestMatchReportArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendOneTimePasscodeArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationSendOrderHandlingQuotationArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendSubscriptionCardAuthorizationRequestArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type MutationSetCommunityJobApplicationEmploymentHiringTermsArgs = {
  applicationId: Scalars['String']['input'];
  terms: EmploymentHiringTermsInput;
};


export type MutationSetDefaultProPhoneNumberArgs = {
  phoneNumberId: Scalars['String']['input'];
};


export type MutationSetEmploymentHiringTermsArgs = {
  applicationId: Scalars['String']['input'];
  terms: EmploymentHiringTermsInput;
};


export type MutationSetLocationAsDefaultArgs = {
  locationId: Scalars['String']['input'];
};


export type MutationSetOrganizationVerificationStatusArgs = {
  isVerified: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationSetPaymentForSplitPaymentInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
  splitPaymentIndex: Scalars['Int']['input'];
};


export type MutationSetPreferredCourseForProStudyWorkOpportunityArgs = {
  opportunityId: Scalars['String']['input'];
  preferredCourse: CanadaBasicApplicationCourseOfStudy;
};


export type MutationSetProPaymentAmountForSubscriptionRequestCallArgs = {
  paymentAmount: Scalars['Float']['input'];
  subscriptionRequestCallId: Scalars['String']['input'];
};


export type MutationSetProProfileOverviewArgs = {
  overview: Scalars['String']['input'];
};


export type MutationSetTalentPoolCandidateHiringTermsArgs = {
  candidateId: Scalars['String']['input'];
  terms: TalentPoolHiringTermsInput;
};


export type MutationShareOrganizationTalentPoolArgs = {
  input: ShareOrganizationTalentPoolDto;
};


export type MutationShortlistEmployerJobApplicationArgs = {
  id: Scalars['String']['input'];
};


export type MutationStartAssessmentArgs = {
  proTradeRequirementId: Scalars['String']['input'];
};


export type MutationStartBillingForRecruitmentArgs = {
  input: StartBillingForRecruitmentInput;
};


export type MutationStartContractPayoutArgs = {
  worksheetId: Scalars['String']['input'];
};


export type MutationStartHomeownerRequestArgs = {
  categoryId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  otherCategoryText?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartHomeownerRequestAsHomeownerArgs = {
  categoryId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  otherCategoryText?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartHomeownerRequestPaymentArgs = {
  discountCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationStartOrganizationPlanSubscriptionArgs = {
  cardAuthorizationId?: InputMaybe<Scalars['String']['input']>;
  interval: SubscriptionInterval;
  planId: Scalars['String']['input'];
};


export type MutationStartPayoutForSubscriptionRequestCallsArgs = {
  period: MonthYearInput;
};


export type MutationStartProPhoneNumberVerificationArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationStartReferrerPayoutForAllReferrersArgs = {
  period: MonthYearInput;
};


export type MutationStartTradeRequirementPaymentArgs = {
  tradeRequirementId: Scalars['String']['input'];
};


export type MutationStartTrainingCommunityProgramArgs = {
  programId: Scalars['String']['input'];
};


export type MutationStopEmployerJobAdArgs = {
  id: Scalars['String']['input'];
};


export type MutationSubmitIdentityInformationArgs = {
  input: SubmitIdentityInformationInput;
};


export type MutationSubmitProApplicationArgs = {
  input: SubmitProApplicationInput;
};


export type MutationSyncSubscriptionRequestCallPayoutAmountArgs = {
  payoutId: Scalars['String']['input'];
};


export type MutationSystemAdminCreateOrganizationTalentPoolArgs = {
  input: SystemAdminCreateOrganizationTalentPoolDto;
};


export type MutationSystemAdminCreateOrganizationUserInviteArgs = {
  email: Scalars['String']['input'];
  inviteRole: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationSystemAdminForceDowngradeOrganizationToFreePlanArgs = {
  args: SystemAdminForceDowngradeOrganizationToFreeArgs;
};


export type MutationSystemAdminResendOrganizationUserInviteArgs = {
  inviteId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationSystemAdminShareOrganizationTalentPoolArgs = {
  input: SystemAdminShareOrganizationTalentPoolDto;
};


export type MutationTerminateProRecruitmentContractArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationTogglePortfolioEmploymentHistoryItemPinArgs = {
  id: Scalars['String']['input'];
};


export type MutationTogglePortfolioWorkHistoryItemPinArgs = {
  id: Scalars['String']['input'];
};


export type MutationTransitionAllOrganizationsPlanSpecArgs = {
  args: TransitionAllOrganizationsPlanSpecArgs;
};


export type MutationTransitionOrganizationPlanSpecArgs = {
  args: TransitionOrganizationPlanSpecArgs;
};


export type MutationUnBlockAUserArgs = {
  uid: Scalars['String']['input'];
};


export type MutationUpdateAdminRolesArgs = {
  id: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']>;
};


export type MutationUpdateAssignmentPaymentArgs = {
  input: UpdateAssignmentPaymentInput;
};


export type MutationUpdateAssignmentProgressArgs = {
  assignmentId: Scalars['String']['input'];
  progress: AssignmentProgress;
};


export type MutationUpdateCertificationArgs = {
  payload: UpdateCertificationInput;
};


export type MutationUpdateCertificationRequirementArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lmsCourseExternalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  passingScore?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateClientArgs = {
  payload: EditClientInput;
};


export type MutationUpdateCommunityAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
  input: UpdateCommunityAnnouncementInput;
};


export type MutationUpdateCommunityJobOpportunityArgs = {
  input: UpdateCommunityJobOpportunityInput;
  jobOpportunityId: Scalars['String']['input'];
};


export type MutationUpdateCommunitySegmentArgs = {
  input: UpdateCommunitySegmentInput;
  segmentId: Scalars['String']['input'];
};


export type MutationUpdateContractQuotationItemsArgs = {
  input: UpdateContractQuotationItemsInput;
};


export type MutationUpdateContractRecruitmentArgs = {
  update: UpdateContractRecruitmentInput;
};


export type MutationUpdateFullTimeProSalaryArgs = {
  potentialMonthlyGrossSalary: Scalars['Float']['input'];
  proId: Scalars['String']['input'];
  shortlistId: Scalars['String']['input'];
};


export type MutationUpdateGuestApplicantUserIdArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateHomeownerRequestArgs = {
  address?: InputMaybe<AddressInput>;
  addressId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<HomeownerRequestTaskFrequency>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  leadSource?: InputMaybe<LeadSource>;
  otherCategoryText?: InputMaybe<Scalars['String']['input']>;
  otherLeadSourceText?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


export type MutationUpdateHomeownerRequestAsHomeownerArgs = {
  address?: InputMaybe<AddressInput>;
  addressId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<HomeownerRequestTaskFrequency>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  leadSource?: InputMaybe<LeadSource>;
  otherCategoryText?: InputMaybe<Scalars['String']['input']>;
  otherLeadSourceText?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


export type MutationUpdateIdentityVerificationArgs = {
  id: Scalars['String']['input'];
  identificationDocument?: InputMaybe<Scalars['String']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<IdentityVerificationStatus>;
  type?: InputMaybe<MeansOfIdentification>;
};


export type MutationUpdateJobAdNotificationPreferencesArgs = {
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  communicationMethods?: InputMaybe<Array<JobAdCommunicationMethod>>;
  employmentTypes?: InputMaybe<Array<EmploymentType>>;
};


export type MutationUpdateJobFinalCostArgs = {
  data: UpdateJobFinalCostInput;
};


export type MutationUpdateMaterialsInvoiceArgs = {
  input: UpdateMaterialsInvoiceInput;
};


export type MutationUpdateMultipleJobInvoiceDetailsArgs = {
  data: UpdateJobsInvoiceDetailsInput;
};


export type MutationUpdateMyOrganizationWebhookUrlArgs = {
  webhookUrl: Scalars['String']['input'];
};


export type MutationUpdateMyProApplicationArgs = {
  acquisitionChannel?: InputMaybe<Scalars['String']['input']>;
  acquisitionChannelText?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  averageMonthlyIncome?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  channelOutreachSourceId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currentIndustry?: InputMaybe<Industry>;
  customTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dateOfBirth?: InputMaybe<Scalars['DateTimeISO']['input']>;
  detailedAddress?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<EmploymentStatus>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  hasInternationalPassport?: InputMaybe<Scalars['Boolean']['input']>;
  highestEducationLevel?: InputMaybe<EducationLevel>;
  id?: InputMaybe<Scalars['String']['input']>;
  incomeCurrency?: InputMaybe<Scalars['String']['input']>;
  incomeLevel?: InputMaybe<IncomeLevel>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leadSource?: InputMaybe<Scalars['String']['input']>;
  leadSourceText?: InputMaybe<Scalars['String']['input']>;
  locationOutreachSourceId?: InputMaybe<Scalars['String']['input']>;
  numberOfDaysWorkedPerWeek?: InputMaybe<Scalars['Float']['input']>;
  otherCategoryText?: InputMaybe<Scalars['String']['input']>;
  otherOccupationText?: InputMaybe<Scalars['String']['input']>;
  otherRelevantDocumentUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  passportExpiryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  passportIssueAuthority?: InputMaybe<Scalars['String']['input']>;
  passportIssueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneType?: InputMaybe<PhoneType>;
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  reasonForJoiningLaborHack?: InputMaybe<Scalars['String']['input']>;
  reasonForJoiningLaborHackOtherText?: InputMaybe<Scalars['String']['input']>;
  reasonsForJoiningLaborHack?: InputMaybe<Array<Scalars['String']['input']>>;
  referredBy?: InputMaybe<Scalars['String']['input']>;
  resumeUrl?: InputMaybe<Scalars['String']['input']>;
  stateOfResidence?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  trainingType?: InputMaybe<TrainingType>;
  yearOfGraduation?: InputMaybe<Scalars['Int']['input']>;
  yearsOfExperience?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdatePreferencesArgs = {
  payload: PreferencesInput;
};


export type MutationUpdateProArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProApplicationArgs = {
  acquisitionChannel?: InputMaybe<Scalars['String']['input']>;
  acquisitionChannelText?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  averageMonthlyIncome?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  channelOutreachSourceId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currentIndustry?: InputMaybe<Industry>;
  customTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dateOfBirth?: InputMaybe<Scalars['DateTimeISO']['input']>;
  detailedAddress?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<EmploymentStatus>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  hasInternationalPassport?: InputMaybe<Scalars['Boolean']['input']>;
  highestEducationLevel?: InputMaybe<EducationLevel>;
  id?: InputMaybe<Scalars['String']['input']>;
  incomeCurrency?: InputMaybe<Scalars['String']['input']>;
  incomeLevel?: InputMaybe<IncomeLevel>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leadSource?: InputMaybe<Scalars['String']['input']>;
  leadSourceText?: InputMaybe<Scalars['String']['input']>;
  locationOutreachSourceId?: InputMaybe<Scalars['String']['input']>;
  numberOfDaysWorkedPerWeek?: InputMaybe<Scalars['Float']['input']>;
  otherCategoryText?: InputMaybe<Scalars['String']['input']>;
  otherOccupationText?: InputMaybe<Scalars['String']['input']>;
  otherRelevantDocumentUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  passportExpiryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  passportIssueAuthority?: InputMaybe<Scalars['String']['input']>;
  passportIssueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneType?: InputMaybe<PhoneType>;
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  reasonForJoiningLaborHack?: InputMaybe<Scalars['String']['input']>;
  reasonForJoiningLaborHackOtherText?: InputMaybe<Scalars['String']['input']>;
  reasonsForJoiningLaborHack?: InputMaybe<Array<Scalars['String']['input']>>;
  referredBy?: InputMaybe<Scalars['String']['input']>;
  resumeUrl?: InputMaybe<Scalars['String']['input']>;
  stateOfResidence?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  trainingType?: InputMaybe<TrainingType>;
  yearOfGraduation?: InputMaybe<Scalars['Int']['input']>;
  yearsOfExperience?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateProCertificationArgs = {
  id: Scalars['String']['input'];
  uploadedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


export type MutationUpdateProRecruitmentContractArgs = {
  contractId: Scalars['String']['input'];
  update: UpdateProRecruitmentContractInput;
};


export type MutationUpdateProStudyWorkOpportunityArgs = {
  preferredCourse?: InputMaybe<CanadaBasicApplicationCourseOfStudy>;
};


export type MutationUpdateTalentPoolInstanceCandidateStatusArgs = {
  input: UpdateCandidateStatusDto;
};


export type MutationUpdateTradeArgs = {
  id: Scalars['String']['input'];
  payload: UpdateTradeInput;
};


export type MutationUpdateTrainingCommunityProgramArgs = {
  payload: UpdateTrainingCommunityProgramInput;
};


export type MutationUpdateUnlockedApplicantNotesArgs = {
  notes: Scalars['String']['input'];
  unlockRecordId: Scalars['String']['input'];
};


export type MutationUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyAndLinkUserToWhatsappGeneratedProArgs = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationVerifyProPhoneNumberArgs = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationVerifyWaitlistedBusinessVerificationCodeArgs = {
  code: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationViewTalentPoolCandidateArgs = {
  id: Scalars['String']['input'];
};


export type MutationViewTalentPoolInstanceArgs = {
  id: Scalars['String']['input'];
};


export type MutationWaitlistBusinessArgs = {
  input: CreateWaitlistedBusinessInput;
};


export type MutationWaiveInspectionFeeArgs = {
  assignmentId: Scalars['String']['input'];
};

export type MyOrganizationJobAdEdge = Edge & {
  __typename?: 'MyOrganizationJobAdEdge';
  cursor: Scalars['String']['output'];
  node: EmployerJobAd;
};

export type MyOrganizationJobAdsResponse = Edges & {
  __typename?: 'MyOrganizationJobAdsResponse';
  edges: Array<MyOrganizationJobAdEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type MyOrganizationJobAdsStats = {
  __typename?: 'MyOrganizationJobAdsStats';
  active: Scalars['Float']['output'];
  inactive: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

/** Filter for organization job ads by status */
export enum MyOrganizationJobAdsStatusFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Inactive = 'INACTIVE'
}

export type NextInvoicePayment = {
  __typename?: 'NextInvoicePayment';
  discount?: Maybe<Scalars['Float']['output']>;
  labor?: Maybe<Scalars['Float']['output']>;
  laborCommission?: Maybe<Scalars['Float']['output']>;
  laborHackFee?: Maybe<Scalars['Float']['output']>;
  materialCommission?: Maybe<Scalars['Float']['output']>;
  materials?: Maybe<Scalars['Float']['output']>;
  nextPaymentPercentage: Scalars['Float']['output'];
  serviceCharge?: Maybe<Scalars['Float']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
  transactionFee?: Maybe<Scalars['Float']['output']>;
};

export enum NotificationEvent {
  InvoicePaid = 'INVOICE_PAID',
  InvoiceRaised = 'INVOICE_RAISED',
  ProDispatched = 'PRO_DISPATCHED',
  RecruitmentRequested = 'RECRUITMENT_REQUESTED',
  SubscriptionRequested = 'SUBSCRIPTION_REQUESTED'
}

export type NotificationPayload = {
  event: NotificationEvent;
  order: NotificationPayloadOrder;
};

export type NotificationPayloadInvoice = {
  __typename?: 'NotificationPayloadInvoice';
  amount: Scalars['Float']['output'];
  invoiceId: Scalars['String']['output'];
  invoiceNumber: Scalars['Float']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type NotificationPayloadLocation = {
  __typename?: 'NotificationPayloadLocation';
  id: Scalars['String']['output'];
  locationText: Scalars['String']['output'];
};

export type NotificationPayloadOrder = {
  __typename?: 'NotificationPayloadOrder';
  id: Scalars['String']['output'];
  orderCode: Scalars['String']['output'];
};

export type NotificationPayloadPro = {
  __typename?: 'NotificationPayloadPro';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NotificationPayloadText = {
  __typename?: 'NotificationPayloadText';
  body: Scalars['String']['output'];
};

export type OnDemandServiceRequestInput = {
  address: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  services: Array<Scalars['String']['input']>;
  visitDate: Scalars['DateTimeISO']['input'];
};

/** The Order Model */
export type Order = {
  __typename?: 'Order';
  address?: Maybe<Address>;
  assignments: Array<TradesmanAssignment>;
  billingAddress: Location;
  client?: Maybe<OrderUser>;
  clientProfile?: Maybe<ClientProfile>;
  completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdByUid?: Maybe<Scalars['String']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  homeownerRequest?: Maybe<HomeownerRequest>;
  id: Scalars['String']['output'];
  inspectionPayment?: Maybe<Payment>;
  isEmergency?: Maybe<Scalars['Boolean']['output']>;
  isImported?: Maybe<Scalars['Boolean']['output']>;
  jobs: Array<Job>;
  locationSchedules: Array<LocationSchedule>;
  orderCode: Scalars['String']['output'];
  owner?: Maybe<Client>;
  status: OrderStatus;
  suggestedTradesmen?: Maybe<Array<Tradesman>>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrderCartItem = {
  custom?: InputMaybe<JobCustomTaskInput>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  task?: InputMaybe<JobTaskInput>;
};

export type OrderEdge = Edge & {
  __typename?: 'OrderEdge';
  cursor: Scalars['String']['output'];
  node: AggregateOrder;
};

export type OrderFilterInput = {
  condition: Array<Scalars['String']['input']>;
  type: OrderFilterType;
};

export enum OrderFilterType {
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  CreatedBetween = 'CREATED_BETWEEN',
  Pending = 'PENDING',
  Unassigned = 'UNASSIGNED'
}

export type OrderHandlingQuotation = {
  __typename?: 'OrderHandlingQuotation';
  acceptedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  assignments: Array<TradesmanAssignment>;
  cancelledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  client: Client;
  clientProfile?: Maybe<ClientProfile>;
  costBreakdown: OrderHandlingQuotationCostBreakdown;
  createdAt: Scalars['DateTimeISO']['output'];
  declinedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  expiresAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  invoice?: Maybe<Invoice>;
  isInUse?: Maybe<Scalars['Boolean']['output']>;
  items: Array<OrderHandlingQuotationItem>;
  notes?: Maybe<Scalars['String']['output']>;
  order: Order;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTimeISO']['output']>;
  serialNumber: Scalars['Int']['output'];
  status: OrderHandlingQuotationStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrderHandlingQuotationCostBreakdown = {
  __typename?: 'OrderHandlingQuotationCostBreakdown';
  discount: Scalars['Float']['output'];
  laborCommission: Scalars['Float']['output'];
  laborFee: Scalars['Float']['output'];
  laborHackFee: Scalars['Float']['output'];
  materialCommission: Scalars['Float']['output'];
  subTotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  totalMaterialsCost: Scalars['Float']['output'];
};

export type OrderHandlingQuotationItem = {
  __typename?: 'OrderHandlingQuotationItem';
  job: Job;
  labor?: Maybe<Scalars['Float']['output']>;
  materials?: Maybe<Array<OrderHandlingQuotationItemMaterial>>;
  serviceCharge?: Maybe<Scalars['Float']['output']>;
};

export type OrderHandlingQuotationItemMaterial = {
  __typename?: 'OrderHandlingQuotationItemMaterial';
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  unitPrice: Scalars['Float']['output'];
};

export enum OrderHandlingQuotationStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type OrderSearchInput = {
  query: Scalars['String']['input'];
  type: OrderSearchType;
};

export enum OrderSearchType {
  ClientName = 'CLIENT_NAME',
  OrderCode = 'ORDER_CODE'
}

export type OrderSortInput = {
  ascending: Scalars['Boolean']['input'];
  type: OrderSortType;
};

export enum OrderSortType {
  ClientName = 'CLIENT_NAME',
  OrderCode = 'ORDER_CODE'
}

export type OrderStatistics = {
  __typename?: 'OrderStatistics';
  all: Scalars['Float']['output'];
  new: Scalars['Float']['output'];
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Processing = 'PROCESSING'
}

export type OrderUsageStatistics = {
  __typename?: 'OrderUsageStatistics';
  all: Scalars['Int']['output'];
  done: Scalars['Int']['output'];
  inProgress: Scalars['Int']['output'];
  processing: Scalars['Int']['output'];
};

export type OrderUser = {
  __typename?: 'OrderUser';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  agreements: Array<AgreementAcceptance>;
  apiAccess?: Maybe<OrganizationApiAccess>;
  canPostPrivateJobs: Scalars['Boolean']['output'];
  cardAuthorizations: Array<CardAuthorization>;
  communityManagerSubscription?: Maybe<CommunityManagerSubscription>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  products: Array<OrganizationProduct>;
  referralCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrganizationAgreement = {
  __typename?: 'OrganizationAgreement';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  hash: Scalars['String']['output'];
  id: Scalars['String']['output'];
  product: Scalars['String']['output'];
  status: OrganizationAgreementStatus;
  type: AgreementType;
  updatedAt: Scalars['DateTimeISO']['output'];
  versionNumber: Scalars['Float']['output'];
};

export enum OrganizationAgreementStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type OrganizationApiAccess = {
  __typename?: 'OrganizationApiAccess';
  appId: Scalars['String']['output'];
  enabledAt: Scalars['DateTimeISO']['output'];
  isEnabled: Scalars['Boolean']['output'];
  webhookUrl: Scalars['String']['output'];
};

export type OrganizationClientProfileBillingAddressInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type OrganizationCommunityInviteResponse = {
  __typename?: 'OrganizationCommunityInviteResponse';
  generatedAt: Scalars['DateTimeISO']['output'];
  inviteUrl: Scalars['String']['output'];
};

export type OrganizationFacility = {
  __typename?: 'OrganizationFacility';
  address: Address;
  contacts: Array<OrganizationFacilityContact>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrganizationFacilityAddressInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type OrganizationFacilityContact = {
  __typename?: 'OrganizationFacilityContact';
  createdAt: Scalars['DateTimeISO']['output'];
  email?: Maybe<Scalars['String']['output']>;
  facility: OrganizationFacility;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrganizationInfoInput = {
  industry?: InputMaybe<Scalars['String']['input']>;
  organization: Scalars['String']['input'];
  roleInOrganization: Scalars['String']['input'];
};

export type OrganizationOneTimeRequest = {
  __typename?: 'OrganizationOneTimeRequest';
  category?: Maybe<Category>;
  clientProfile: ClientProfile;
  closedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  facility: OrganizationFacility;
  facilityAddressSnapshot: OrganizationRequestAddressSnapshot;
  facilityContact: OrganizationFacilityContact;
  facilityContactEmailSnapshot?: Maybe<Scalars['String']['output']>;
  facilityContactNameSnapshot: Scalars['String']['output'];
  facilityContactPhoneSnapshot: Scalars['String']['output'];
  facilityNameSnapshot: Scalars['String']['output'];
  finalizedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  generatedOrderContactNote?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isComplete: Scalars['Boolean']['output'];
  legacyClient: Client;
  order: Order;
  organization: Organization;
  otherCategoryText?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTimeISO']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrganizationPartnership = {
  __typename?: 'OrganizationPartnership';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  organization: Organization;
  partnerOrganizationCountryCode: Scalars['String']['output'];
  partnerOrganizationName: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrganizationPartnershipShadowUser = {
  __typename?: 'OrganizationPartnershipShadowUser';
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partnership: OrganizationPartnership;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrganizationPlanDowngradeIntent = {
  __typename?: 'OrganizationPlanDowngradeIntent';
  createdAt: Scalars['DateTimeISO']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initiatedBy?: Maybe<OrganizationUser>;
  interval: SubscriptionInterval;
  isExternalCancellation: Scalars['Boolean']['output'];
  organization: Organization;
  processedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  resultingSubscription?: Maybe<OrganizationPlanSubscription>;
  scheduledFor?: Maybe<Scalars['DateTimeISO']['output']>;
  sourceProviderCode?: Maybe<Scalars['String']['output']>;
  sourceSubscription: OrganizationPlanSubscription;
  status: DowngradeIntentStatus;
  targetSpec: OrganizationPlanSpec;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrganizationPlanSpec = {
  __typename?: 'OrganizationPlanSpec';
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  familyCode: Scalars['String']['output'];
  gatewayProviderIntervalPlanCodes: OrganizationPlanSpecGatewayProviderIntervalPlanCodes;
  id: Scalars['String']['output'];
  intervalDiscounts: Array<IntervalDiscount>;
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  monthlyBasePrice: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  product: OrganizationProduct;
  quotas: OrganizationPlanSpecQuotas;
  requiresCardForTrial?: Maybe<Scalars['Boolean']['output']>;
  smsCredits: Scalars['Float']['output'];
  trialLengthInDays?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  version: Scalars['Int']['output'];
};

export type OrganizationPlanSpecGatewayProviderIntervalPlanCodes = {
  __typename?: 'OrganizationPlanSpecGatewayProviderIntervalPlanCodes';
  MONTHLY: Scalars['String']['output'];
  YEARLY: Scalars['String']['output'];
};

export type OrganizationPlanSpecQuota = {
  __typename?: 'OrganizationPlanSpecQuota';
  limit: Scalars['Int']['output'];
  type: OrganizationPlanSpecQuotaType;
};

export type OrganizationPlanSpecQuotaInput = {
  limit: Scalars['Int']['input'];
  type: OrganizationPlanSpecQuotaType;
};

export enum OrganizationPlanSpecQuotaType {
  Concurrent = 'CONCURRENT',
  Persistent = 'PERSISTENT',
  Recurring = 'RECURRING'
}

export type OrganizationPlanSpecQuotas = {
  __typename?: 'OrganizationPlanSpecQuotas';
  activeAdverts: OrganizationPlanSpecQuota;
  adminSeats: OrganizationPlanSpecQuota;
  communityMembers: OrganizationPlanSpecQuota;
  connections: OrganizationPlanSpecQuota;
};

export type OrganizationPlanSpecQuotasInput = {
  activeAdverts: OrganizationPlanSpecQuotaInput;
  adminSeats: OrganizationPlanSpecQuotaInput;
  communityMembers: OrganizationPlanSpecQuotaInput;
  connections: OrganizationPlanSpecQuotaInput;
};

export type OrganizationPlanSpecTransitionIntent = {
  __typename?: 'OrganizationPlanSpecTransitionIntent';
  createdAt: Scalars['DateTimeISO']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  organization: Organization;
  processedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  resultingSubscription?: Maybe<OrganizationPlanSubscription>;
  scheduledFor?: Maybe<Scalars['DateTimeISO']['output']>;
  sourceSpec: OrganizationPlanSpec;
  sourceSubscription: OrganizationPlanSubscription;
  status: PlanSpecTransitionIntentStatus;
  targetSpec: OrganizationPlanSpec;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrganizationPlanSubscription = {
  __typename?: 'OrganizationPlanSubscription';
  billingPeriods: Array<BillingPeriodRecord>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  interval: SubscriptionInterval;
  isActive: Scalars['Boolean']['output'];
  organization: Organization;
  planSpec: OrganizationPlanSpec;
  provider?: Maybe<Scalars['String']['output']>;
  providerCode?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTimeISO']['output'];
  status: OrganizationPlanSubscriptionStatus;
  terminatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  trialExpiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrganizationPlanSubscriptionChangeRequest = {
  __typename?: 'OrganizationPlanSubscriptionChangeRequest';
  changeType?: Maybe<ChangeRequestType>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  interval: SubscriptionInterval;
  organization: Organization;
  organizationUser: OrganizationUser;
  payment: Payment;
  previousSubscription?: Maybe<OrganizationPlanSubscription>;
  proratedAmount?: Maybe<Scalars['Float']['output']>;
  spec: OrganizationPlanSpec;
  subscription?: Maybe<OrganizationPlanSubscription>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** The current status of an organization subscription */
export enum OrganizationPlanSubscriptionStatus {
  Active = 'ACTIVE',
  GracePeriod = 'GRACE_PERIOD',
  Suspended = 'SUSPENDED',
  Terminated = 'TERMINATED',
  Trial = 'TRIAL'
}

export enum OrganizationProduct {
  Business = 'BUSINESS',
  CommunityManager = 'COMMUNITY_MANAGER'
}

export type OrganizationRequestAddressSnapshot = {
  __typename?: 'OrganizationRequestAddressSnapshot';
  address: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type OrganizationSharingInput = {
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationTalentPool = {
  __typename?: 'OrganizationTalentPool';
  communityMembers: Array<TrainingCommunityMember>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: OrganizationUser;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  organizationsSharedWith: Array<Organization>;
  status: OrganizationTalentPoolStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrganizationTalentPoolInstance = {
  __typename?: 'OrganizationTalentPoolInstance';
  candidates: Array<TalentPoolCandidate>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: OrganizationUser;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  parentTalentPool: OrganizationTalentPool;
  status: OrganizationTalentPoolInstanceStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum OrganizationTalentPoolInstanceStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED'
}

export enum OrganizationTalentPoolStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum OrganizationToolPaymentMethod {
  BankTransfer = 'BANK_TRANSFER',
  Online = 'ONLINE'
}

export type OrganizationUnlockedApplicant = {
  __typename?: 'OrganizationUnlockedApplicant';
  applicant: BaseJobApplicant;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  unlockRequest: ApplicantUnlockRequest;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrganizationUser = {
  __typename?: 'OrganizationUser';
  createdAt: Scalars['DateTimeISO']['output'];
  disabledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role: OrganizationUserRole;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['String']['output'];
};

export type OrganizationUserInvite = {
  __typename?: 'OrganizationUserInvite';
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  inviteRole: OrganizationUserRole;
  invitedBy?: Maybe<OrganizationUser>;
  organization: Organization;
  status: OrganizationUserInviteStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Status of the organization user invite */
export enum OrganizationUserInviteStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING'
}

/** Role of the user in the organization */
export enum OrganizationUserRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export type OtherServiceRequestInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

/** Sources of entities for outreach */
export type OutreachSource = {
  __typename?: 'OutreachSource';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OutreachSourceInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  type: OutreachSourceType;
};

export enum OutreachSourceType {
  Channel = 'CHANNEL',
  Location = 'LOCATION'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** The Payment Model */
export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float']['output'];
  checkout?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoice?: Maybe<Invoice>;
  proTradeRequirementPayment?: Maybe<ProTradeRequirementPayment>;
  providerId: Scalars['String']['output'];
  providerTxId?: Maybe<Scalars['String']['output']>;
  status: TransactionStatus;
  transactionDate?: Maybe<Scalars['DateTimeISO']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  transactionReference: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum PaymentMethod {
  ByOutput = 'BY_OUTPUT',
  FixedAmount = 'FIXED_AMOUNT'
}

export type PaymentProvider = {
  __typename?: 'PaymentProvider';
  balance: Scalars['Float']['output'];
  channel: PaymentProviderChannel;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  transactionFee: Scalars['Float']['output'];
};


export type PaymentProviderTransactionFeeArgs = {
  amount: Scalars['Float']['input'];
};

export enum PaymentProviderChannel {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type PaymentProviderData = {
  __typename?: 'PaymentProviderData';
  accountNumber: Scalars['String']['output'];
  providers: Array<TransferRecipient>;
};

export type PaymentProviderInformation = {
  __typename?: 'PaymentProviderInformation';
  defaultAccountNumber: Scalars['String']['output'];
  id: Scalars['String']['output'];
  pro?: Maybe<Pro>;
  providerData: Array<PaymentProviderData>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** Payment requirements for the plan change */
export type PaymentRequirements = {
  __typename?: 'PaymentRequirements';
  /** Amount to charge (full price or prorated) */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Proration details (for paid-to-paid upgrades) */
  proration?: Maybe<ProrationResultGql>;
  /** Whether immediate payment is required */
  requiresImmediatePayment: Scalars['Boolean']['output'];
};

export enum PaymentSchedule {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type Period = {
  __typename?: 'Period';
  end: Scalars['DateTimeISO']['output'];
  start: Scalars['DateTimeISO']['output'];
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  isVerified: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum PhoneType {
  BasicPhone = 'BASIC_PHONE',
  NoPhone = 'NO_PHONE',
  Smartphone = 'SMARTPHONE'
}

/** Result of evaluating a plan change request */
export type PlanChangeEvaluationResult = {
  __typename?: 'PlanChangeEvaluationResult';
  /** Current billing period information */
  billingPeriodInfo?: Maybe<BillingPeriodInfo>;
  /** The type of plan change identified */
  changeType: PlanChangeType;
  /** Current plan information */
  currentPlan?: Maybe<PlanInfo>;
  /** Downgrade-specific information (for downgrade scenarios) */
  downgradeInfo?: Maybe<DowngradeInfo>;
  /** Whether this change is allowed to proceed */
  isEligible: Scalars['Boolean']['output'];
  /** Payment requirements for this change */
  paymentRequirements: PaymentRequirements;
  /** Human-readable reason for ineligibility (if not eligible) */
  reason?: Maybe<Scalars['String']['output']>;
  /** Recommended action for the client */
  recommendedAction: RecommendedAction;
  /** Target plan information */
  targetPlan: PlanInfo;
  /** Free trial availability information */
  trialInfo: TrialInfo;
};

/** The type of plan change identified during evaluation */
export enum PlanChangeType {
  CardlessTrialAvailable = 'CARDLESS_TRIAL_AVAILABLE',
  Downgrade = 'DOWNGRADE',
  FreeToPaid = 'FREE_TO_PAID',
  NoSubscription = 'NO_SUBSCRIPTION',
  PaidToPaidUpgrade = 'PAID_TO_PAID_UPGRADE',
  SameTier = 'SAME_TIER',
  TrialAvailable = 'TRIAL_AVAILABLE'
}

/** Information about a plan specification */
export type PlanInfo = {
  __typename?: 'PlanInfo';
  /** Family code (free, standard, growth, enterprise) */
  familyCode: Scalars['String']['output'];
  /** Family code index (0=free, 1=standard, 2=growth, 3=enterprise) */
  familyCodeIndex: Scalars['Int']['output'];
  /** Whether this is a free plan */
  isFreePlan: Scalars['Boolean']['output'];
  /** Plan name */
  name: Scalars['String']['output'];
  /** Price for the specified interval in NGN */
  price: Scalars['Float']['output'];
  /** Plan specification ID */
  specId: Scalars['String']['output'];
};

export type PlanSpecPrice = {
  __typename?: 'PlanSpecPrice';
  base: Scalars['Float']['output'];
  discount: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

/** The status of a plan spec transition intent */
export enum PlanSpecTransitionIntentStatus {
  AppliedImmediately = 'APPLIED_IMMEDIATELY',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Scheduled = 'SCHEDULED'
}

export type Point = {
  __typename?: 'Point';
  coordinates: Array<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type PointChange = {
  change: Scalars['Float']['input'];
  tradesmanId: Scalars['String']['input'];
};

export type PortfolioCertification = {
  __typename?: 'PortfolioCertification';
  createdAt: Scalars['DateTimeISO']['output'];
  id?: Maybe<Scalars['String']['output']>;
  issuedAt: Scalars['DateTimeISO']['output'];
  issuedBy: Scalars['String']['output'];
  issuerCertificationId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

/** Filter for portfolio completion status */
export enum PortfolioCompletionFilter {
  All = 'ALL',
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

export type PortfolioEducation = {
  __typename?: 'PortfolioEducation';
  createdAt: Scalars['DateTimeISO']['output'];
  fieldOfStudy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  qualification: EducationLevel;
  schoolName: Scalars['String']['output'];
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type PortfolioEmploymentHistoryItem = {
  __typename?: 'PortfolioEmploymentHistoryItem';
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  endedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  images: Array<PortfolioImage>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  jobTitle: Scalars['String']['output'];
  monthlySalary?: Maybe<Scalars['Float']['output']>;
  proDoesNotWishToDiscloseMonthlySalary: Scalars['Boolean']['output'];
  startedAt: Scalars['DateTimeISO']['output'];
};

export type PortfolioImage = {
  __typename?: 'PortfolioImage';
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  originalUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type PortfolioWorkHistoryItem = {
  __typename?: 'PortfolioWorkHistoryItem';
  budget?: Maybe<Scalars['Float']['output']>;
  clientReview?: Maybe<PortfolioWorkHistoryItemClientReview>;
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  endedAt: Scalars['DateTimeISO']['output'];
  id?: Maybe<Scalars['String']['output']>;
  images: Array<PortfolioImage>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  laborhackJobRatings?: Maybe<LaborhackJobRatings>;
  name: Scalars['String']['output'];
  proDoesNotWishToDiscloseBudget?: Maybe<Scalars['Boolean']['output']>;
  startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  videos: Array<Scalars['String']['output']>;
};

export type PortfolioWorkHistoryItemClientReview = {
  __typename?: 'PortfolioWorkHistoryItemClientReview';
  feedback?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Float']['output'];
};

export type PostOrderVerificationResponse = IResponse & {
  __typename?: 'PostOrderVerificationResponse';
  data?: Maybe<ClientDetails>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

/** app preferences for a user */
export type Preferences = {
  __typename?: 'Preferences';
  hasDisabledTelegramPopUp?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  proId: Scalars['String']['output'];
};

export type PreferencesInput = {
  hasDisabledTelegramPopUp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrefillCertificationInput = {
  issuedAt: Scalars['String']['input'];
  issuedBy: Scalars['String']['input'];
  issuerCertificationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PrefillEducationInput = {
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  qualification: EducationLevel;
  schoolName: Scalars['String']['input'];
};

export type PrefillEmploymentInput = {
  companyName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endedAt?: InputMaybe<Scalars['String']['input']>;
  jobTitle: Scalars['String']['input'];
  startedAt: Scalars['String']['input'];
};

export type PrefillPortfolioResponse = {
  __typename?: 'PrefillPortfolioResponse';
  certificationCount: Scalars['Float']['output'];
  educationCount: Scalars['Float']['output'];
  employmentHistoryCount: Scalars['Float']['output'];
  laborpassCompleted: Scalars['Boolean']['output'];
  professionalSummarySet: Scalars['Boolean']['output'];
  workHistoryCount: Scalars['Float']['output'];
};

export type PrefillWorkHistoryInput = {
  description: Scalars['String']['input'];
  endedAt?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['String']['input']>;
};

export type PreviouslyUsedTradesman = {
  __typename?: 'PreviouslyUsedTradesman';
  assignmentDate?: Maybe<Scalars['DateTimeISO']['output']>;
  rating: Scalars['Float']['output'];
  tradesman: Tradesman;
};

export type Pro = {
  __typename?: 'Pro';
  associatedLaborHackEmail: Scalars['String']['output'];
  authProviderId?: Maybe<Scalars['String']['output']>;
  categories: Array<Category>;
  categoryIds: Array<Scalars['String']['output']>;
  certifications: Array<ProCertification>;
  conflicts: Array<ScheduleConflictUnion>;
  createdAt: Scalars['DateTimeISO']['output'];
  customTags?: Maybe<Array<UserAddedTag>>;
  defaultPhoneNumber: PhoneNumber;
  email: Scalars['String']['output'];
  employmentStatus?: Maybe<EmploymentStatus>;
  firstName: Scalars['String']['output'];
  handle: Scalars['String']['output'];
  hasCommunityMembership: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  identityVerification?: Maybe<IdentityVerification>;
  identityVerificationIssues?: Maybe<Array<IdentityVerificationIssueCode>>;
  identityVerificationStatus?: Maybe<IdentityVerificationStatus>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  jobTitle: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  onboardedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  overview?: Maybe<Scalars['String']['output']>;
  paymentProviderInformation?: Maybe<PaymentProviderInformation>;
  phoneNumber: Scalars['String']['output'];
  phoneNumberVerified: Scalars['Boolean']['output'];
  phoneNumbers: Array<PhoneNumber>;
  phoneType?: Maybe<PhoneType>;
  portfolioUrl: Scalars['String']['output'];
  proApplication?: Maybe<ProApplication>;
  referredBy?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<JobAdTag>>;
  tracks: Array<ProTrack>;
  trades: Array<Trade>;
  tradesman?: Maybe<Tradesman>;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  yearsOfExperience?: Maybe<Scalars['Float']['output']>;
  yearsOfExperienceLastModifiedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type ProConflictsArgs = {
  payload: ProposedSchedule;
};


export type ProIdentityVerificationArgs = {
  showDeclined?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ProAccountType {
  FullyProvisioned = 'FULLY_PROVISIONED',
  WhatsappGenerated = 'WHATSAPP_GENERATED'
}

export type ProApplication = {
  __typename?: 'ProApplication';
  acquisitionChannel?: Maybe<Scalars['String']['output']>;
  acquisitionChannelText?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  averageMonthlyIncome?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['String']['output']>;
  channelOutreachSource?: Maybe<OutreachSource>;
  conversionPath?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  currentIndustry?: Maybe<Industry>;
  customTags?: Maybe<Array<UserAddedTag>>;
  dateOfBirth?: Maybe<Scalars['DateTimeISO']['output']>;
  detailedAddress?: Maybe<Address>;
  email: Scalars['String']['output'];
  emergencyContactName?: Maybe<Scalars['String']['output']>;
  emergencyContactPhone?: Maybe<Scalars['String']['output']>;
  employmentStatus?: Maybe<EmploymentStatus>;
  firstName: Scalars['String']['output'];
  gender: Gender;
  handle: Scalars['String']['output'];
  hasInternationalPassport?: Maybe<Scalars['Boolean']['output']>;
  highestEducationLevel?: Maybe<EducationLevel>;
  id: Scalars['String']['output'];
  identification?: Maybe<ProApplicationIdentification>;
  identityValidated?: Maybe<Scalars['Boolean']['output']>;
  incomeCurrency?: Maybe<Scalars['String']['output']>;
  incomeLevel?: Maybe<IncomeLevel>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  leadSource: Scalars['String']['output'];
  leadSourceText?: Maybe<Scalars['String']['output']>;
  locationOutreachSource?: Maybe<OutreachSource>;
  numberOfDaysWorkedPerWeek?: Maybe<Scalars['Float']['output']>;
  otherCategoryText?: Maybe<Scalars['String']['output']>;
  otherOccupationText?: Maybe<Scalars['String']['output']>;
  otherRelevantDocumentUrls?: Maybe<Array<Scalars['String']['output']>>;
  passportExpiryDate?: Maybe<Scalars['DateTimeISO']['output']>;
  passportIssueAuthority?: Maybe<Scalars['String']['output']>;
  passportIssueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  phoneType?: Maybe<PhoneType>;
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
  reasonForJoiningLaborHack?: Maybe<Scalars['String']['output']>;
  reasonForJoiningLaborHackOtherText?: Maybe<Scalars['String']['output']>;
  reasonsForJoiningLaborHack: Array<Scalars['String']['output']>;
  resumeUrl?: Maybe<Scalars['String']['output']>;
  stateOfResidence?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<JobAdTag>>;
  trainingType?: Maybe<TrainingType>;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['String']['output'];
  yearOfGraduation?: Maybe<Scalars['Int']['output']>;
  yearsOfExperience?: Maybe<Scalars['Float']['output']>;
  yearsOfExperienceLastModifiedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ProApplicationIdentification = {
  __typename?: 'ProApplicationIdentification';
  identificationNumber: Scalars['String']['output'];
  identificationUrl: Scalars['String']['output'];
  meansOfIdentification: MeansOfIdentification;
};

export type ProApplicationIdentificationInput = {
  identificationNumber: Scalars['String']['input'];
  identificationUrl: Scalars['String']['input'];
  meansOfIdentification: MeansOfIdentification;
};

export type ProAssignmentChecklist = {
  __typename?: 'ProAssignmentChecklist';
  onLaborHackApparel: Scalars['Boolean']['output'];
  onProtectiveGear: Scalars['Boolean']['output'];
  submitted: Scalars['DateTimeISO']['output'];
  validationImageUrl: Scalars['String']['output'];
  withProperEquipment: Scalars['Boolean']['output'];
};

export type ProAssignmentChecklistInput = {
  onLaborHackApparel: Scalars['Boolean']['input'];
  onProtectiveGear: Scalars['Boolean']['input'];
  validationImageUrl: Scalars['String']['input'];
  withProperEquipment: Scalars['Boolean']['input'];
};

export type ProCertification = {
  __typename?: 'ProCertification';
  certification: Certification;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  pro: Pro;
  results: Array<ProCertificationResult>;
  updatedAt: Scalars['DateTimeISO']['output'];
  uploadedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ProCertificationEdge = Edge & {
  __typename?: 'ProCertificationEdge';
  cursor: Scalars['String']['output'];
  node: ProCertification;
};

export type ProCertificationResult = {
  __typename?: 'ProCertificationResult';
  attemptId?: Maybe<Scalars['Float']['output']>;
  certificationRequirement: CertificationRequirement;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  proCertification: ProCertification;
  score: Scalars['Float']['output'];
  submittedAt: Scalars['DateTimeISO']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ProDispatchedNotificationPayload = NotificationPayload & {
  __typename?: 'ProDispatchedNotificationPayload';
  event: NotificationEvent;
  location: NotificationPayloadLocation;
  order: NotificationPayloadOrder;
  pro: NotificationPayloadPro;
};

export type ProEdge = Edge & {
  __typename?: 'ProEdge';
  cursor: Scalars['String']['output'];
  node: ProListItem;
};

export type ProListItem = {
  __typename?: 'ProListItem';
  alternativeToPracticalInterviewStatus: ListProsTestStatus;
  backgroundCheckComplete: Scalars['Boolean']['output'];
  bankAccountSubmitted: Scalars['Boolean']['output'];
  categories: Array<Category>;
  conflicts?: Maybe<Array<ScheduleConflictUnion>>;
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  guarantors?: Maybe<Array<Guarantor>>;
  id: Scalars['String']['output'];
  identityVerification?: Maybe<IdentityVerification>;
  identityVerificationIssues?: Maybe<Array<IdentityVerificationIssueCode>>;
  identityVerificationStatus?: Maybe<IdentityVerificationStatus>;
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  onboardedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  paidForPriorLearningAttempts?: Maybe<Scalars['Boolean']['output']>;
  paidForSoftSkillsAttempts?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber: Scalars['String']['output'];
  priorLearningTestStatus: ListProsTestStatus;
  proApplication?: Maybe<ProApplication>;
  referees?: Maybe<Array<Referee>>;
  referredBy?: Maybe<Scalars['String']['output']>;
  softSkillsTrainingStatus: ListProsTestStatus;
  tracks: Array<ProTrack>;
  trades: Array<Trade>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ProLocation = {
  area?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  landmark?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
};

export type ProPortfolio = {
  __typename?: 'ProPortfolio';
  averageLaborHackJobsRatings: AverageLaborHackJobsRatings;
  averageRating: Scalars['Float']['output'];
  backgroundCheckStatus: ProPortfolioBadgeStatus;
  certifications: Array<PortfolioCertification>;
  educationEntries: Array<PortfolioEducation>;
  email: Scalars['String']['output'];
  employmentHistory: Array<PortfolioEmploymentHistoryItem>;
  experience?: Maybe<Scalars['Float']['output']>;
  firstName: Scalars['String']['output'];
  handle: Scalars['String']['output'];
  hasCompletedRequiredPortfolioSteps: Scalars['Boolean']['output'];
  identityVerificationStatus: ProPortfolioBadgeStatus;
  isEmailHidden?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  ratingCount: Scalars['Float']['output'];
  title?: Maybe<Scalars['String']['output']>;
  totalBudget: Scalars['Float']['output'];
  workHistory: Array<PortfolioWorkHistoryItem>;
};

export enum ProPortfolioBadgeStatus {
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING'
}

export type ProRecruitmentContract = {
  __typename?: 'ProRecruitmentContract';
  category: Category;
  createdAt: Scalars['DateTimeISO']['output'];
  currentJob?: Maybe<RecruitmentJob>;
  endDate: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  job?: Maybe<RecruitmentJob>;
  paymentAmount?: Maybe<Scalars['Int']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentSchedule?: Maybe<PaymentSchedule>;
  pro: Pro;
  proLevel: Scalars['Float']['output'];
  recruitment: ContractRecruitment;
  recruitmentType: RecruitmentType;
  requestedStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
  startDate: Scalars['DateTimeISO']['output'];
  status: ProRecruitmentContractStatus;
  terminatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  unitMeasured?: Maybe<Scalars['String']['output']>;
};

export enum ProRecruitmentContractStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Terminated = 'TERMINATED'
}

export type ProSkill = {
  __typename?: 'ProSkill';
  name: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type ProStudyWorkOpportunity = {
  __typename?: 'ProStudyWorkOpportunity';
  basicApplication?: Maybe<CanadaBasicApplication>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  isPaid: Scalars['Boolean']['output'];
  opportunity: StudyWorkOpportunity;
  payments: Array<Payment>;
  preferredCourse?: Maybe<CanadaBasicApplicationCourseOfStudy>;
  pro: Pro;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum ProTrack {
  Localgig = 'LOCALGIG',
  Studywork = 'STUDYWORK'
}

export type ProTradeLevelDiscount = {
  __typename?: 'ProTradeLevelDiscount';
  applicableTradeLevels: Array<TradeLevel>;
  autoApplied: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isRevoked: Scalars['Boolean']['output'];
  limit?: Maybe<Scalars['Float']['output']>;
  prompt: Scalars['String']['output'];
  pros: Array<Pro>;
  type: ProTradeLevelDiscountType;
  usageExpiresAt: Scalars['DateTimeISO']['output'];
  useOnce?: Maybe<Scalars['Boolean']['output']>;
  validFrom: Scalars['DateTimeISO']['output'];
  validUntil?: Maybe<Scalars['DateTimeISO']['output']>;
  value: Scalars['Float']['output'];
};


export type ProTradeLevelDiscountIsRevokedArgs = {
  proId?: InputMaybe<Scalars['String']['input']>;
};

export enum ProTradeLevelDiscountType {
  Basic = 'BASIC',
  Retry = 'RETRY'
}

export type ProTradeLevelPayment = {
  __typename?: 'ProTradeLevelPayment';
  affectedTradeRequirements: Array<TradeRequirement>;
  createdAt: Scalars['DateTimeISO']['output'];
  discount?: Maybe<ProTradeLevelDiscount>;
  id: Scalars['String']['output'];
  isPaid: Scalars['Boolean']['output'];
  payments: Array<Payment>;
  pro: Pro;
  tradeLevel: TradeLevel;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ProTradeRequirement = {
  __typename?: 'ProTradeRequirement';
  attemptsRemaining: Scalars['Int']['output'];
  canReschedule?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  events?: Maybe<Array<ProTradeRequirementInterviewEvent>>;
  hasCompletedPayment: Scalars['Boolean']['output'];
  hasPassed: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  pro: Pro;
  processedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  requirement: TradeRequirement;
  results: Array<ProTradeRequirementResult>;
  scheduledFor?: Maybe<Scalars['DateTimeISO']['output']>;
  tradeLevelPayments: Array<ProTradeLevelPayment>;
  updatedAt: Scalars['DateTimeISO']['output'];
  waived?: Maybe<Scalars['Boolean']['output']>;
};

export type ProTradeRequirementEdge = Edge & {
  __typename?: 'ProTradeRequirementEdge';
  cursor: Scalars['String']['output'];
  node: ProTradeRequirementListItem;
};

export type ProTradeRequirementInterviewEvent = {
  __typename?: 'ProTradeRequirementInterviewEvent';
  attemptId: Scalars['Int']['output'];
  cancellationUrl?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  rescheduleUrl?: Maybe<Scalars['String']['output']>;
  status: ProTradeRequirementInterviewEventStatus;
};

export enum ProTradeRequirementInterviewEventStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Rescheduled = 'RESCHEDULED',
  Scheduled = 'SCHEDULED'
}

export type ProTradeRequirementListItem = {
  __typename?: 'ProTradeRequirementListItem';
  attemptsRemaining: Scalars['Int']['output'];
  canReschedule?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  events?: Maybe<Array<ProTradeRequirementInterviewEvent>>;
  externalStatus: ExternalProTradeRequirementStatus;
  hasCompletedPayment: Scalars['Boolean']['output'];
  hasPassed: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  pro: Pro;
  processedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  requirement: TradeRequirement;
  results: Array<ProTradeRequirementResult>;
  scheduledFor?: Maybe<Scalars['DateTimeISO']['output']>;
  tradeLevelPayments: Array<ProTradeRequirement>;
  updatedAt: Scalars['DateTimeISO']['output'];
  waived?: Maybe<Scalars['Boolean']['output']>;
};

export type ProTradeRequirementPayment = {
  __typename?: 'ProTradeRequirementPayment';
  confirmedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  discount?: Maybe<ProTradeLevelDiscount>;
  id: Scalars['String']['output'];
  payments?: Maybe<Array<Payment>>;
  pro: Pro;
  proTradeRequirement: ProTradeRequirement;
  tradeRequirement: TradeRequirement;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ProTradeRequirementResult = {
  __typename?: 'ProTradeRequirementResult';
  attemptId: Scalars['Float']['output'];
  passed: Scalars['Boolean']['output'];
  scores: Array<Scalars['Int']['output']>;
  submittedAt: Scalars['DateTimeISO']['output'];
};

export type ProWithConflicts = {
  __typename?: 'ProWithConflicts';
  conflicts: Array<ScheduleConflictUnion>;
  id: Scalars['String']['output'];
  pro: Tradesman;
};

export type ProductFeedback = {
  __typename?: 'ProductFeedback';
  createdAt: Scalars['DateTimeISO']['output'];
  feedback: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationUser: OrganizationUser;
  product: LaborHackProduct;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum Progress {
  Assigned = 'ASSIGNED',
  ClientInspection = 'CLIENT_INSPECTION',
  Completed = 'COMPLETED',
  FinalQuote = 'FINAL_QUOTE',
  MaterialsPurchased = 'MATERIALS_PURCHASED',
  NotStarted = 'NOT_STARTED',
  PreInspection = 'PRE_INSPECTION',
  UnAssigned = 'UN_ASSIGNED'
}

export enum ProjectChallenges {
  BudgetOverruns = 'BUDGET_OVERRUNS',
  DelaysInDelivery = 'DELAYS_IN_DELIVERY',
  PoorCommunication = 'POOR_COMMUNICATION',
  PoorQualityWork = 'POOR_QUALITY_WORK',
  UnverifiedSkillsOrQualifications = 'UNVERIFIED_SKILLS_OR_QUALIFICATIONS'
}

export type ProjectOutsourcingDto = {
  challengesToAvoid: Array<ProjectChallenges>;
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  expectedTeamSize: Scalars['Float']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  keySkillsRequired: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  managementType: Scalars['String']['input'];
  organization?: InputMaybe<Scalars['String']['input']>;
  otherProjectChallenges?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  projectType: Scalars['String']['input'];
  roleInOrganization?: InputMaybe<Scalars['String']['input']>;
  userType: Scalars['String']['input'];
};

export type ProposedContractInfo = {
  contractInterval: ContractInterval;
  contractLength: Scalars['Float']['input'];
  contractStartDate: Scalars['DateTimeISO']['input'];
  nonBillableDates: Array<Scalars['String']['input']>;
  nonWorkingDays: Array<Scalars['String']['input']>;
};

export type ProposedSchedule = {
  end: Scalars['DateTimeISO']['input'];
  nonBillableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  nonWorkingDays?: InputMaybe<Array<Scalars['String']['input']>>;
  overtimeDates?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  start: Scalars['DateTimeISO']['input'];
};

/** Proration calculation result */
export type ProrationResultGql = {
  __typename?: 'ProrationResultGQL';
  /** The total price of the current plan for the billing interval */
  currentPlanPrice: Scalars['Float']['output'];
  /** Number of days remaining in the current billing period */
  daysRemaining: Scalars['Int']['output'];
  /** The total price of the new plan for the billing interval */
  newPlanPrice: Scalars['Float']['output'];
  /** The prorated amount to charge for the upgrade */
  proratedAmount: Scalars['Float']['output'];
  /** Total number of days in the current billing period */
  totalDaysInPeriod: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  accountActivationByToken: AccountActivation;
  accountActivationsByBusinessId: Array<AccountActivation>;
  /** Get the active downgrade intent for the organization */
  activeOrganizationPlanDowngradeIntent?: Maybe<OrganizationPlanDowngradeIntent>;
  admin: Admin;
  adminGetAllEmployerJobAds: AdminEmployerJobAdsResponse;
  adminGetProsWithinReachForEmployerJobAd: AdminProsWithinReachResponse;
  /** Get all LaborHack job applications of a user */
  allMyJobApplications: Array<JobApplicantApplication>;
  allProRecruitmentContractsByRecruitment: Array<ProRecruitmentContract>;
  applicantUnlockFee: Scalars['Int']['output'];
  artisanInvoice?: Maybe<FilledArtisanInvoice>;
  assignmentPayment: AssignmentPayment;
  assignmentPayments: ListAssignmentPaymentResponse;
  assignmentPaymentsByOrderId: Array<AssignmentPayment>;
  assignmentPaymentsByTradesmanId: Array<AssignmentPayment>;
  assignmentsByOrderId: Array<TradesmanAssignment>;
  availableAutoAppliedInvoiceDiscount?: Maybe<InvoiceDiscount>;
  availableAutoAppliedInvoiceDiscountByClientId?: Maybe<InvoiceDiscount>;
  availableAutoAppliedInvoiceDiscountByClientProfileId?: Maybe<InvoiceDiscount>;
  availableDiscounts: Array<ProTradeLevelDiscount>;
  availableRetryDiscounts: Array<ProTradeLevelDiscount>;
  /** Get the status of a bulk plan spec transition job */
  bulkPlanSpecTransitionStatus?: Maybe<BulkPlanSpecTransitionJob>;
  business: Business;
  businessByEmail: Business;
  businesses: ListBusinessesResponse;
  canApplyInvoiceDiscount: Scalars['Boolean']['output'];
  /** Check if organization can start a card-less trial for the given plan */
  canStartCardlessTrialForPlan: Scalars['Boolean']['output'];
  canStartOrganizationPlanSubscriptionWithFreeTrial: Scalars['Boolean']['output'];
  cardAuthorizationByReference: CardAuthorization;
  categories: Array<Category>;
  categorySubscriptionPackagePlan: CategorySubscriptionPackagePlan;
  certification: Certification;
  certificationRequirement: CertificationRequirement;
  checkAgreementAcceptance: AgreementCheckResult;
  checkAssignmentPaymentStatus: CheckAssignmentPaymentStatusResponse;
  checkIfCategoryHasANonCustomPackage: Scalars['Boolean']['output'];
  checkTradesmenAvailabilityByDate: ListTradesmanWithAvailabilityResponse;
  client: Client;
  clientByEmail: Client;
  clientExists: Scalars['Boolean']['output'];
  clientOrders: Array<ClientOrderListItem>;
  clientProfileOrders: Array<ClientOrderListItem>;
  clients: ListClientsResponse;
  communityInviteMetadata: CommunityInviteMetadataResponse;
  communityInviteOnboardingContext?: Maybe<CommunityInviteOnboardingContextResponse>;
  communityJobApplication?: Maybe<CommunityJobApplication>;
  communityJobApplicationsForOpportunity: Array<CommunityJobApplication>;
  computeIntegratorPayoutBreakdown: ThirdPartyIntegratorPayoutBreakdown;
  computePayoutBreakdown: ContractPayoutBreakdown;
  contract: Contract;
  contractPayout?: Maybe<ContractPayout>;
  contractPayoutReimbursementsByInvoice: Array<ContractPayoutReimbursement>;
  contractPayouts: Array<ContractPayout>;
  contractPayoutsByIds: Array<ContractPayout>;
  contractRecruitment: ContractRecruitment;
  contractRecruitments: Array<ContractRecruitment>;
  contractsByRecruitmentId: Array<Contract>;
  /** Get the current active subscription for the authenticated organization */
  currentOrganizationPlanSubscription?: Maybe<OrganizationPlanSubscription>;
  /** Get the default organization plan specifications. Optionally filter by product. */
  defaultOrganizationPlanSpecs: Array<OrganizationPlanSpec>;
  /** @deprecated read information from pro entities directly */
  defaultTransferRecipients?: Maybe<Array<TransferRecipient>>;
  /** @deprecated read information from pro entities directly */
  defaultTransferRecipientsForPro?: Maybe<Array<TransferRecipient>>;
  doesApplicantExistWithEmail: Scalars['Boolean']['output'];
  doesProExistWithEmail: Scalars['Boolean']['output'];
  emailMonthlyStatisticsToAllReferrers: Array<Scalars['String']['output']>;
  employerJobAdPrincipals: Array<EmployerJobAdPrincipal>;
  employerJobAdThirdParties: Array<EmployerJobAdThirdParty>;
  employerJobApplication?: Maybe<EmployerJobApplication>;
  /** Get all job applications sent to this organization */
  employerJobApplications: Array<EmployerJobApplication>;
  /** Get enterprise plan specifications for the current organization */
  enterpriseOrganizationPlanSpecs: Array<OrganizationPlanSpec>;
  /** Evaluate an organization plan change request and return comprehensive information about eligibility, pricing, and available options */
  evaluateOrganizationPlanChange: PlanChangeEvaluationResult;
  fetchOutreachSources: Array<OutreachSource>;
  generateProTradeRequirementPaymentLink: Scalars['String']['output'];
  getAgreementContent: OrganizationAgreement;
  getAllCategory: Array<Category>;
  getAllProTradeRequirementsForPro: Array<ProTradeRequirement>;
  getAllRoles: GetAdminRolesResponse;
  getAllServices: AllServices;
  getAllSubCategory: Array<SubCategory>;
  getAnnouncementSmsStats: AnnouncementSmsStats;
  getAssignmentSchedule: GetAssignmentScheduleResponse;
  getAvailableAutoAppliedInvoiceDiscounts: Array<InvoiceDiscount>;
  getAvailableAutoAppliedInvoiceDiscountsByClientProfileId: Array<InvoiceDiscount>;
  getAverageApplicationsPerJobForOrganization: Scalars['Float']['output'];
  getBackgroundCheckByProId?: Maybe<BackgroundCheck>;
  getBackgroundCheckByUserId?: Maybe<BackgroundCheck>;
  getBankAccountInformation: GetBankAccountInformationResponse;
  getBankAccountInformationByRecipientCode: GetBankAccountInformationResponse;
  getCensoredPortfolio?: Maybe<Scalars['String']['output']>;
  getClientByEmail?: Maybe<Client>;
  getClientByUserId: GetClientResponse;
  getClientInvoices: Array<Invoice>;
  getClientLocations: ClientLocationData;
  getClientNotifications: GetNotificationsResponse;
  getClientStatistics: GetClientStatisticsResponse;
  getClientUsageStatistics: UsageStatistics;
  getCommunityAnnouncement?: Maybe<CommunityAnnouncement>;
  getCommunityAnnouncementForPro?: Maybe<CommunityAnnouncement>;
  getCommunityAnnouncements: Array<CommunityAnnouncement>;
  getCommunityAnnouncementsForPro: Array<CommunityAnnouncement>;
  getCommunityJobOpportunitiesForPro: Array<CommunityJobOpportunity>;
  getCommunityJobOpportunity?: Maybe<CommunityJobOpportunity>;
  getCommunityJobOpportunityForPro?: Maybe<CommunityJobOpportunity>;
  getCommunitySegment?: Maybe<CommunitySegment>;
  getContractWorksheetsForContract: Array<ContractWorksheet>;
  getContractWorksheetsForPayroll: Array<ContractWorksheet>;
  getDiscountBalanceForClientByDiscountId?: Maybe<Scalars['Float']['output']>;
  getDiscountBalanceForClientProfileByDiscountId?: Maybe<Scalars['Float']['output']>;
  getEligibleBasicDiscounts: Array<ProTradeLevelDiscount>;
  getEmailsOfClientsWithSubscriptionsThatHaveExpiredButHaveNotBeenCancelled: Array<Scalars['String']['output']>;
  getEmailsOfProsThatCouldNotDownloadCertificates: Array<Scalars['String']['output']>;
  getEmployerJobAd?: Maybe<EmployerJobAd>;
  getEmployerJobAds: Array<EmployerJobAd>;
  getEmployerJobAdsAwaitingReview: Array<EmployerJobAd>;
  getEstimationText?: Maybe<Scalars['String']['output']>;
  getHireAnalyticsForOrganization: HireAnalytics;
  getHomeownerRequestPaymentCost: HomeownerRequestPaymentCost;
  getImportedInvoiceUploadUrl: ImportedInvoiceUploadUrl;
  getInspectionInvoiceForAssignment: Invoice;
  getInvite: Invite;
  getInvoiceById: GetInvoiceResponse;
  getInvoicesByOrder: Array<Invoice>;
  getJobAdNotificationPreferences?: Maybe<JobAdNotificationsPreferences>;
  getJobByCode: Job;
  getMyAssignments: GetTradesmanAssignmentsResponse;
  getMyLocations: GetClientLocationsResponse;
  getMyOrganizationTalentPools: Array<OrganizationTalentPool>;
  getMyPreviouslyUsedTradesmen: GetMyPreviouslyUsedTradesmenResponse;
  getMyRecruiterEarlyAccessInvite?: Maybe<RecruiterEarlyAccessInvite>;
  getMyTalentPoolInstance: OrganizationTalentPoolInstance;
  getMyTalentPoolInstances: Array<OrganizationTalentPoolInstance>;
  getMyTrainingEarlyAccessInvite?: Maybe<TrainingEarlyAccessInvite>;
  getOrder: Order;
  getOrderStatistics: GetOrderStatisticsResponse;
  getOrganizationJobOpportunities: Array<CommunityJobOpportunity>;
  getOrganizationSegments: Array<CommunitySegment>;
  getOrganizationTotalJobPosts: Scalars['Float']['output'];
  /** Get the total number of onboarded pros for an organization */
  getOrganizationTotalOnboardedPros: Scalars['Float']['output'];
  /** @deprecated Use recruitmentPayrollOverlappingContracts instead */
  getOverlappingContracts: Array<ProRecruitmentContract>;
  getPendingDirectDebitAuthorizations: Array<DirectDebitAuthorization>;
  getPendingProTradeRequirementPayments: Array<ProTradeRequirementPayment>;
  getPlansBySubscriptionPackage: Array<CategorySubscriptionPackagePlan>;
  getPreferencesByUserId?: Maybe<Preferences>;
  getProAccountType?: Maybe<ProAccountType>;
  getProApplicationUploadPresignedUrl: Scalars['String']['output'];
  getRecruitmentJobShortlist?: Maybe<RecruitmentJobShortlist>;
  getRecruitmentPayrollByPeriod: RecruitmentPayroll;
  getRecruitmentPayrollPeriods: Array<RecruitmentPayrollPeriod>;
  getRecruitmentPayrollsForRecruitment: Array<RecruitmentPayroll>;
  getReferrerById: Referrer;
  getReferrerByReferralCode: Referrer;
  getReferrerPaymentProviderInformation: PaymentProviderInformation;
  getReferrerStatistics: ReferrerStatistics;
  getRefundRequestById: GetRefundRequestResponse;
  getReviewByAssignmentId: Review;
  getSMSCreditBalance: Scalars['Float']['output'];
  /** Get sms-credit debit history for the current organization */
  getSMSCreditDebitHistory: Array<SmsLedgerEntry>;
  /** Get SMS credit purchase history for the current organization */
  getSMSCreditPurchaseHistory: Array<SmsCreditPurchaseRequest>;
  /** Get full SMS ledger history (credits and debits) for the current organization */
  getSMSLedgerHistory: Array<SmsLedgerEntry>;
  getShareableApplication?: Maybe<ShareableApplication>;
  getShortlistAnalyticsForOrganization: ShortlistAnalytics;
  getSubCategory: Array<SubCategory>;
  getSubscriptionPackagesByCategory: CategorySubscriptionPackage;
  getSubscriptionsByUserId: Array<SubscriptionRequest>;
  getTradesmanAssignmentById: GetTradesmanAssignmentResponse;
  getTradesmanAssignmentVisits: Array<TradesmanAssignmentVisit>;
  /** @deprecated Use `assignmentsByOrderId` instead */
  getTradesmanAssignments: GetTradesmanAssignmentsResponse;
  getTradesmanByReferralCode: GetTradesmanResponse;
  getTradesmanProfile: GetTradesmanProfileResponse;
  getTradesmanSchedule: GetTradesmanScheduleResponse;
  getTradesmenByCategory: ListTradesmanResponse;
  getTradesmenWithAvailabilityByCategory: ListTradesmanWithAvailabilityResponse;
  getUnfinalizedHomeownerRequestsForClientByUserId: Array<HomeownerRequest>;
  getUserByPhoneNumber: GetUserByPhoneNumberResponse;
  getUserRecordByEmail: User;
  getUserRecordByPhoneNumber: User;
  /** Get the current wallet balance for the organization (in Naira) */
  getWalletBalance: Scalars['Float']['output'];
  /** Get wallet funding request history for the organization */
  getWalletFundingHistory: Array<WalletFundingRequest>;
  /** Get wallet ledger history (all credits and debits) for the organization */
  getWalletLedgerHistory: Array<WalletLedgerEntry>;
  homeowner: Homeowner;
  homeownerByEmail?: Maybe<Homeowner>;
  homeownerExists: Scalars['Boolean']['output'];
  homeownerRequest: HomeownerRequest;
  identityVerification: IdentityVerification;
  identityVerificationsForPro: Array<IdentityVerification>;
  invoice: Invoice;
  invoiceDiscountByCode?: Maybe<InvoiceDiscount>;
  invoices: ListInvoiceResponse;
  invoicesByRecruitmentId: Array<Invoice>;
  isMaxNumberOfRequestCallsForBaseIntervalMet: Scalars['Boolean']['output'];
  jobAdShortlistById?: Maybe<JobAdShortlist>;
  jobAdShortlistHistory: Array<JobAdShortlist>;
  jobAdTags: Array<JobAdTag>;
  latestJobAdShortlist?: Maybe<JobAdShortlist>;
  listAllAdmins: ListAdminsResponse;
  listAllTradesmen: ListTradesmanResponse;
  listBanks: ListBanksResponse;
  listHomeowners: ListHomeownersResponse;
  listOfReferrers: Array<Referrer>;
  listOrders: ListOrdersResponse;
  listProTradeRequirements: ListProTradeRequirementsResponse;
  listPros: ListProsResponse;
  listProsForRecruitment: ListProsResponse;
  listProsTotalCount: Scalars['Float']['output'];
  listRefundRequests: ListRefundRequestsResponse;
  marketplaceJob?: Maybe<MarketplaceJob>;
  marketplaceRequest?: Maybe<MarketplaceRequest>;
  marketplaceRequests: Array<MarketplaceRequest>;
  /** Get the minimum wallet funding amount (in Naira) */
  minimumWalletFundingAmount: Scalars['Int']['output'];
  myClient?: Maybe<Client>;
  myClientProfile: ClientProfile;
  myCommunityJobApplications: Array<CommunityJobApplication>;
  myContractRecruitments: Array<ContractRecruitment>;
  myDiscardedApplications: Array<DiscardedJobApplication>;
  myEmployerAdmin?: Maybe<EmployerAdmin>;
  myHomeowner?: Maybe<Homeowner>;
  myJobApplicantProfile?: Maybe<BaseJobApplicant>;
  myJobApplication?: Maybe<JobApplicantApplication>;
  myJobApplications: Array<EmployerJobApplication>;
  myMarketplaceRequest?: Maybe<MarketplaceRequest>;
  myMarketplaceRequests: Array<MarketplaceRequest>;
  myOrder: Order;
  myOrderForClientProfile: Order;
  myOrderHandlingQuotation: OrderHandlingQuotation;
  myOrderHandlingQuotationForClientProfile: OrderHandlingQuotation;
  myOrganization?: Maybe<Organization>;
  myOrganizationApiAccess?: Maybe<OrganizationApiAccess>;
  myOrganizationCommunityInvite: OrganizationCommunityInviteResponse;
  myOrganizationFacilities: Array<OrganizationFacility>;
  myOrganizationJobAd?: Maybe<EmployerJobAd>;
  myOrganizationJobAds: MyOrganizationJobAdsResponse;
  myOrganizationJobAdsStats: MyOrganizationJobAdsStats;
  myOrganizationOneTimeRequests: Array<OrganizationOneTimeRequest>;
  /** Get all available plan specs for the current organization (default plans + any enterprise plans specific to the org) */
  myOrganizationPlanSpecs: Array<OrganizationPlanSpec>;
  myOrganizationUnlockedApplicants: Array<OrganizationUnlockedApplicant>;
  myOrganizationUsers: Array<OrganizationUser>;
  myOrganizationWebhookPortalUrl?: Maybe<Scalars['String']['output']>;
  myPortfolio?: Maybe<ProPortfolio>;
  myPro?: Maybe<Pro>;
  myProApplication?: Maybe<ProApplication>;
  myProInformation: Pro;
  myThirdPartyIntegrator?: Maybe<ThirdPartyIntegrator>;
  myThirdPartyIntegratorWebhookPortalUrl: Scalars['String']['output'];
  /** @deprecated Use myTrainingCommunityProfile instead */
  myTrainingCommunityAdmin?: Maybe<TrainingCommunityAdmin>;
  myTrainingCommunityProfile?: Maybe<TrainingCommunityAdmin>;
  myTrainingCommunityProgramLogBook?: Maybe<TrainingCommunityProgramStudentLogBook>;
  myTrainingCommunityProgramLogBookEntry?: Maybe<TrainingCommunityProgramStudentLogBookEntry>;
  myTrainingCommunityProgramLogBooks: Array<TrainingCommunityProgramStudentLogBook>;
  myUserProfile: User;
  nextInvoicePayment: NextInvoicePayment;
  nonRecurrentlyBilledSubscriptionRequests: Array<SubscriptionRequest>;
  numberOfProsWithLessThanOneYearOfExperience: Scalars['Float']['output'];
  orderHandlingQuotation: OrderHandlingQuotation;
  orderHandlingQuotationsByOrderId: Array<OrderHandlingQuotation>;
  organization?: Maybe<Organization>;
  organizationCommunityManagerStatus: CommunityManagerSubscriptionStatusResponse;
  organizationEmployerJobApplication?: Maybe<EmployerJobApplication>;
  organizationFacility: OrganizationFacility;
  organizationFacilityContacts: Array<OrganizationFacilityContact>;
  organizationMembersWithIncompletePortfolios: Array<TrainingCommunityMember>;
  organizationOneTimeRequest: OrganizationOneTimeRequest;
  organizationPartnershipShadowUsers: Array<OrganizationPartnershipShadowUser>;
  organizationPartnerships: Array<OrganizationPartnership>;
  /** Get all downgrade intents for the organization */
  organizationPlanDowngradeIntents: Array<OrganizationPlanDowngradeIntent>;
  /** Get the organization plan specification by id */
  organizationPlanSpec?: Maybe<OrganizationPlanSpec>;
  /** Get the interval discounts for organization plan specifications */
  organizationPlanSpecIntervalDiscounts: Array<IntervalDiscount>;
  /** Get the price for an organization plan specification by id and interval */
  organizationPlanSpecPrice?: Maybe<PlanSpecPrice>;
  /** Get a plan spec transition intent by ID */
  organizationPlanSpecTransitionIntent?: Maybe<OrganizationPlanSpecTransitionIntent>;
  /** Get the organization plan specifications that extends the limit of a quota. Optionally filter by product. */
  organizationPlanSpecsWithExtendedQuota: Array<OrganizationPlanSpec>;
  organizationPlanSubscriptionChangeRequest?: Maybe<OrganizationPlanSubscriptionChangeRequest>;
  /** Get the subscription management URL for updating payment card. Only available for paid subscriptions. */
  organizationPlanSubscriptionManagementUrl: Scalars['String']['output'];
  organizationTrainingCommunityAdmins: Array<TrainingCommunityAdmin>;
  organizationTrainingCommunityMembers: Array<TrainingCommunityMember>;
  organizationTrainingCommunityProgram?: Maybe<TrainingCommunityProgram>;
  organizationTrainingCommunityPrograms: Array<TrainingCommunityProgram>;
  organizationUserInviteByToken?: Maybe<OrganizationUserInvite>;
  organizationUserInvites: Array<OrganizationUserInvite>;
  organizationUsers: Array<OrganizationUser>;
  payment?: Maybe<Payment>;
  /** @deprecated read information from pro entities directly */
  paymentProviderInformation?: Maybe<PaymentProviderInformation>;
  paymentProviders: Array<PaymentProvider>;
  postOrderVerifyPayment: PostOrderVerificationResponse;
  /** Preview the proration calculation for upgrading to a different plan */
  previewUpgradeProration: UpgradeProrationPreview;
  pro: Pro;
  proApplicationByProId: ProApplication;
  proCertification: ProCertification;
  proCertifications: ListProCertificationsResponse;
  proExists: Scalars['Boolean']['output'];
  proPortfolio?: Maybe<ProPortfolio>;
  proRecruitmentContractById: ProRecruitmentContract;
  proStudyWorkOpportunityByOpportunity: ProStudyWorkOpportunity;
  proTradeLevelPayment: ProTradeLevelPayment;
  proTradeLevelPayments: Array<ProTradeLevelPayment>;
  proTradeRequirement: ProTradeRequirement;
  proTradeRequirementsByTradeLevel: Array<ProTradeRequirement>;
  proTradeRequirementsForPro: Array<ProTradeRequirement>;
  proposedContractEndDate: Scalars['DateTimeISO']['output'];
  pros: Array<Pro>;
  prosWithContractConflictInformation: Array<ProWithConflicts>;
  quotation: ContractQuotation;
  recruitmentJob?: Maybe<RecruitmentJob>;
  recruitmentPayroll: RecruitmentPayroll;
  recruitmentPayrollOverlappingContracts: Array<ProRecruitmentContract>;
  referrals: DefaultResponse;
  referrerPayoutById: ReferrerPayout;
  referrerPayouts: Array<ReferrerPayout>;
  refreshCourses: Scalars['Boolean']['output'];
  refreshOplSoftSkillsResults: Scalars['Boolean']['output'];
  sendEmailsToClientsWithActiveSubscriptionsButNoAuthorization: Scalars['Boolean']['output'];
  sendHomeownerRequestReminderEmails: Scalars['Boolean']['output'];
  studyWorkOpportunities: Array<StudyWorkOpportunity>;
  studyWorkOpportunity: StudyWorkOpportunity;
  subscriptionDetails: SubscriptionRequest;
  subscriptionRequestCall: SubscriptionRequestCall;
  subscriptionRequestCallPayoutDetails: SubscriptionRequestCallPayout;
  subscriptionRequestCallPayouts: Array<SubscriptionRequestCallPayout>;
  subscriptions: Array<SubscriptionRequest>;
  syncClientUserData: Scalars['Boolean']['output'];
  talentPoolCandidate?: Maybe<TalentPoolCandidate>;
  thirdPartyIntegrator?: Maybe<ThirdPartyIntegrator>;
  thirdPartyIntegratorPayout?: Maybe<ThirdPartyIntegratorPayout>;
  thirdPartyIntegratorPayouts: Array<ThirdPartyIntegratorPayout>;
  thirdPartyIntegratorPayoutsByIds: Array<ThirdPartyIntegratorPayout>;
  trade: Trade;
  tradeRequirements: Array<TradeRequirement>;
  /** Lists all trades enabled in the system. */
  trades: Array<Trade>;
  trainingCommunityMember?: Maybe<TrainingCommunityMember>;
  trainingCommunityProgramLogBook?: Maybe<TrainingCommunityProgramStudentLogBook>;
  trainingCommunityProgramLogBookEntry?: Maybe<TrainingCommunityProgramStudentLogBookEntry>;
  trainingCommunityProgramStudents: Array<TrainingCommunityProgramStudent>;
  transferRequest: Transfer;
  userAddedTags: Array<UserAddedTag>;
  verifyCardAuthorizationForSubscription: Scalars['Boolean']['output'];
  verifyPayment: VerifyPaymentResponse;
};


export type QueryAccountActivationByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryAccountActivationsByBusinessIdArgs = {
  businessId: Scalars['String']['input'];
};


export type QueryAdminArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminGetAllEmployerJobAdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  employmentTypes?: InputMaybe<Array<EmploymentType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  principalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<EmployerJobAdStatus>>;
};


export type QueryAdminGetProsWithinReachForEmployerJobAdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  experienceLevels?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobAdId: Scalars['String']['input'];
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAllMyJobApplicationsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAllProRecruitmentContractsByRecruitmentArgs = {
  recruitmentId: Scalars['String']['input'];
};


export type QueryArtisanInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
};


export type QueryAssignmentPaymentArgs = {
  id: Scalars['String']['input'];
};


export type QueryAssignmentPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ListAssignmentPaymentFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ListAssignmentPaymentSearch>;
};


export type QueryAssignmentPaymentsByOrderIdArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryAssignmentPaymentsByTradesmanIdArgs = {
  tradesmanId: Scalars['String']['input'];
};


export type QueryAssignmentsByOrderIdArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryAvailableAutoAppliedInvoiceDiscountArgs = {
  invoiceType?: InputMaybe<InvoiceType>;
};


export type QueryAvailableAutoAppliedInvoiceDiscountByClientIdArgs = {
  clientId: Scalars['String']['input'];
  invoiceType?: InputMaybe<InvoiceType>;
};


export type QueryAvailableAutoAppliedInvoiceDiscountByClientProfileIdArgs = {
  clientProfileId: Scalars['String']['input'];
  invoiceType?: InputMaybe<InvoiceType>;
};


export type QueryAvailableDiscountsArgs = {
  tradeId: Scalars['String']['input'];
};


export type QueryAvailableRetryDiscountsArgs = {
  tradeRequirementId: Scalars['String']['input'];
};


export type QueryBulkPlanSpecTransitionStatusArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryBusinessArgs = {
  id: Scalars['String']['input'];
};


export type QueryBusinessByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryBusinessesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ListBusinessesFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCanApplyInvoiceDiscountArgs = {
  discountCode: Scalars['String']['input'];
  invoiceType?: InputMaybe<InvoiceType>;
};


export type QueryCanStartCardlessTrialForPlanArgs = {
  planId: Scalars['String']['input'];
};


export type QueryCanStartOrganizationPlanSubscriptionWithFreeTrialArgs = {
  planId: Scalars['String']['input'];
};


export type QueryCardAuthorizationByReferenceArgs = {
  reference: Scalars['String']['input'];
};


export type QueryCategoriesArgs = {
  excludeSystemKeys?: InputMaybe<Array<CategorySystemKey>>;
};


export type QueryCategorySubscriptionPackagePlanArgs = {
  planId: Scalars['String']['input'];
};


export type QueryCheckAgreementAcceptanceArgs = {
  product: Scalars['String']['input'];
  type: AgreementType;
};


export type QueryCheckAssignmentPaymentStatusArgs = {
  assignmentId: Scalars['String']['input'];
};


export type QueryCheckIfCategoryHasANonCustomPackageArgs = {
  categoryId: Scalars['String']['input'];
};


export type QueryCheckTradesmenAvailabilityByDateArgs = {
  data: CheckTradesmenAvailabilityByDate;
};


export type QueryClientArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryClientByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryClientExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryClientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCommunityInviteMetadataArgs = {
  token: Scalars['String']['input'];
};


export type QueryCommunityInviteOnboardingContextArgs = {
  sessionToken: Scalars['String']['input'];
};


export type QueryCommunityJobApplicationArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommunityJobApplicationsForOpportunityArgs = {
  jobOpportunityId: Scalars['String']['input'];
};


export type QueryComputeIntegratorPayoutBreakdownArgs = {
  override?: InputMaybe<ThirdPartyIntegratorPayoutOverrideInput>;
  payoutId: Scalars['String']['input'];
};


export type QueryComputePayoutBreakdownArgs = {
  override?: InputMaybe<ContractPayoutOverrideInput>;
  payoutId: Scalars['String']['input'];
};


export type QueryContractArgs = {
  id: Scalars['String']['input'];
};


export type QueryContractPayoutArgs = {
  id: Scalars['String']['input'];
};


export type QueryContractPayoutReimbursementsByInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
};


export type QueryContractPayoutsArgs = {
  transferStatus?: InputMaybe<Array<TransferStatus>>;
};


export type QueryContractPayoutsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryContractRecruitmentArgs = {
  id: Scalars['String']['input'];
};


export type QueryContractsByRecruitmentIdArgs = {
  recruitmentId: Scalars['String']['input'];
};


export type QueryDefaultOrganizationPlanSpecsArgs = {
  product?: InputMaybe<OrganizationProduct>;
};


export type QueryDefaultTransferRecipientsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryDefaultTransferRecipientsForProArgs = {
  proId: Scalars['String']['input'];
};


export type QueryDoesApplicantExistWithEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryDoesProExistWithEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryEmailMonthlyStatisticsToAllReferrersArgs = {
  period: MonthYearInput;
};


export type QueryEmployerJobApplicationArgs = {
  id: Scalars['String']['input'];
};


export type QueryEvaluateOrganizationPlanChangeArgs = {
  interval: SubscriptionInterval;
  specId: Scalars['String']['input'];
};


export type QueryGenerateProTradeRequirementPaymentLinkArgs = {
  proTradeRequirementPaymentId: Scalars['String']['input'];
};


export type QueryGetAgreementContentArgs = {
  product: Scalars['String']['input'];
  type: AgreementType;
};


export type QueryGetAnnouncementSmsStatsArgs = {
  announcementId: Scalars['String']['input'];
};


export type QueryGetAssignmentScheduleArgs = {
  input: GetAssignmentScheduleInput;
};


export type QueryGetAvailableAutoAppliedInvoiceDiscountsArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryGetAvailableAutoAppliedInvoiceDiscountsByClientProfileIdArgs = {
  clientProfileId: Scalars['String']['input'];
};


export type QueryGetAverageApplicationsPerJobForOrganizationArgs = {
  dateRange?: InputMaybe<AnalyticsDateRange>;
};


export type QueryGetBackgroundCheckByProIdArgs = {
  proId: Scalars['String']['input'];
};


export type QueryGetBankAccountInformationArgs = {
  input: BankAccountInformationInput;
};


export type QueryGetBankAccountInformationByRecipientCodeArgs = {
  recipientCode: Scalars['String']['input'];
};


export type QueryGetCensoredPortfolioArgs = {
  proId: Scalars['String']['input'];
};


export type QueryGetClientByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetClientByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetClientLocationsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetCommunityAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
};


export type QueryGetCommunityAnnouncementForProArgs = {
  announcementId: Scalars['String']['input'];
};


export type QueryGetCommunityAnnouncementsArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCommunityJobOpportunityArgs = {
  jobOpportunityId: Scalars['String']['input'];
};


export type QueryGetCommunityJobOpportunityForProArgs = {
  jobOpportunityId: Scalars['String']['input'];
};


export type QueryGetCommunitySegmentArgs = {
  segmentId: Scalars['String']['input'];
};


export type QueryGetContractWorksheetsForContractArgs = {
  contractId: Scalars['String']['input'];
};


export type QueryGetContractWorksheetsForPayrollArgs = {
  payrollId: Scalars['String']['input'];
};


export type QueryGetDiscountBalanceForClientByDiscountIdArgs = {
  clientId: Scalars['String']['input'];
  discountId: Scalars['String']['input'];
};


export type QueryGetDiscountBalanceForClientProfileByDiscountIdArgs = {
  clientProfileId: Scalars['String']['input'];
  discountId: Scalars['String']['input'];
};


export type QueryGetEmployerJobAdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetEmployerJobAdsArgs = {
  dateFilter?: InputMaybe<EmployerJobAdsDateFilter>;
  employmentTypes: Array<EmploymentType>;
};


export type QueryGetEstimationTextArgs = {
  input: UpdateContractQuotationItemsInput;
};


export type QueryGetHireAnalyticsForOrganizationArgs = {
  dateRange?: InputMaybe<AnalyticsDateRange>;
};


export type QueryGetHomeownerRequestPaymentCostArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetImportedInvoiceUploadUrlArgs = {
  fileExtension: Scalars['String']['input'];
};


export type QueryGetInspectionInvoiceForAssignmentArgs = {
  assignmentId: Scalars['String']['input'];
};


export type QueryGetInviteArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetInvoiceByIdArgs = {
  invoiceId: Scalars['String']['input'];
};


export type QueryGetInvoicesByOrderArgs = {
  orderId: Scalars['String']['input'];
  type?: InputMaybe<InvoiceType>;
};


export type QueryGetJobByCodeArgs = {
  jobCode: Scalars['String']['input'];
};


export type QueryGetMyTalentPoolInstanceArgs = {
  instanceId: Scalars['String']['input'];
};


export type QueryGetOrderArgs = {
  orderCode: Scalars['String']['input'];
};


export type QueryGetOrganizationTotalJobPostsArgs = {
  dateRange?: InputMaybe<AnalyticsDateRange>;
};


export type QueryGetOrganizationTotalOnboardedProsArgs = {
  dateRange?: InputMaybe<AnalyticsDateRange>;
};


export type QueryGetOverlappingContractsArgs = {
  period: RecruitmentPayrollPeriodInput;
  recruitmentPayrollId: Scalars['String']['input'];
};


export type QueryGetPendingProTradeRequirementPaymentsArgs = {
  proTradeRequirementId: Scalars['String']['input'];
};


export type QueryGetPlansBySubscriptionPackageArgs = {
  packageId: Scalars['String']['input'];
};


export type QueryGetProAccountTypeArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryGetProApplicationUploadPresignedUrlArgs = {
  fileExtension: Scalars['String']['input'];
  path: Scalars['String']['input'];
};


export type QueryGetRecruitmentJobShortlistArgs = {
  recruitmentId: Scalars['String']['input'];
  recruitmentRequestId: Scalars['String']['input'];
};


export type QueryGetRecruitmentPayrollByPeriodArgs = {
  period: RecruitmentPayrollPeriodInput;
  recruitmentId: Scalars['String']['input'];
};


export type QueryGetRecruitmentPayrollPeriodsArgs = {
  recruitmentId: Scalars['String']['input'];
};


export type QueryGetRecruitmentPayrollsForRecruitmentArgs = {
  recruitmentId: Scalars['String']['input'];
};


export type QueryGetReferrerByIdArgs = {
  referrerId: Scalars['String']['input'];
};


export type QueryGetReferrerByReferralCodeArgs = {
  referralCode: Scalars['String']['input'];
};


export type QueryGetReferrerPaymentProviderInformationArgs = {
  referrerId: Scalars['String']['input'];
};


export type QueryGetReferrerStatisticsArgs = {
  period: MonthYearInput;
  referrerId: Scalars['String']['input'];
};


export type QueryGetRefundRequestByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetReviewByAssignmentIdArgs = {
  assignmentId: Scalars['String']['input'];
};


export type QueryGetShareableApplicationArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetShortlistAnalyticsForOrganizationArgs = {
  dateRange?: InputMaybe<AnalyticsDateRange>;
};


export type QueryGetSubscriptionPackagesByCategoryArgs = {
  categoryId: Scalars['String']['input'];
};


export type QueryGetTradesmanAssignmentByIdArgs = {
  assignmentId: Scalars['String']['input'];
};


export type QueryGetTradesmanAssignmentVisitsArgs = {
  assignmentId: Scalars['String']['input'];
};


export type QueryGetTradesmanAssignmentsArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryGetTradesmanByReferralCodeArgs = {
  referralCode: Scalars['String']['input'];
};


export type QueryGetTradesmanScheduleArgs = {
  tradesmanId: Scalars['String']['input'];
};


export type QueryGetTradesmenByCategoryArgs = {
  categoryId: Scalars['String']['input'];
};


export type QueryGetTradesmenWithAvailabilityByCategoryArgs = {
  data: GetTradesmanWithAvailabilityByCategoryInput;
};


export type QueryGetUserByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryGetUserRecordByEmailArgs = {
  authProvider?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};


export type QueryGetUserRecordByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryHomeownerArgs = {
  id: Scalars['String']['input'];
};


export type QueryHomeownerByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryHomeownerExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryHomeownerRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryIdentityVerificationArgs = {
  id: Scalars['String']['input'];
};


export type QueryIdentityVerificationsForProArgs = {
  proId: Scalars['String']['input'];
};


export type QueryInvoiceArgs = {
  id: Scalars['String']['input'];
};


export type QueryInvoiceDiscountByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInvoicesByRecruitmentIdArgs = {
  recruitmentId: Scalars['String']['input'];
};


export type QueryIsMaxNumberOfRequestCallsForBaseIntervalMetArgs = {
  dateOfAssignment: Scalars['DateTimeISO']['input'];
  subscriptionRequest: Scalars['String']['input'];
};


export type QueryJobAdShortlistByIdArgs = {
  shortlistId: Scalars['String']['input'];
};


export type QueryJobAdShortlistHistoryArgs = {
  jobAdId: Scalars['String']['input'];
};


export type QueryLatestJobAdShortlistArgs = {
  jobAdId: Scalars['String']['input'];
};


export type QueryListAllTradesmenArgs = {
  search?: InputMaybe<ListAllTradesmenSearch>;
};


export type QueryListBanksArgs = {
  providerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListHomeownersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: Array<OrderFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<OrderSearchInput>;
  sorts?: Array<OrderSortInput>;
};


export type QueryListProTradeRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ListProTradeRequirementsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ListProTradeRequirementsSearch>;
  sort?: InputMaybe<ListProTradeRequirementsSort>;
};


export type QueryListProsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ListProsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ListProsSearch>;
  sort?: InputMaybe<ListProsSort>;
};


export type QueryListProsForRecruitmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  exclusionShortlistId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ListProsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  proposedSchedule?: InputMaybe<ProposedSchedule>;
  search?: InputMaybe<ListProsSearch>;
  sort?: InputMaybe<ListProsSort>;
};


export type QueryListProsTotalCountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ListProsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ListProsSearch>;
  sort?: InputMaybe<ListProsSort>;
};


export type QueryListRefundRequestsArgs = {
  input?: InputMaybe<ListRefundRequestsInput>;
};


export type QueryMarketplaceJobArgs = {
  id: Scalars['String']['input'];
};


export type QueryMarketplaceRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryMyCommunityJobApplicationsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryMyJobApplicationArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryMyJobApplicationsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryMyMarketplaceRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryMyOrderArgs = {
  id: Scalars['String']['input'];
};


export type QueryMyOrderForClientProfileArgs = {
  id: Scalars['String']['input'];
};


export type QueryMyOrderHandlingQuotationArgs = {
  id: Scalars['String']['input'];
};


export type QueryMyOrderHandlingQuotationForClientProfileArgs = {
  id: Scalars['String']['input'];
};


export type QueryMyOrganizationJobAdArgs = {
  id: Scalars['String']['input'];
};


export type QueryMyOrganizationJobAdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MyOrganizationJobAdsStatusFilter>;
};


export type QueryMyTrainingCommunityProgramLogBookArgs = {
  id: Scalars['String']['input'];
};


export type QueryMyTrainingCommunityProgramLogBookEntryArgs = {
  id: Scalars['String']['input'];
};


export type QueryNextInvoicePaymentArgs = {
  invoiceId: Scalars['String']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNumberOfProsWithLessThanOneYearOfExperienceArgs = {
  registrationDateRange?: InputMaybe<AnalyticsDateRange>;
};


export type QueryOrderHandlingQuotationArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrderHandlingQuotationsByOrderIdArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryOrganizationArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationCommunityManagerStatusArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryOrganizationEmployerJobApplicationArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationFacilityArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationFacilityContactsArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryOrganizationOneTimeRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationPartnershipShadowUsersArgs = {
  partnershipId: Scalars['String']['input'];
};


export type QueryOrganizationPlanSpecArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationPlanSpecPriceArgs = {
  id: Scalars['String']['input'];
  interval: SubscriptionInterval;
};


export type QueryOrganizationPlanSpecTransitionIntentArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationPlanSpecsWithExtendedQuotaArgs = {
  limit: Scalars['Int']['input'];
  product?: InputMaybe<OrganizationProduct>;
  quotaKey: Scalars['String']['input'];
};


export type QueryOrganizationPlanSubscriptionChangeRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationTrainingCommunityMembersArgs = {
  portfolioFilter?: InputMaybe<PortfolioCompletionFilter>;
  programId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationTrainingCommunityProgramArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationUserInviteByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryPaymentArgs = {
  id: Scalars['String']['input'];
};


export type QueryPostOrderVerifyPaymentArgs = {
  transactionReference: Scalars['String']['input'];
};


export type QueryPreviewUpgradeProrationArgs = {
  interval: SubscriptionInterval;
  specId: Scalars['String']['input'];
};


export type QueryProArgs = {
  id: Scalars['String']['input'];
};


export type QueryProApplicationByProIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryProCertificationArgs = {
  id: Scalars['String']['input'];
};


export type QueryProCertificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ListProCertificationsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProExistsArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryProPortfolioArgs = {
  handle: Scalars['String']['input'];
};


export type QueryProRecruitmentContractByIdArgs = {
  contractId: Scalars['String']['input'];
};


export type QueryProStudyWorkOpportunityByOpportunityArgs = {
  opportunityId: Scalars['String']['input'];
};


export type QueryProTradeLevelPaymentArgs = {
  proId?: InputMaybe<Scalars['String']['input']>;
  tradeLevelId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProTradeLevelPaymentsArgs = {
  proId?: InputMaybe<Scalars['String']['input']>;
  tradeLevelId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProTradeRequirementArgs = {
  id: Scalars['String']['input'];
};


export type QueryProTradeRequirementsByTradeLevelArgs = {
  tradeLevelId: Scalars['String']['input'];
};


export type QueryProTradeRequirementsForProArgs = {
  proId: Scalars['String']['input'];
};


export type QueryProposedContractEndDateArgs = {
  proposed: ProposedContractInfo;
};


export type QueryProsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ListProsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ListProsSearch>;
  sort?: InputMaybe<ListProsSort>;
};


export type QueryProsWithContractConflictInformationArgs = {
  categoryId: Scalars['String']['input'];
  proposed: ProposedContractInfo;
};


export type QueryQuotationArgs = {
  id: Scalars['String']['input'];
};


export type QueryRecruitmentJobArgs = {
  recruitmentId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};


export type QueryRecruitmentPayrollArgs = {
  id: Scalars['String']['input'];
};


export type QueryRecruitmentPayrollOverlappingContractsArgs = {
  id: Scalars['String']['input'];
};


export type QueryReferrerPayoutByIdArgs = {
  referrerPayoutId: Scalars['String']['input'];
};


export type QueryReferrerPayoutsArgs = {
  transferStatus?: InputMaybe<Array<TransferStatus>>;
};


export type QueryStudyWorkOpportunityArgs = {
  id: Scalars['String']['input'];
};


export type QuerySubscriptionDetailsArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type QuerySubscriptionRequestCallArgs = {
  subscriptionRequestCallId: Scalars['String']['input'];
};


export type QuerySubscriptionRequestCallPayoutDetailsArgs = {
  subscriptionRequestCallPayoutId: Scalars['String']['input'];
};


export type QuerySubscriptionRequestCallPayoutsArgs = {
  transferStatus?: InputMaybe<Array<TransferStatus>>;
};


export type QueryTalentPoolCandidateArgs = {
  id: Scalars['String']['input'];
};


export type QueryThirdPartyIntegratorArgs = {
  id: Scalars['String']['input'];
};


export type QueryThirdPartyIntegratorPayoutArgs = {
  id: Scalars['String']['input'];
};


export type QueryThirdPartyIntegratorPayoutsArgs = {
  thirdPartyIntegratorId?: InputMaybe<Scalars['String']['input']>;
  transferStatus?: InputMaybe<Array<TransferStatus>>;
};


export type QueryThirdPartyIntegratorPayoutsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryTradeArgs = {
  id: Scalars['String']['input'];
};


export type QueryTradesArgs = {
  filters?: InputMaybe<ListTradesFilters>;
};


export type QueryTrainingCommunityMemberArgs = {
  memberId: Scalars['String']['input'];
};


export type QueryTrainingCommunityProgramLogBookArgs = {
  id: Scalars['String']['input'];
};


export type QueryTrainingCommunityProgramLogBookEntryArgs = {
  date: Scalars['String']['input'];
  logBookId: Scalars['String']['input'];
};


export type QueryTrainingCommunityProgramStudentsArgs = {
  programId: Scalars['String']['input'];
};


export type QueryTransferRequestArgs = {
  transferRequestId: Scalars['String']['input'];
};


export type QueryVerifyCardAuthorizationForSubscriptionArgs = {
  transactionReference: Scalars['String']['input'];
};


export type QueryVerifyPaymentArgs = {
  transactionId?: InputMaybe<Scalars['String']['input']>;
  transactionReference: Scalars['String']['input'];
};

export type QuotaUsage = {
  __typename?: 'QuotaUsage';
  activeAdverts: QuotaUsageValue;
  adminSeats: QuotaUsageValue;
  communityMembers: QuotaUsageValue;
  connections: QuotaUsageValue;
};

export type QuotaUsageValue = {
  __typename?: 'QuotaUsageValue';
  used: Scalars['Int']['output'];
};

export enum QuotationStatus {
  Approved = 'APPROVED',
  AwaitingApproval = 'AWAITING_APPROVAL',
  Cancelled = 'CANCELLED',
  NotSent = 'NOT_SENT'
}

export type Rating = {
  __typename?: 'Rating';
  appearance: Scalars['Float']['output'];
  behavior: Scalars['Float']['output'];
  postServiceCleanUp: Scalars['Float']['output'];
  properToolUsage: Scalars['Float']['output'];
  punctuality: Scalars['Float']['output'];
};

export type ReachDetails = {
  __typename?: 'ReachDetails';
  isLowReach: Scalars['Boolean']['output'];
  matched: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type Recipient = {
  __typename?: 'Recipient';
  address: Array<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

/** The recommended action for the client after plan change evaluation */
export enum RecommendedAction {
  Blocked = 'BLOCKED',
  InitiateDowngrade = 'INITIATE_DOWNGRADE',
  PayAndDowngrade = 'PAY_AND_DOWNGRADE',
  PayAndUpgrade = 'PAY_AND_UPGRADE',
  PayProrated = 'PAY_PRORATED',
  StartCardlessTrial = 'START_CARDLESS_TRIAL',
  StartTrial = 'START_TRIAL'
}

export type RecruitToolSalesConversationRequestDto = {
  digitalToolsUsed?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  majorChallenges: Scalars['String']['input'];
  organization: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  preferredSalesConversationDate: Scalars['DateTimeISO']['input'];
  preferredSalesConversationTime: Scalars['String']['input'];
  roleInOrganization: Scalars['String']['input'];
  typeOfTalent: Scalars['String']['input'];
};

export type RecruiterEarlyAccessInvite = {
  __typename?: 'RecruiterEarlyAccessInvite';
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type RecruitmentConsultationDto = {
  companySize: CompanySize;
  duration: DurationDetailsInput;
  email: Scalars['String']['input'];
  employmentType: Scalars['String']['input'];
  expectedStartDate: Scalars['DateTimeISO']['input'];
  industry: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  location: Scalars['String']['input'];
  organization: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  roleInOrganization: Scalars['String']['input'];
  salaryRange: Scalars['String']['input'];
};

export type RecruitmentData = {
  __typename?: 'RecruitmentData';
  agreedDailyRate: Scalars['Float']['output'];
  contract?: Maybe<Contract>;
  numberOfBilledDays: Scalars['Float']['output'];
  period: Period;
};

export type RecruitmentJob = {
  __typename?: 'RecruitmentJob';
  category: Trade;
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  matches: Array<RecruitmentMatch>;
  proCount: Scalars['Float']['output'];
  pros: Array<Pro>;
  request: RecruitmentRequest;
  schedule: RecruitmentJobSchedule;
  shortlist?: Maybe<RecruitmentJobShortlist>;
};

export type RecruitmentJobSchedule = {
  __typename?: 'RecruitmentJobSchedule';
  /** This is the date the job ends. */
  end: Scalars['DateTimeISO']['output'];
  /** An array of dates the pro(s) are not required to work. */
  offDates?: Maybe<Array<Scalars['DateTimeISO']['output']>>;
  /** This is the date the job starts. */
  start: Scalars['DateTimeISO']['output'];
  /** An array of days in week the pro(s) are required to work. For example: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]. */
  workDays: Array<Scalars['String']['output']>;
};

export type RecruitmentJobShortlist = {
  __typename?: 'RecruitmentJobShortlist';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  recruitmentId: Scalars['String']['output'];
  recruitmentRequestId: Scalars['String']['output'];
  shortlistedPros: Array<RecruitmentJobShortlistedPro>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum RecruitmentJobShortlistStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type RecruitmentJobShortlistedPro = {
  __typename?: 'RecruitmentJobShortlistedPro';
  potentialMonthlyGrossSalary?: Maybe<Scalars['Float']['output']>;
  pro: Pro;
  status: RecruitmentJobShortlistStatus;
};

/** keeps track of a pro that matches a recruitment job under request */
export type RecruitmentMatch = {
  __typename?: 'RecruitmentMatch';
  potentialMonthlyGrossSalary?: Maybe<Scalars['Float']['output']>;
  pro: RecruitmentMatchPro;
  relevantSkills: Array<RecruitmentProSkill>;
};

export type RecruitmentMatchPro = {
  __typename?: 'RecruitmentMatchPro';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type RecruitmentPaymentSettings = {
  __typename?: 'RecruitmentPaymentSettings';
  payBeforeService: Scalars['Boolean']['output'];
};

export type RecruitmentPayroll = {
  __typename?: 'RecruitmentPayroll';
  id: Scalars['String']['output'];
  period: RecruitmentPayrollPeriod;
  recruitment: ContractRecruitment;
};

export type RecruitmentPayrollPeriod = {
  __typename?: 'RecruitmentPayrollPeriod';
  end: Scalars['DateTimeISO']['output'];
  start: Scalars['DateTimeISO']['output'];
};

export type RecruitmentPayrollPeriodInput = {
  end: Scalars['DateTimeISO']['input'];
  start: Scalars['DateTimeISO']['input'];
};

export type RecruitmentProSkill = {
  __typename?: 'RecruitmentProSkill';
  name: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type RecruitmentRequest = {
  __typename?: 'RecruitmentRequest';
  _id: Scalars['String']['output'];
  categoryId: Scalars['String']['output'];
  contractDetails?: Maybe<ContractDetails>;
  id: Scalars['String']['output'];
  /** the invoice for this request */
  matchingFeeInvoice?: Maybe<Invoice>;
  nonWorkingDays?: Maybe<Array<Scalars['String']['output']>>;
  proCount: Scalars['Float']['output'];
  proLevel: Scalars['Float']['output'];
  proposedStartDate: Scalars['DateTimeISO']['output'];
  shortlistId?: Maybe<Scalars['String']['output']>;
};

export type RecruitmentRequestInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  contractDetails?: InputMaybe<ContractDetailsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  nonWorkingDays?: InputMaybe<Array<Scalars['String']['input']>>;
  proCount: Scalars['Float']['input'];
  proLevel: Scalars['Float']['input'];
  proposedStartDate: Scalars['DateTimeISO']['input'];
};

export enum RecruitmentRequestStatus {
  Assigning = 'ASSIGNING',
  Fulfilled = 'FULFILLED',
  Pending = 'PENDING',
  QuotationSent = 'QUOTATION_SENT'
}

export enum RecruitmentType {
  Contract = 'CONTRACT',
  FullTime = 'FULL_TIME'
}

/** A referee for a user */
export type Referee = {
  __typename?: 'Referee';
  companyAddress: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  relationship: Scalars['String']['output'];
};

export type RefereeInput = {
  companyAddress: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  relationship: Scalars['String']['input'];
};

export type Referrer = {
  __typename?: 'Referrer';
  businessName: Scalars['String']['output'];
  commissionPercentage: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  linkedDiscount?: Maybe<InvoiceDiscount>;
  marketingCampaign: MarketingCampaign;
  name: Scalars['String']['output'];
  paymentProviderInformation?: Maybe<PaymentProviderInformation>;
  referralCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ReferrerInput = {
  businessName: Scalars['String']['input'];
  commissionPercentage: Scalars['Float']['input'];
  email: Scalars['String']['input'];
  linkedDiscountCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  referralCode: Scalars['String']['input'];
};

export type ReferrerPayout = {
  __typename?: 'ReferrerPayout';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  override?: Maybe<ReferrerPayoutOverride>;
  period: MonthYear;
  referrer: Referrer;
  transfer?: Maybe<Transfer>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ReferrerPayoutOverride = {
  __typename?: 'ReferrerPayoutOverride';
  amount?: Maybe<Scalars['Float']['output']>;
  reason: Scalars['String']['output'];
};

export type ReferrerPayoutOverrideInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  reason: Scalars['String']['input'];
};

export type ReferrerStatistics = {
  __typename?: 'ReferrerStatistics';
  allTimeEarnings: Scalars['Float']['output'];
  allTimeNumberOfReferrals: Scalars['Float']['output'];
  earningsThisMonth: Scalars['Float']['output'];
  numberOfReferralsThisMonth: Scalars['Float']['output'];
  referrerId: Scalars['String']['output'];
};

export type Refund = {
  __typename?: 'Refund';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  order: Order;
  pointChanges: Array<RefundPointChange>;
  preferredTransferAccount: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  refundItems: Array<RefundItem>;
  transfer: Transfer;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type RefundItem = {
  __typename?: 'RefundItem';
  amount: Scalars['Float']['output'];
  assignment: TradesmanAssignment;
  job: Job;
};

export type RefundPointChange = {
  __typename?: 'RefundPointChange';
  pointChange: Scalars['Float']['output'];
  tradesman: Tradesman;
};

export type RegisterBusinessInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clients?: InputMaybe<Array<CreateBusinessClientInput>>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterNewClientInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leadSource: LeadSource;
  marketingTag?: InputMaybe<Scalars['String']['input']>;
  otherLeadSourceText?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export enum RemittanceInterval {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum RenovationArea {
  BathroomRemodeling = 'BATHROOM_REMODELING',
  Carpentry = 'CARPENTRY',
  Electrical = 'ELECTRICAL',
  FlooringTiling = 'FLOORING_TILING',
  KitchenRemodeling = 'KITCHEN_REMODELING',
  Other = 'OTHER',
  Painting = 'PAINTING',
  Plumbing = 'PLUMBING',
  Roofing = 'ROOFING',
  WindowsDoors = 'WINDOWS_DOORS'
}

export type RenovationProjectRequestDto = {
  areas: Array<RenovationArea>;
  contactInfo: ContactInfoInput;
  intendedDuration: SimpleDuration;
  organizationInfo?: InputMaybe<OrganizationInfoInput>;
  otherArea?: InputMaybe<Scalars['String']['input']>;
  projectLocation: Scalars['String']['input'];
  requiresStructuralChanges: Scalars['Boolean']['input'];
};

export type Review = {
  __typename?: 'Review';
  assignment: TradesmanAssignment;
  averageRating: Scalars['Float']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  rating: Rating;
  tradesman: Tradesman;
};

export enum Role {
  Bot = 'BOT',
  BusinessDeveloper = 'BUSINESS_DEVELOPER',
  CertificationAdministrator = 'CERTIFICATION_ADMINISTRATOR',
  Client = 'CLIENT',
  Customerservice = 'CUSTOMERSERVICE',
  Employer = 'EMPLOYER',
  Finance = 'FINANCE',
  Outreach = 'OUTREACH',
  Pro = 'PRO',
  Projectmanager = 'PROJECTMANAGER',
  ProAdministrator = 'PRO_ADMINISTRATOR',
  RecruitmentAdministrator = 'RECRUITMENT_ADMINISTRATOR',
  Root = 'ROOT',
  SystemAdministrator = 'SYSTEM_ADMINISTRATOR',
  Tradesman = 'TRADESMAN',
  TrainingCommunityAdmin = 'TRAINING_COMMUNITY_ADMIN',
  UserAdministrator = 'USER_ADMINISTRATOR'
}

export type RotateOrganizationApiSecretResponse = {
  __typename?: 'RotateOrganizationApiSecretResponse';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type SmsCreditPurchaseRequest = {
  __typename?: 'SMSCreditPurchaseRequest';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  creditsAllocated: Scalars['Float']['output'];
  exchangeRate: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  invoice: Invoice;
  organization: Organization;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type SmsLedgerEntry = {
  __typename?: 'SMSLedgerEntry';
  amount: Scalars['Float']['output'];
  announcement?: Maybe<CommunityAnnouncement>;
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  organization: Organization;
  planSubscription?: Maybe<OrganizationPlanSubscription>;
  purchaseRequest?: Maybe<SmsCreditPurchaseRequest>;
  transactionType: SmsLedgerTransactionType;
  type: SmsLedgerEntryType;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum SmsLedgerEntryType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export enum SmsLedgerTransactionType {
  Payg = 'PAYG',
  Subscription = 'SUBSCRIPTION',
  Usage = 'USAGE'
}

export type SalaryDetails = {
  __typename?: 'SalaryDetails';
  cap?: Maybe<Scalars['Float']['output']>;
  currency: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  starting: Scalars['Float']['output'];
};

export type SalaryDetailsInput = {
  cap?: InputMaybe<Scalars['Float']['input']>;
  currency: Scalars['String']['input'];
  currencyCode: Scalars['String']['input'];
  starting: Scalars['Float']['input'];
};

export type SaveBusinessClientInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SaveBusinessInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clients?: InputMaybe<Array<SaveBusinessClientInput>>;
  name: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export enum ScheduleConflictType {
  AssignmentScheduled = 'ASSIGNMENT_SCHEDULED',
  ContractOverlap = 'CONTRACT_OVERLAP',
  MarketplaceMatch = 'MARKETPLACE_MATCH'
}

export type ScheduleConflictUnion = AssignmentConflict | ContractConflict | MarketplaceConflict;

export type ScoringTemplateField = {
  __typename?: 'ScoringTemplateField';
  description?: Maybe<Scalars['String']['output']>;
  maximumScore?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type SentEmail = {
  __typename?: 'SentEmail';
  createdAt: Scalars['DateTimeISO']['output'];
  deliveryStatus: SentEmailDeliveryStatus;
  id: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  recipientEmail: Scalars['String']['output'];
  template: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum SentEmailDeliveryStatus {
  Delivered = 'Delivered',
  Failed = 'Failed',
  Opened = 'Opened',
  Pending = 'Pending'
}

export type ServiceRequestResponse = {
  __typename?: 'ServiceRequestResponse';
  done: Scalars['Boolean']['output'];
};

export type ShadowUserPayload = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  partnerCountryCode?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
};

export type ShareOrganizationTalentPoolDto = {
  expiresAt: Scalars['DateTimeISO']['input'];
  masterPoolId: Scalars['String']['input'];
  organizationDetails: OrganizationSharingInput;
};

export type ShareableApplication = {
  __typename?: 'ShareableApplication';
  applicant: CensoredApplicant;
  certifications: Array<JobApplicationCertification>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  education: Array<JobApplicationEducation>;
  employmentHistory: Array<JobApplicationEmploymentHistoryItem>;
  projectHistory: Array<JobApplicationProjectHistoryItem>;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ShortlistAnalytics = {
  __typename?: 'ShortlistAnalytics';
  nonShortlistedCount: Scalars['Float']['output'];
  shortlistRate: Scalars['String']['output'];
  shortlistedCount: Scalars['Float']['output'];
  totalApplications: Scalars['Float']['output'];
};

export enum SimpleDuration {
  Gt_6Months = 'GT_6_MONTHS',
  Lt_1Month = 'LT_1_MONTH',
  OneToThreeMonths = 'ONE_TO_THREE_MONTHS',
  ThreeToSixMonths = 'THREE_TO_SIX_MONTHS'
}

export type SplitPayment = {
  __typename?: 'SplitPayment';
  payment?: Maybe<Payment>;
  percentage: Scalars['Float']['output'];
};

export type StartBillingForRecruitmentInput = {
  id: Scalars['String']['input'];
  options: StartBillingForRecruitmentOptions;
};

export type StartBillingForRecruitmentOptions = {
  billingAddressId: Scalars['String']['input'];
  payBeforeService: Scalars['Boolean']['input'];
};

export enum Status {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Paused = 'PAUSED'
}

export type StudyWorkOpportunity = {
  __typename?: 'StudyWorkOpportunity';
  country: StudyWorkOpportunityCountry;
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum StudyWorkOpportunityCountry {
  Canada = 'CANADA'
}

/** The SubCategory model */
export type SubCategory = {
  __typename?: 'SubCategory';
  categoryId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  taskIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type SubCategoryInput = {
  category: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  requestCount?: Scalars['Float']['input'];
};

export type SubmitIdentityInformationInput = {
  dateOfBirth?: InputMaybe<Scalars['DateTimeISO']['input']>;
  identificationNumber: Scalars['String']['input'];
  /** Base64 encoded photo of the user's ID */
  identityImage?: InputMaybe<Scalars['String']['input']>;
  /** URL of the user's ID image */
  identityImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Base64 encoded photos of the user's face for a liveness check */
  livenessImages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Base64 encoded photo of the user */
  selfieImage?: InputMaybe<Scalars['String']['input']>;
  type: MeansOfIdentification;
};

export type SubmitProApplicationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  averageMonthlyIncome: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  channelOutreachSourceId?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  currentIndustry?: InputMaybe<Industry>;
  dateOfBirth: Scalars['DateTimeISO']['input'];
  detailedAddress?: InputMaybe<AddressInput>;
  email: Scalars['String']['input'];
  employmentStatus: EmploymentStatus;
  firstName: Scalars['String']['input'];
  gender: Gender;
  highestEducationLevel?: InputMaybe<EducationLevel>;
  identification?: InputMaybe<ProApplicationIdentificationInput>;
  incomeCurrency?: InputMaybe<Scalars['String']['input']>;
  incomeLevel?: InputMaybe<IncomeLevel>;
  jobTitle: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  leadSource: Scalars['String']['input'];
  leadSourceText?: InputMaybe<Scalars['String']['input']>;
  locationOutreachSourceId?: InputMaybe<Scalars['String']['input']>;
  numberOfDaysWorkedPerWeek: Scalars['Int']['input'];
  otherCategoryText?: InputMaybe<Scalars['String']['input']>;
  otherRelevantDocumentUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber: Scalars['String']['input'];
  phoneType: PhoneType;
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  reasonForJoiningLaborHack?: InputMaybe<Scalars['String']['input']>;
  reasonForJoiningLaborHackOtherText?: InputMaybe<Scalars['String']['input']>;
  reasonsForJoiningLaborHack?: InputMaybe<Array<Scalars['String']['input']>>;
  referredBy?: InputMaybe<Scalars['String']['input']>;
  resumeUrl?: InputMaybe<Scalars['String']['input']>;
  stateOfResidence?: InputMaybe<Scalars['String']['input']>;
  tags: Array<Scalars['String']['input']>;
  trainingType?: InputMaybe<TrainingType>;
  userAddedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  yearsOfExperience: Scalars['Float']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  newClientNotification: NotificationPayload;
};

export enum SubscriptionInterval {
  Biannually = 'BIANNUALLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export type SubscriptionRequest = {
  __typename?: 'SubscriptionRequest';
  address?: Maybe<Address>;
  cancelledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  category: Category;
  client: Client;
  createdAt: Scalars['DateTimeISO']['output'];
  homeownerRequest: HomeownerRequest;
  id: Scalars['String']['output'];
  lastBillingDate?: Maybe<Scalars['DateTimeISO']['output']>;
  orderCode: Scalars['String']['output'];
  payments: Array<SubscriptionRequestPayment>;
  plan: CategorySubscriptionPackagePlan;
  providerCode?: Maybe<Scalars['String']['output']>;
  status: SubscriptionStatus;
  subscriptionRequestCalls: Array<SubscriptionRequestCall>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type SubscriptionRequestCall = {
  __typename?: 'SubscriptionRequestCall';
  assignedPro?: Maybe<Pro>;
  createdAt: Scalars['DateTimeISO']['output'];
  dateOfAssignment: Scalars['DateTimeISO']['output'];
  expectedProPaymentAmount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  proPaymentAmount?: Maybe<Scalars['Float']['output']>;
  subscriptionRequest: SubscriptionRequest;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type SubscriptionRequestCallPayout = {
  __typename?: 'SubscriptionRequestCallPayout';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  override?: Maybe<SubscriptionRequestCallPayoutOverride>;
  period: MonthYear;
  pro: Pro;
  subscriptionRequestCalls: Array<SubscriptionRequestCall>;
  transfer?: Maybe<Transfer>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type SubscriptionRequestCallPayoutOverride = {
  __typename?: 'SubscriptionRequestCallPayoutOverride';
  amount?: Maybe<Scalars['Float']['output']>;
  reason: Scalars['String']['output'];
};

export type SubscriptionRequestCallPayoutOverrideInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  reason: Scalars['String']['input'];
};

export type SubscriptionRequestPayment = {
  __typename?: 'SubscriptionRequestPayment';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  invoice: Invoice;
  subscriptionRequest: SubscriptionRequest;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type SystemAdminCreateOrganizationTalentPoolDto = {
  communityMemberEmails: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  impersonatedOrganizationUserId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Arguments for forcing an emergency downgrade of a broken trial subscription to free */
export type SystemAdminForceDowngradeOrganizationToFreeArgs = {
  /** Organization ID to force-downgrade to free */
  organizationId: Scalars['String']['input'];
};

/** Result of a system-admin emergency downgrade of an organization to free */
export type SystemAdminForceDowngradeOrganizationToFreeResult = {
  __typename?: 'SystemAdminForceDowngradeOrganizationToFreeResult';
  organizationId: Scalars['String']['output'];
  providerCancellationAttempted: Scalars['Boolean']['output'];
  providerCancellationSkippedReason?: Maybe<Scalars['String']['output']>;
  resultingSubscriptionId: Scalars['String']['output'];
  sourcePlanSpecId: Scalars['String']['output'];
  sourceSubscriptionId: Scalars['String']['output'];
  targetFreePlanSpecId: Scalars['String']['output'];
};

export type SystemAdminShareOrganizationTalentPoolDto = {
  expiresAt: Scalars['DateTimeISO']['input'];
  impersonatedOrganizationUserId: Scalars['String']['input'];
  masterPoolId: Scalars['String']['input'];
  organizationDetails: Array<OrganizationSharingInput>;
};

export type TalentPoolCandidate = {
  __typename?: 'TalentPoolCandidate';
  communityMember: TrainingCommunityMember;
  createdAt: Scalars['DateTimeISO']['output'];
  hiringTerms?: Maybe<EmploymentHiringTerms>;
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  poolInstance: OrganizationTalentPoolInstance;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: TalentPoolCandidateStatus;
  statusHistory: Array<TalentPoolStatusHistory>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum TalentPoolCandidateStatus {
  Hired = 'HIRED',
  Interview = 'INTERVIEW',
  Recommended = 'RECOMMENDED',
  Rejected = 'REJECTED',
  Shortlisted = 'SHORTLISTED'
}

export type TalentPoolHiringTermsInput = {
  contractLength?: InputMaybe<Scalars['Int']['input']>;
  contractUnit?: InputMaybe<EmploymentContractUnit>;
  employmentType: EmploymentType;
  salary?: InputMaybe<Scalars['Float']['input']>;
  salaryUnit?: InputMaybe<EmploymentSalaryUnit>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  title: Scalars['String']['input'];
};

export type TalentPoolStatusHistory = {
  __typename?: 'TalentPoolStatusHistory';
  notes?: Maybe<Scalars['String']['output']>;
  status: TalentPoolCandidateStatus;
  timestamp: Scalars['DateTimeISO']['output'];
};

/** The Task Model */
export type Task = {
  __typename?: 'Task';
  categoryId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  estimatedCost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requestCount?: Maybe<Scalars['Float']['output']>;
  subCategoryId?: Maybe<Scalars['String']['output']>;
};

export type TextNotificationPayload = NotificationPayload & {
  __typename?: 'TextNotificationPayload';
  event: NotificationEvent;
  order: NotificationPayloadOrder;
  text: NotificationPayloadText;
};

export type ThirdPartyDetailsInput = {
  createThirdParty?: InputMaybe<CreateThirdPartyInput>;
  thirdPartyId?: InputMaybe<Scalars['String']['input']>;
};

export type ThirdPartyIntegrator = {
  __typename?: 'ThirdPartyIntegrator';
  appId: Scalars['String']['output'];
  client?: Maybe<Client>;
  clientProfile?: Maybe<ClientProfile>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paymentProviderInformation?: Maybe<PaymentProviderInformation>;
  policy?: Maybe<ThirdPartyIntegratorPolicy>;
  updatedAt: Scalars['DateTimeISO']['output'];
  webhookUrl: Scalars['String']['output'];
};

export type ThirdPartyIntegratorPayout = {
  __typename?: 'ThirdPartyIntegratorPayout';
  breakdown: ThirdPartyIntegratorPayoutBreakdown;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  orders: Array<Order>;
  override?: Maybe<ThirdPartyIntegratorPayoutOverride>;
  payoutPeriodEnd: Scalars['DateTimeISO']['output'];
  payoutPeriodStart: Scalars['DateTimeISO']['output'];
  thirdPartyIntegrator: ThirdPartyIntegrator;
  transfer?: Maybe<Transfer>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ThirdPartyIntegratorPayoutBreakdown = {
  __typename?: 'ThirdPartyIntegratorPayoutBreakdown';
  gross: Scalars['Float']['output'];
  net: Scalars['Float']['output'];
};

export type ThirdPartyIntegratorPayoutOverride = {
  __typename?: 'ThirdPartyIntegratorPayoutOverride';
  amount: Scalars['Float']['output'];
  reason: Scalars['String']['output'];
};

export type ThirdPartyIntegratorPayoutOverrideInput = {
  amount: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
};

export type ThirdPartyIntegratorPolicy = {
  __typename?: 'ThirdPartyIntegratorPolicy';
  remittanceInterval: RemittanceInterval;
  serviceFeeSharePercentage: Scalars['Float']['output'];
};

export type ToDetails = {
  __typename?: 'ToDetails';
  address: Scalars['String']['output'];
  client: ArtisanClient;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type Trade = {
  __typename?: 'Trade';
  category: Category;
  certification: Certification;
  createdAt: Scalars['DateTimeISO']['output'];
  currentLevel?: Maybe<Scalars['Float']['output']>;
  description: Scalars['String']['output'];
  displayPriority?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  levels: Array<TradeLevel>;
  name: Scalars['String']['output'];
};


export type TradeCurrentLevelArgs = {
  proId?: InputMaybe<Scalars['String']['input']>;
};

export type TradeLevel = {
  __typename?: 'TradeLevel';
  certificate?: Maybe<Certificate>;
  createdAt: Scalars['DateTimeISO']['output'];
  hasAccess?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Int']['output'];
  requirements: Array<TradeRequirement>;
  trade: Trade;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type TradeLevelCertificateArgs = {
  proId?: InputMaybe<Scalars['String']['input']>;
};

export type TradeRequirement = {
  __typename?: 'TradeRequirement';
  actions: Array<TradeRequirementActions>;
  class?: Maybe<TradeRequirementClass>;
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  discounts?: Maybe<Array<ProTradeLevelDiscount>>;
  id: Scalars['String']['output'];
  invitationUrl?: Maybe<Scalars['String']['output']>;
  isPassed?: Maybe<Scalars['Boolean']['output']>;
  lmsCourseId?: Maybe<Scalars['String']['output']>;
  lmsExternalId?: Maybe<Scalars['String']['output']>;
  lmsId?: Maybe<Scalars['String']['output']>;
  maximumScore?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  passingScore?: Maybe<Scalars['Float']['output']>;
  preRequisites?: Maybe<Array<TradeRequirement>>;
  price: Scalars['Float']['output'];
  proTradeRequirement?: Maybe<ProTradeRequirement>;
  prompt: Scalars['String']['output'];
  scoringTemplate?: Maybe<Array<ScoringTemplateField>>;
  type: TradeRequirementType;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type TradeRequirementDiscountsArgs = {
  proId: Scalars['String']['input'];
};


export type TradeRequirementIsPassedArgs = {
  proId: Scalars['String']['input'];
};


export type TradeRequirementProTradeRequirementArgs = {
  proId: Scalars['String']['input'];
};

export enum TradeRequirementActionTypes {
  OpenUrl = 'OPEN_URL'
}

export type TradeRequirementActions = {
  __typename?: 'TradeRequirementActions';
  external?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  type: TradeRequirementActionTypes;
  url: Scalars['String']['output'];
};

export enum TradeRequirementClass {
  AlternativeToPractical = 'ALTERNATIVE_TO_PRACTICAL',
  PriorLearning = 'PRIOR_LEARNING',
  SoftSkills = 'SOFT_SKILLS'
}

export enum TradeRequirementType {
  ExternalAssessment = 'EXTERNAL_ASSESSMENT',
  InternalAssessment = 'INTERNAL_ASSESSMENT',
  Interview = 'INTERVIEW'
}

/** The Tradesman's Model */
export type Tradesman = {
  __typename?: 'Tradesman';
  accountNumber?: Maybe<Scalars['String']['output']>;
  assignedTo: Array<TradesmanAssignment>;
  authProviderId?: Maybe<Scalars['String']['output']>;
  bankCode?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  categoryId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  level: Scalars['Float']['output'];
  location: Location;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  rewardPoints?: Maybe<Scalars['Float']['output']>;
  taxIdentificationNumber?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type TradesmanAssignment = {
  __typename?: 'TradesmanAssignment';
  assignmentPayments?: Maybe<Array<AssignmentPayment>>;
  category: Category;
  checklists?: Maybe<Checklists>;
  client?: Maybe<Client>;
  clientProfile?: Maybe<ClientProfile>;
  currentQuote?: Maybe<OrderHandlingQuotation>;
  date: Scalars['DateTimeISO']['output'];
  homeownerRequest?: Maybe<HomeownerRequest>;
  id: Scalars['String']['output'];
  inspectionPayment?: Maybe<Payment>;
  inspectionWaived?: Maybe<Scalars['Boolean']['output']>;
  invoice?: Maybe<Invoice>;
  jobs: Array<Job>;
  order: Order;
  otherPros: Array<Tradesman>;
  progress?: Maybe<AssignmentProgress>;
  tradesman: Tradesman;
};


export type TradesmanAssignmentCurrentQuoteArgs = {
  includeUnsent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TradesmanAssignmentVisit = {
  __typename?: 'TradesmanAssignmentVisit';
  arrivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  assignment: TradesmanAssignment;
  cancelledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  client: Client;
  clientProfile?: Maybe<ClientProfile>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  reason: VisitReason;
  status: VisitStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
  visitDate: Scalars['DateTimeISO']['output'];
};

export type TradesmanLocation = {
  area?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  landmark?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
};

export type TradesmanProfile = {
  __typename?: 'TradesmanProfile';
  assignmentsCompleted: Scalars['Float']['output'];
  biodata: Tradesman;
  rating: Scalars['Float']['output'];
  totalPoints: Scalars['Float']['output'];
};

export type TradesmanWithAvailability = {
  __typename?: 'TradesmanWithAvailability';
  assignedTo: Array<TradesmanAssignment>;
  availability: Availability;
  categoryId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  level: Scalars['Float']['output'];
  location: Location;
  phoneNumber: Scalars['String']['output'];
  referralCode?: Maybe<Scalars['String']['output']>;
  taxIdentificationNumber?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type TrainingCommunityAdmin = {
  __typename?: 'TrainingCommunityAdmin';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationUser: OrganizationUser;
  userId: Scalars['String']['output'];
};

export type TrainingCommunityMember = {
  __typename?: 'TrainingCommunityMember';
  addedBy: TrainingCommunityAdmin;
  createdAt: Scalars['DateTimeISO']['output'];
  email?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  phone?: Maybe<Scalars['String']['output']>;
  pro?: Maybe<Pro>;
  programs: Array<TrainingCommunityProgram>;
  source: TrainingCommunityMemberSource;
  status: TrainingCommunityMemberStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum TrainingCommunityMemberSource {
  CsvImport = 'CSV_IMPORT',
  InviteLink = 'INVITE_LINK',
  Manual = 'MANUAL'
}

export enum TrainingCommunityMemberStatus {
  NotRegistered = 'NOT_REGISTERED',
  Registered = 'REGISTERED',
  SetupCompleted = 'SETUP_COMPLETED'
}

export type TrainingCommunityProgram = {
  __typename?: 'TrainingCommunityProgram';
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: TrainingCommunityAdmin;
  enableLogBookReporting?: Maybe<Scalars['Boolean']['output']>;
  endDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  logBookReportingFrequency?: Maybe<LogBookReportingFrequency>;
  logBookSupervisors: Array<OrganizationPartnershipShadowUser>;
  name: Scalars['String']['output'];
  organization: Organization;
  pendingSupervisorInvitations: Array<OrganizationUserInvite>;
  startDate: Scalars['String']['output'];
  supervisors: Array<TrainingCommunityProgramSupervisor>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type TrainingCommunityProgramLogBookEntryInput = {
  date: Scalars['String']['input'];
  tasks: Array<TrainingCommunityProgramLogBookEntryTaskInput>;
};

export type TrainingCommunityProgramLogBookEntryTaskInput = {
  description: Scalars['String']['input'];
  media?: InputMaybe<Array<TrainingCommunityProgramStudentLogBookEntryTaskMediaItemInput>>;
};

export type TrainingCommunityProgramStudent = {
  __typename?: 'TrainingCommunityProgramStudent';
  createdAt: Scalars['DateTimeISO']['output'];
  currentSupervisor?: Maybe<TrainingCommunityProgramStudentSupervisor>;
  id: Scalars['String']['output'];
  logBook?: Maybe<TrainingCommunityProgramStudentLogBook>;
  member: TrainingCommunityMember;
  program: TrainingCommunityProgram;
  supervisors: Array<TrainingCommunityProgramStudentSupervisor>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type TrainingCommunityProgramStudentLogBook = {
  __typename?: 'TrainingCommunityProgramStudentLogBook';
  createdAt: Scalars['DateTimeISO']['output'];
  entries: Array<TrainingCommunityProgramStudentLogBookEntry>;
  id: Scalars['String']['output'];
  program: TrainingCommunityProgram;
  student: TrainingCommunityProgramStudent;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type TrainingCommunityProgramStudentLogBookEntry = {
  __typename?: 'TrainingCommunityProgramStudentLogBookEntry';
  comments: Array<TrainingCommunityProgramStudentLogBookEntryComment>;
  createdAt: Scalars['DateTimeISO']['output'];
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  logBook: TrainingCommunityProgramStudentLogBook;
  reviewedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  reviewedBy?: Maybe<TrainingCommunityAdmin>;
  submittedAt: Scalars['DateTimeISO']['output'];
  tasks: Array<TrainingCommunityProgramStudentLogBookEntryTask>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type TrainingCommunityProgramStudentLogBookEntryComment = {
  __typename?: 'TrainingCommunityProgramStudentLogBookEntryComment';
  author: OrganizationUser;
  createdAt: Scalars['DateTimeISO']['output'];
  text: Scalars['String']['output'];
};

export type TrainingCommunityProgramStudentLogBookEntryTask = {
  __typename?: 'TrainingCommunityProgramStudentLogBookEntryTask';
  description: Scalars['String']['output'];
  media: Array<TrainingCommunityProgramStudentLogBookEntryTaskMediaItem>;
};

export type TrainingCommunityProgramStudentLogBookEntryTaskMediaItem = {
  __typename?: 'TrainingCommunityProgramStudentLogBookEntryTaskMediaItem';
  key: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  originalUrl: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
};

export type TrainingCommunityProgramStudentLogBookEntryTaskMediaItemInput = {
  key: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type TrainingCommunityProgramStudentSupervisor = {
  __typename?: 'TrainingCommunityProgramStudentSupervisor';
  startsAt: Scalars['DateTimeISO']['output'];
  supervisor: OrganizationPartnershipShadowUser;
};

export type TrainingCommunityProgramSupervisor = {
  __typename?: 'TrainingCommunityProgramSupervisor';
  isActive: Scalars['Boolean']['output'];
  user: OrganizationUser;
};

export type TrainingEarlyAccessInvite = {
  __typename?: 'TrainingEarlyAccessInvite';
  claimedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
};

export enum TrainingType {
  Apprentice = 'APPRENTICE',
  College = 'COLLEGE',
  Other = 'OTHER',
  Polytechnic = 'POLYTECHNIC',
  TrainingInstitute = 'TRAINING_INSTITUTE'
}

export enum TransactionStatus {
  Failure = 'FAILURE',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type Transfer = {
  __typename?: 'Transfer';
  amount?: Maybe<Scalars['Float']['output']>;
  approvedBy?: Maybe<Admin>;
  auditedBy?: Maybe<Admin>;
  bankName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initiatedBy: Admin;
  providerId: Scalars['String']['output'];
  purpose: TransferTypes;
  recipientCode: Scalars['String']['output'];
  status?: Maybe<TransferStatus>;
  transactionDate?: Maybe<Scalars['DateTimeISO']['output']>;
  transactionReference?: Maybe<Scalars['String']['output']>;
  transferCode?: Maybe<Scalars['String']['output']>;
};

export type TransferRecipient = {
  __typename?: 'TransferRecipient';
  bankInformation?: Maybe<BankAccountInformation>;
  providerId: Scalars['String']['output'];
  recipientCode: Scalars['String']['output'];
};

export enum TransferStatus {
  AwaitingApproval = 'AWAITING_APPROVAL',
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Queued = 'QUEUED',
  Reversed = 'REVERSED'
}

export enum TransferTypes {
  ContractorPayment = 'CONTRACTOR_PAYMENT',
  Handling = 'HANDLING',
  ReferrerPayout = 'REFERRER_PAYOUT',
  Refund = 'REFUND',
  SubscriptionScheduledRequestPayout = 'SUBSCRIPTION_SCHEDULED_REQUEST_PAYOUT',
  ThirdPartyIntegratorPayout = 'THIRD_PARTY_INTEGRATOR_PAYOUT'
}

/** Arguments for transitioning all organizations on a plan spec to a new version */
export type TransitionAllOrganizationsPlanSpecArgs = {
  /** Source plan specification ID (current version) */
  sourceSpecId: Scalars['String']['input'];
  /** Target plan specification ID (new version) */
  targetSpecId: Scalars['String']['input'];
};

/** Arguments for transitioning a single organization to a new plan spec version */
export type TransitionOrganizationPlanSpecArgs = {
  /** Organization ID to transition */
  organizationId: Scalars['String']['input'];
  /** Target plan specification ID (new version) */
  targetSpecId: Scalars['String']['input'];
};

/** Result of transitioning a single organization */
export type TransitionOrganizationPlanSpecResult = {
  __typename?: 'TransitionOrganizationPlanSpecResult';
  /** Action taken for this organization */
  action: Scalars['String']['output'];
  /** Transition intent created (for scheduled paid plan transitions) */
  intent?: Maybe<OrganizationPlanSpecTransitionIntent>;
  /** New subscription created (for immediate transitions) */
  newSubscription?: Maybe<OrganizationPlanSubscription>;
};

/** Information about free trial availability */
export type TrialInfo = {
  __typename?: 'TrialInfo';
  /** Whether card-less trial is available */
  cardlessTrialAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Whether any free trial is available */
  isAvailable: Scalars['Boolean']['output'];
  /** Length of trial in days (if available) */
  lengthInDays?: Maybe<Scalars['Int']['output']>;
  /** Whether card is required for trial */
  requiresCard?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAssignmentPaymentInput = {
  amount: Scalars['Float']['input'];
  assignmentPaymentId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  proId: Scalars['String']['input'];
};

export type UpdateAssignmentResponse = {
  __typename?: 'UpdateAssignmentResponse';
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type UpdateCandidateStatusDto = {
  candidateId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  status: TalentPoolCandidateStatus;
};

export type UpdateCertificationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommunityAnnouncementInput = {
  communicationChannels?: InputMaybe<Array<CommunicationChannel>>;
  publishedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<CommunityAnnouncementStatus>;
  targetSegmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CommunityAnnouncementType>;
};

export type UpdateCommunityJobOpportunityInput = {
  applicationDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<DurationDetailsInput>;
  employmentType?: InputMaybe<EmploymentType>;
  location?: InputMaybe<JobLocationInput>;
  salary?: InputMaybe<SalaryDetailsInput>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommunitySegmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  memberIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<CommunitySegmentStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractQuotationItemsInput = {
  id: Scalars['String']['input'];
  items: Array<ContractQuotationItemInput>;
};

export type UpdateContractRecruitmentInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  recruitmentDiscountValue?: InputMaybe<Scalars['Float']['input']>;
  requests?: InputMaybe<Array<RecruitmentRequestInput>>;
  status?: InputMaybe<RecruitmentRequestStatus>;
};

export type UpdateJobFinalCostInput = {
  finalCost: Scalars['Int']['input'];
  jobId: Scalars['String']['input'];
};

export type UpdateJobsInvoiceDetailsInput = {
  items: Array<JobInvoiceDetailsItem>;
};

export type UpdateMaterialsInvoiceInput = {
  allowedPaymentProviders?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceId: Scalars['String']['input'];
  jobUpdates: Array<JobInvoiceDetailsItem>;
  splits?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type UpdateProRecruitmentContractInput = {
  agreedRate?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id: Scalars['String']['input'];
  potentialMonthlyGrossSalary?: InputMaybe<Scalars['Float']['input']>;
  proLevel?: InputMaybe<Scalars['Int']['input']>;
  recruitmentType?: InputMaybe<RecruitmentType>;
  requestedStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<ProRecruitmentContractStatus>;
  terminatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UpdateTradeInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  certificationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTrainingCommunityProgramInput = {
  enableLogBookReporting?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invitedSupervisorEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  logBookReportingFrequency?: InputMaybe<LogBookReportingFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  supervisorIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Preview of proration calculation for a paid-to-paid upgrade */
export type UpgradeProrationPreview = {
  __typename?: 'UpgradeProrationPreview';
  /** Current plan price for the interval */
  currentPlanPrice?: Maybe<Scalars['Int']['output']>;
  /** Days remaining in current billing period */
  daysRemaining?: Maybe<Scalars['Int']['output']>;
  isEligible: Scalars['Boolean']['output'];
  /** New plan price for the interval */
  newPlanPrice?: Maybe<Scalars['Int']['output']>;
  /** Prorated amount to charge in Naira */
  proratedAmount?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /** Total days in current billing period */
  totalDaysInPeriod?: Maybe<Scalars['Int']['output']>;
};

export type UsageStatistics = {
  __typename?: 'UsageStatistics';
  orders: OrderUsageStatistics;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type UserAddedTag = {
  __typename?: 'UserAddedTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pro: Pro;
};

export type UserNotification = {
  __typename?: 'UserNotification';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  notification: NotificationPayload;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum UserType {
  Pro = 'PRO'
}

export enum VatApplicationScope {
  EntireInvoice = 'ENTIRE_INVOICE',
  ServiceCharge = 'SERVICE_CHARGE'
}

export type VerifyPaymentResponse = IResponse & {
  __typename?: 'VerifyPaymentResponse';
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export enum VisitReason {
  Inspection = 'INSPECTION',
  Work = 'WORK'
}

export enum VisitStatus {
  Arrived = 'ARRIVED',
  Cancelled = 'CANCELLED',
  Scheduled = 'SCHEDULED'
}

export type WaitlistedBusiness = {
  __typename?: 'WaitlistedBusiness';
  contacts: Array<WaitlistedContact>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  location?: Maybe<BusinessLocation>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type WaitlistedContact = {
  __typename?: 'WaitlistedContact';
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type WalletFundingRequest = {
  __typename?: 'WalletFundingRequest';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  initiatedBy?: Maybe<OrganizationUser>;
  invoice: Invoice;
  organization: Organization;
  status: WalletFundingStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type WalletFundingResponse = {
  __typename?: 'WalletFundingResponse';
  accessCode?: Maybe<Scalars['String']['output']>;
  authorizationUrl?: Maybe<Scalars['String']['output']>;
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
};

/** Status of a wallet funding request */
export enum WalletFundingStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type WalletLedgerEntry = {
  __typename?: 'WalletLedgerEntry';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fundingRequest?: Maybe<WalletFundingRequest>;
  id: Scalars['String']['output'];
  initiatedBy?: Maybe<OrganizationUser>;
  organization: Organization;
  transactionType: WalletLedgerTransactionType;
  type: WalletLedgerEntryType;
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Whether the entry is a credit or debit */
export enum WalletLedgerEntryType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

/** Type of wallet transaction */
export enum WalletLedgerTransactionType {
  Deposit = 'DEPOSIT',
  Refund = 'REFUND',
  ServicePayment = 'SERVICE_PAYMENT'
}

export type WhatsappUser = {
  __typename?: 'WhatsappUser';
  business?: Maybe<WhatsappUserBusiness>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  paymentProviderInformation?: Maybe<PaymentProviderInformation>;
  pro?: Maybe<Pro>;
  referredBy?: Maybe<Scalars['String']['output']>;
};

export type WhatsappUserBusiness = {
  __typename?: 'WhatsappUserBusiness';
  address: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreateCategoryInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  proTitle?: InputMaybe<Scalars['String']['input']>;
  requestCount?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateTaskInput = {
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  estimatedCost: Scalars['Float']['input'];
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subCategory: Scalars['String']['input'];
};

/** Input type to edit category */
export type EditCategoryInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  proTitle?: InputMaybe<Scalars['String']['input']>;
};

export type GetTradesWithFiltersQueryVariables = Exact<{
  filters: ListTradesFilters;
}>;


export type GetTradesWithFiltersQuery = { __typename?: 'Query', trades: Array<{ __typename?: 'Trade', id: string, name: string, createdAt: any, description: string, category: { __typename?: 'Category', id: string, name: string, proTitle?: string | null } }> };

export type AddTrackMutationVariables = Exact<{
  track: ProTrack;
}>;


export type AddTrackMutation = { __typename?: 'Mutation', addTrackToPro: { __typename?: 'Pro', id: string, tracks: Array<ProTrack> } };

export type AddTradeToProMutationVariables = Exact<{
  tradeId: Scalars['String']['input'];
}>;


export type AddTradeToProMutation = { __typename?: 'Mutation', addTradeToPro: { __typename?: 'Pro', id: string, trades: Array<{ __typename?: 'Trade', id: string, name: string, description: string, levels: Array<{ __typename?: 'TradeLevel', id: string, order: number, requirements: Array<{ __typename?: 'TradeRequirement', id: string, name: string, description: string, price: number, prompt: string, type: TradeRequirementType }> }> }> } };

export type GetProTradeLevelPaymentQueryVariables = Exact<{
  tradeLevelId: Scalars['String']['input'];
  proId: Scalars['String']['input'];
}>;


export type GetProTradeLevelPaymentQuery = { __typename?: 'Query', proTradeLevelPayment: { __typename?: 'ProTradeLevelPayment', id: string, isPaid: boolean, affectedTradeRequirements: Array<{ __typename?: 'TradeRequirement', id: string, name: string, price: number }>, payments: Array<{ __typename?: 'Payment', id: string, amount: number, checkout?: string | null }>, discount?: { __typename?: 'ProTradeLevelDiscount', id: string, code: string, description: string, value: number, isRevoked: boolean } | null } };

export type GetProTradeLevelPaymentsQueryVariables = Exact<{
  tradeLevelId: Scalars['String']['input'];
  proId: Scalars['String']['input'];
}>;


export type GetProTradeLevelPaymentsQuery = { __typename?: 'Query', proTradeLevelPayments: Array<{ __typename?: 'ProTradeLevelPayment', id: string, isPaid: boolean, createdAt: any, affectedTradeRequirements: Array<{ __typename?: 'TradeRequirement', id: string, name: string, price: number }>, payments: Array<{ __typename?: 'Payment', id: string, amount: number, checkout?: string | null }>, discount?: { __typename?: 'ProTradeLevelDiscount', id: string, code: string, description: string, value: number, isRevoked: boolean } | null }> };

export type GetRetryDiscountsQueryVariables = Exact<{
  tradeRequirementId: Scalars['String']['input'];
}>;


export type GetRetryDiscountsQuery = { __typename?: 'Query', availableRetryDiscounts: Array<{ __typename?: 'ProTradeLevelDiscount', id: string, code: string, description: string, value: number }> };

export type StartProPhoneNumberVerificationMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type StartProPhoneNumberVerificationMutation = { __typename?: 'Mutation', startProPhoneNumberVerification: string };

export type SendOtpMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type SendOtpMutation = { __typename?: 'Mutation', sendOneTimePasscode: string };

export type VerifyProOtpMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  otp: Scalars['String']['input'];
}>;


export type VerifyProOtpMutation = { __typename?: 'Mutation', verifyProPhoneNumber: { __typename?: 'BasicResponse', success: boolean, message: string, code?: string | null } };

export type AddPorfolioWorkHistoryItemMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  images: Array<JobImage> | JobImage;
  videos: Array<Scalars['String']['input']> | Scalars['String']['input'];
  budget?: InputMaybe<Scalars['Float']['input']>;
  proDoesNotWishToDiscloseBudget: Scalars['Boolean']['input'];
  endedAt: Scalars['DateTimeISO']['input'];
}>;


export type AddPorfolioWorkHistoryItemMutation = { __typename?: 'Mutation', addPorfolioWorkHistoryItem: boolean };

export type AddPortfolioEmploymentHistoryItemMutationVariables = Exact<{
  companyName: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  description: Scalars['String']['input'];
  startedAt: Scalars['DateTimeISO']['input'];
  proDoesNotWishToDiscloseMonthlySalary: Scalars['Boolean']['input'];
  images: Array<JobImage> | JobImage;
  endedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  monthlySalary?: InputMaybe<Scalars['Float']['input']>;
}>;


export type AddPortfolioEmploymentHistoryItemMutation = { __typename?: 'Mutation', addPortfolioEmploymentHistoryItem: { __typename?: 'PortfolioEmploymentHistoryItem', id: string, jobTitle: string } };

export type EditPortfolioEmploymentHistoryItemMutationVariables = Exact<{
  id: Scalars['String']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  endedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  existingImageIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  images?: InputMaybe<Array<JobImage> | JobImage>;
  monthlySalary?: InputMaybe<Scalars['Float']['input']>;
  proDoesNotWishToDiscloseMonthlySalary?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditPortfolioEmploymentHistoryItemMutation = { __typename?: 'Mutation', editPortfolioEmploymentHistoryItem: { __typename?: 'PortfolioEmploymentHistoryItem', id: string, isPinned?: boolean | null, companyName: string, jobTitle: string, description: string, startedAt: any, endedAt?: any | null, monthlySalary?: number | null, proDoesNotWishToDiscloseMonthlySalary: boolean, images: Array<{ __typename?: 'PortfolioImage', id: string, name: string, thumbnailUrl?: string | null, originalUrl?: string | null }> } };

export type EditPortfolioWorkHistoryItemMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  existingImageIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  images?: InputMaybe<Array<JobImage> | JobImage>;
  videos?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  proDoesNotWishToDiscloseBudget?: InputMaybe<Scalars['Boolean']['input']>;
  endedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
}>;


export type EditPortfolioWorkHistoryItemMutation = { __typename?: 'Mutation', editPortfolioWorkHistoryItem: { __typename?: 'PortfolioWorkHistoryItem', id?: string | null, name: string, description: string, startedAt?: any | null, endedAt: any, videos: Array<string>, budget?: number | null, proDoesNotWishToDiscloseBudget?: boolean | null, verified?: boolean | null, images: Array<{ __typename?: 'PortfolioImage', id: string, name: string }>, clientReview?: { __typename?: 'PortfolioWorkHistoryItemClientReview', rating: number, feedback?: string | null } | null } };

export type RemovePortfolioWorkHistoryItemMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemovePortfolioWorkHistoryItemMutation = { __typename?: 'Mutation', removePortfolioWorkHistoryItem: { __typename?: 'PortfolioWorkHistoryItem', id?: string | null } };

export type RemovePortfolioEmploymentHistoryItemMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemovePortfolioEmploymentHistoryItemMutation = { __typename?: 'Mutation', removePortfolioEmploymentHistoryItem: { __typename?: 'PortfolioEmploymentHistoryItem', id: string } };

export type MyPortfolioWithMediaQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPortfolioWithMediaQuery = { __typename?: 'Query', myPortfolio?: { __typename?: 'ProPortfolio', firstName: string, lastName: string, phone: string, email: string, handle: string, isEmailHidden?: boolean | null, backgroundCheckStatus: ProPortfolioBadgeStatus, identityVerificationStatus: ProPortfolioBadgeStatus, title?: string | null, location?: string | null, totalBudget: number, averageRating: number, ratingCount: number, overview?: string | null, experience?: number | null, hasCompletedRequiredPortfolioSteps: boolean, workHistory: Array<{ __typename?: 'PortfolioWorkHistoryItem', id?: string | null, name: string, description: string, budget?: number | null, proDoesNotWishToDiscloseBudget?: boolean | null, startedAt?: any | null, endedAt: any, verified?: boolean | null, isPinned?: boolean | null, createdAt: any, images: Array<{ __typename?: 'PortfolioImage', id: string, name: string, mimeType: string, originalUrl?: string | null, thumbnailUrl?: string | null, deletedAt?: any | null }>, clientReview?: { __typename?: 'PortfolioWorkHistoryItemClientReview', rating: number, feedback?: string | null } | null }>, employmentHistory: Array<{ __typename?: 'PortfolioEmploymentHistoryItem', id: string, isPinned?: boolean | null, companyName: string, jobTitle: string, description: string, startedAt: any, endedAt?: any | null, monthlySalary?: number | null, proDoesNotWishToDiscloseMonthlySalary: boolean, createdAt: any, images: Array<{ __typename?: 'PortfolioImage', id: string, name: string, mimeType: string, originalUrl?: string | null, thumbnailUrl?: string | null, deletedAt?: any | null }> }>, certifications: Array<{ __typename?: 'PortfolioCertification', id?: string | null, name: string, issuedBy: string, issuedAt: any, issuerCertificationId?: string | null, url?: string | null, verified?: boolean | null, createdAt: any }>, educationEntries: Array<{ __typename?: 'PortfolioEducation', id?: string | null, schoolName: string, fieldOfStudy?: string | null, qualification: EducationLevel, verified?: boolean | null, createdAt: any }>, averageLaborHackJobsRatings: { __typename?: 'AverageLaborHackJobsRatings', averageAppearanceRating: number, averagePunctualityRating: number, averagePostServiceCleanUpRating: number, averageBehaviorRating: number, averageProperToolUsageRating: number } } | null };

export type MyPortfolioDashboardCompletionQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPortfolioDashboardCompletionQuery = { __typename?: 'Query', myPortfolio?: { __typename?: 'ProPortfolio', handle: string, overview?: string | null, workHistory: Array<{ __typename?: 'PortfolioWorkHistoryItem', id?: string | null }>, employmentHistory: Array<{ __typename?: 'PortfolioEmploymentHistoryItem', id: string }>, certifications: Array<{ __typename?: 'PortfolioCertification', id?: string | null }>, educationEntries: Array<{ __typename?: 'PortfolioEducation', id?: string | null }> } | null };

export type ProExistsQueryVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type ProExistsQuery = { __typename?: 'Query', proExists: boolean };

export type JobAdTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type JobAdTagsQuery = { __typename?: 'Query', jobAdTags: Array<{ __typename?: 'JobAdTag', id: string, name: string, group: string }> };

export type MyJobApplicantProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyJobApplicantProfileQuery = { __typename?: 'Query', myJobApplicantProfile?: { __typename?: 'BaseJobApplicant', firstName: string, lastName: string, phoneNumber: string, email: string, yearsOfExperience?: number | null } | null };

export type GetPreSignedUrlQueryVariables = Exact<{
  path: Scalars['String']['input'];
  fileExtension: Scalars['String']['input'];
}>;


export type GetPreSignedUrlQuery = { __typename?: 'Query', getProApplicationUploadPresignedUrl: string };

export type UpdatePreferencesMutationVariables = Exact<{
  payload: PreferencesInput;
}>;


export type UpdatePreferencesMutation = { __typename?: 'Mutation', updatePreferences: { __typename?: 'Preferences', hasDisabledTelegramPopUp?: boolean | null } };

export type GetCommunityJobOpportunitiesForProQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommunityJobOpportunitiesForProQuery = { __typename?: 'Query', getCommunityJobOpportunitiesForPro: Array<{ __typename?: 'CommunityJobOpportunity', id: string, title: string, description: string, employmentType: EmploymentType, hasApplied: boolean, canApply: boolean, applicationDeadline?: any | null, createdAt: any, location: { __typename?: 'EmployerJobAdLocation', country: string, state: string, area: string }, salary?: { __typename?: 'SalaryDetails', starting: number, cap?: number | null, currency: string, currencyCode: string } | null, duration?: { __typename?: 'DurationDetails', value: number, type: DurationType } | null, tags: Array<{ __typename?: 'JobAdTag', name: string }>, organization: { __typename?: 'Organization', name: string } }> };

export type GetCommunityAnnouncementsForProQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommunityAnnouncementsForProQuery = { __typename?: 'Query', getCommunityAnnouncementsForPro: Array<{ __typename?: 'CommunityAnnouncement', id: string, title: string, content: string, type: CommunityAnnouncementType, publishedAt?: any | null, jobOpportunity?: { __typename?: 'CommunityJobOpportunity', id: string, title: string } | null, organization: { __typename?: 'Organization', name: string } }> };

export type MyCommunityJobApplicationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;


export type MyCommunityJobApplicationsQuery = { __typename?: 'Query', myCommunityJobApplications: Array<{ __typename?: 'CommunityJobApplication', id: string, createdAt: any, jobOpportunity: { __typename?: 'CommunityJobOpportunity', id: string, title: string }, education: Array<{ __typename?: 'JobApplicationEducation', id?: string | null, schoolName: string, fieldOfStudy?: string | null, qualification: EducationLevel, createdAt: any }>, employmentHistory: Array<{ __typename?: 'JobApplicationEmploymentHistoryItem', id: string, companyName: string, jobTitle: string, description: string, startedAt: any, endedAt?: any | null, createdAt: any, media: Array<{ __typename?: 'JobApplicationMediaItem', key: string, mimeType: string, originalUrl: string, thumbnailUrl: string }> }>, projectHistory: Array<{ __typename?: 'JobApplicationProjectHistoryItem', id?: string | null, name: string, description: string, startedAt?: any | null, endedAt: any, videos: Array<string>, createdAt: any, media: Array<{ __typename?: 'JobApplicationMediaItem', key: string, mimeType: string, originalUrl: string, thumbnailUrl: string }> }>, certifications: Array<{ __typename?: 'JobApplicationCertification', id?: string | null, name: string, issuerCertificationId?: string | null, issuedBy: string, issuedAt: any, url?: string | null, createdAt: any }> }> };

export type GetCommunityJobOpportunityForApplicationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCommunityJobOpportunityForApplicationQuery = { __typename?: 'Query', getCommunityJobOpportunityForPro?: { __typename?: 'CommunityJobOpportunity', id: string, title: string, description: string, employmentType: EmploymentType, hasApplied: boolean, canApply: boolean, createdAt: any, applicationDeadline?: any | null, organization: { __typename?: 'Organization', name: string }, location: { __typename?: 'EmployerJobAdLocation', area: string, state: string, country: string }, salary?: { __typename?: 'SalaryDetails', starting: number, cap?: number | null, currency: string, currencyCode: string } | null, duration?: { __typename?: 'DurationDetails', value: number, type: DurationType } | null, tags: Array<{ __typename?: 'JobAdTag', id: string, name: string }> } | null };

export type CreateCommunityJobApplicationMutationVariables = Exact<{
  input: CreateCommunityJobApplicationDto;
}>;


export type CreateCommunityJobApplicationMutation = { __typename?: 'Mutation', createCommunityJobApplication: { __typename?: 'CommunityJobApplication', id: string, status: ApplicationStatus, createdAt: any } };

export type GetCommunityAnnouncementForProQueryVariables = Exact<{
  announcementId: Scalars['String']['input'];
}>;


export type GetCommunityAnnouncementForProQuery = { __typename?: 'Query', getCommunityAnnouncementForPro?: { __typename?: 'CommunityAnnouncement', id: string, title: string, content: string, type: CommunityAnnouncementType, publishedAt?: any | null, jobOpportunity?: { __typename?: 'CommunityJobOpportunity', id: string, title: string } | null, organization: { __typename?: 'Organization', name: string } } | null };

export type CommunityInviteMetadataQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type CommunityInviteMetadataQuery = { __typename?: 'Query', communityInviteMetadata: { __typename?: 'CommunityInviteMetadataResponse', organizationName?: string | null, isValid: boolean } };

export type InitialiseJoinByCommunityInviteMutationVariables = Exact<{
  input: InitialiseJoinByCommunityInviteInput;
}>;


export type InitialiseJoinByCommunityInviteMutation = { __typename?: 'Mutation', initialiseJoinByCommunityInvite: { __typename?: 'InitialiseJoinByCommunityInviteResponse', inviteJoinSessionToken: string, loginHint: string, flowType: InviteJoinFlowType, redirectStrategy: CommunityInviteRedirectStrategy } };

export type FinalizeJoinByCommunityInviteMutationVariables = Exact<{
  sessionToken: Scalars['String']['input'];
}>;


export type FinalizeJoinByCommunityInviteMutation = { __typename?: 'Mutation', finalizeJoinByCommunityInvite: { __typename?: 'FinalizeJoinByCommunityInviteResponse', status: FinalizeJoinByCommunityInviteStatus, redirectTo?: string | null, organizationReferralCode?: string | null } };

export type CommunityInviteOnboardingContextQueryVariables = Exact<{
  sessionToken: Scalars['String']['input'];
}>;


export type CommunityInviteOnboardingContextQuery = { __typename?: 'Query', communityInviteOnboardingContext?: { __typename?: 'CommunityInviteOnboardingContextResponse', flowType: InviteJoinFlowType, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, profession?: string | null, organizationReferralCode?: string | null } | null };

export type MyPortfolioForJobApplicationPrefillQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPortfolioForJobApplicationPrefillQuery = { __typename?: 'Query', myPortfolio?: { __typename?: 'ProPortfolio', workHistory: Array<{ __typename?: 'PortfolioWorkHistoryItem', id?: string | null, name: string, description: string, startedAt?: any | null, endedAt: any, images: Array<{ __typename?: 'PortfolioImage', key?: string | null, mimeType: string, originalUrl?: string | null, thumbnailUrl?: string | null }> }>, employmentHistory: Array<{ __typename?: 'PortfolioEmploymentHistoryItem', id: string, companyName: string, jobTitle: string, description: string, startedAt: any, endedAt?: any | null, images: Array<{ __typename?: 'PortfolioImage', key?: string | null, mimeType: string, originalUrl?: string | null, thumbnailUrl?: string | null }> }>, certifications: Array<{ __typename?: 'PortfolioCertification', id?: string | null, name: string, issuedBy: string, issuedAt: any, issuerCertificationId?: string | null, url?: string | null }>, educationEntries: Array<{ __typename?: 'PortfolioEducation', id?: string | null, schoolName: string, fieldOfStudy?: string | null, qualification: EducationLevel }> } | null };

export type AllMyJobApplicationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;


export type AllMyJobApplicationsQuery = { __typename?: 'Query', allMyJobApplications: Array<{ __typename?: 'JobApplicantApplication', id: string, status: ApplicationStatus, enhancementRequested: boolean, createdAt: any, ad?: { __typename?: 'EmployerJobAd', companyName: string, title: string, id: string, organization: { __typename?: 'Organization', name: string }, principal?: { __typename?: 'EmployerJobAdPrincipal', name: string } | null } | null, communityJobOpportunity?: { __typename?: 'CommunityJobOpportunity', id: string, title: string, organization: { __typename?: 'Organization', name: string } } | null, education: Array<{ __typename?: 'JobApplicationEducation', id?: string | null, schoolName: string, fieldOfStudy?: string | null, qualification: EducationLevel, createdAt: any }>, employmentHistory: Array<{ __typename?: 'JobApplicationEmploymentHistoryItem', id: string, companyName: string, jobTitle: string, description: string, startedAt: any, endedAt?: any | null, createdAt: any, media: Array<{ __typename?: 'JobApplicationMediaItem', key: string, mimeType: string, originalUrl: string, thumbnailUrl: string }> }>, projectHistory: Array<{ __typename?: 'JobApplicationProjectHistoryItem', id?: string | null, name: string, description: string, startedAt?: any | null, endedAt: any, videos: Array<string>, createdAt: any, media: Array<{ __typename?: 'JobApplicationMediaItem', key: string, mimeType: string, originalUrl: string, thumbnailUrl: string }> }>, certifications: Array<{ __typename?: 'JobApplicationCertification', id?: string | null, name: string, issuerCertificationId?: string | null, issuedBy: string, issuedAt: any, url?: string | null, createdAt: any }> }> };

export type GetJobAdForApplicationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetJobAdForApplicationQuery = { __typename?: 'Query', getEmployerJobAd?: { __typename?: 'EmployerJobAd', id: string, title: string, description: string, employmentType: EmploymentType, companyName: string, applicationDeadline?: any | null, hasApplied: boolean, canApply: boolean, createdAt: any, organization: { __typename?: 'Organization', name: string }, principal?: { __typename?: 'EmployerJobAdPrincipal', name: string } | null, location: { __typename?: 'EmployerJobAdLocation', area: string, state: string, country: string }, salaryDetails?: { __typename?: 'SalaryDetails', starting: number, cap?: number | null, currencyCode: string } | null, duration?: { __typename?: 'DurationDetails', value: number, type: DurationType } | null, tags: Array<{ __typename?: 'JobAdTag', id: string, name: string }>, categories: Array<{ __typename?: 'Category', name: string }> } | null };

export type GetEmployerJobAdsQueryVariables = Exact<{
  dateFilter?: InputMaybe<EmployerJobAdsDateFilter>;
  employmentTypes: Array<EmploymentType> | EmploymentType;
}>;


export type GetEmployerJobAdsQuery = { __typename?: 'Query', getEmployerJobAds: Array<{ __typename?: 'EmployerJobAd', companyName: string, applicationDeadline?: any | null, title: string, salary?: number | null, id: string, visibility: JobVisibility, employmentType: EmploymentType, createdAt: any, description: string, hasApplied: boolean, canApply: boolean, categories: Array<{ __typename?: 'Category', name: string }>, tags: Array<{ __typename?: 'JobAdTag', id: string, name: string }>, location: { __typename?: 'EmployerJobAdLocation', area: string, state: string, country: string }, salaryDetails?: { __typename?: 'SalaryDetails', starting: number, cap?: number | null, currencyCode: string } | null, principal?: { __typename?: 'EmployerJobAdPrincipal', name: string } | null, organization: { __typename?: 'Organization', name: string }, duration?: { __typename?: 'DurationDetails', value: number, type: DurationType } | null }> };

export type CreateRecruiterJobApplicationLoggedInMutationVariables = Exact<{
  input: CreateJobApplicationDto;
}>;


export type CreateRecruiterJobApplicationLoggedInMutation = { __typename?: 'Mutation', createRecruiterJobApplicationLoggedIn: { __typename?: 'EmployerJobApplication', id: string, status: ApplicationStatus, createdAt: any } };

export type AddPortfolioCertificationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  issuedBy: Scalars['String']['input'];
  issuerCertificationId?: InputMaybe<Scalars['String']['input']>;
  issuedAt: Scalars['DateTimeISO']['input'];
}>;


export type AddPortfolioCertificationMutation = { __typename?: 'Mutation', addPortfolioCertification: boolean };

export type EditPortfolioCertificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  issuedBy?: InputMaybe<Scalars['String']['input']>;
  issuerCertificationId?: InputMaybe<Scalars['String']['input']>;
  issuedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditPortfolioCertificationMutation = { __typename?: 'Mutation', editPortfolioCertification: { __typename?: 'PortfolioCertification', id?: string | null, name: string, issuedBy: string, issuerCertificationId?: string | null, issuedAt: any, url?: string | null } };

export type RemovePortfolioCertificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemovePortfolioCertificationMutation = { __typename?: 'Mutation', removePortfolioCertification: { __typename?: 'PortfolioCertification', id?: string | null } };

export type PrefillPortfolioFromCvMutationVariables = Exact<{
  professionalSummary?: InputMaybe<Scalars['String']['input']>;
  educationItems: Array<PrefillEducationInput> | PrefillEducationInput;
  employmentHistoryItems: Array<PrefillEmploymentInput> | PrefillEmploymentInput;
  workHistoryItems: Array<PrefillWorkHistoryInput> | PrefillWorkHistoryInput;
  certificationItems: Array<PrefillCertificationInput> | PrefillCertificationInput;
}>;


export type PrefillPortfolioFromCvMutation = { __typename?: 'Mutation', prefillPortfolioFromCV: { __typename?: 'PrefillPortfolioResponse', educationCount: number, employmentHistoryCount: number, workHistoryCount: number, certificationCount: number, professionalSummarySet: boolean, laborpassCompleted: boolean } };

export type EditPortfolioEducationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  schoolName?: InputMaybe<Scalars['String']['input']>;
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  qualification?: InputMaybe<EducationLevel>;
}>;


export type EditPortfolioEducationMutation = { __typename?: 'Mutation', editPortfolioEducation: { __typename?: 'PortfolioEducation', createdAt: any, fieldOfStudy?: string | null, id?: string | null, qualification: EducationLevel, schoolName: string, verified?: boolean | null } };

export type RemovePortfolioEducationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemovePortfolioEducationMutation = { __typename?: 'Mutation', removePortfolioEducation: { __typename?: 'PortfolioEducation', id?: string | null } };

export type ToggleEmploymentHistoryItemPinMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ToggleEmploymentHistoryItemPinMutation = { __typename?: 'Mutation', togglePortfolioEmploymentHistoryItemPin: { __typename?: 'PortfolioEmploymentHistoryItem', id: string, isPinned?: boolean | null } };

export type GeneratePortfolioOverviewMutationVariables = Exact<{ [key: string]: never; }>;


export type GeneratePortfolioOverviewMutation = { __typename?: 'Mutation', generatePortfolioOverview: { __typename?: 'Pro', id: string, overview?: string | null } };

export type SetOverviewMutationVariables = Exact<{
  overview: Scalars['String']['input'];
}>;


export type SetOverviewMutation = { __typename?: 'Mutation', setProProfileOverview: { __typename?: 'Pro', id: string, overview?: string | null } };

export type TogglePortfolioWorkHistoryItemPinMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TogglePortfolioWorkHistoryItemPinMutation = { __typename?: 'Mutation', togglePortfolioWorkHistoryItemPin: { __typename?: 'PortfolioWorkHistoryItem', id?: string | null, isPinned?: boolean | null } };

export type GetProAccountTypeQueryVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type GetProAccountTypeQuery = { __typename?: 'Query', getProAccountType?: ProAccountType | null };

export type VerifyAndLinkUserToProMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifyAndLinkUserToProMutation = { __typename?: 'Mutation', verifyAndLinkUserToWhatsappGeneratedPro: { __typename?: 'Pro', id: string } };

export type GetProStudyWorkOpportunityByOpportunityQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProStudyWorkOpportunityByOpportunityQuery = { __typename?: 'Query', proStudyWorkOpportunityByOpportunity: { __typename?: 'ProStudyWorkOpportunity', id: string, preferredCourse?: CanadaBasicApplicationCourseOfStudy | null, pro: { __typename?: 'Pro', id: string, associatedLaborHackEmail: string }, opportunity: { __typename?: 'StudyWorkOpportunity', id: string, country: StudyWorkOpportunityCountry, description: string, price: number } } };

export type InitiateProTradeLevelPaymentMutationVariables = Exact<{
  tradeLevelId: Scalars['String']['input'];
}>;


export type InitiateProTradeLevelPaymentMutation = { __typename?: 'Mutation', initiateProTradeLevelPaymentByPro: { __typename?: 'ProTradeLevelPayment', id: string, affectedTradeRequirements: Array<{ __typename?: 'TradeRequirement', id: string, name: string, price: number }>, payments: Array<{ __typename?: 'Payment', id: string, amount: number, checkout?: string | null }>, discount?: { __typename?: 'ProTradeLevelDiscount', id: string, code: string, description: string, value: number } | null } };

export type RefreshProTradeLevelPaymentMutationVariables = Exact<{
  tradeLevelPaymentId: Scalars['String']['input'];
}>;


export type RefreshProTradeLevelPaymentMutation = { __typename?: 'Mutation', refreshProTradeLevelPayment: { __typename?: 'ProTradeLevelPayment', id: string, affectedTradeRequirements: Array<{ __typename?: 'TradeRequirement', id: string, name: string, price: number }>, payments: Array<{ __typename?: 'Payment', id: string, amount: number, checkout?: string | null }>, discount?: { __typename?: 'ProTradeLevelDiscount', id: string, code: string, description: string, value: number } | null } };

export type StartAssessmentMutationVariables = Exact<{
  proTradeRequirementId: Scalars['String']['input'];
}>;


export type StartAssessmentMutation = { __typename?: 'Mutation', startAssessment: { __typename?: 'ProTradeRequirement', id: string, requirement: { __typename?: 'TradeRequirement', id: string, lmsId?: string | null, lmsCourseId?: string | null } } };

export type GetProTradeRequirementsByLevelQueryVariables = Exact<{
  levelId: Scalars['String']['input'];
}>;


export type GetProTradeRequirementsByLevelQuery = { __typename?: 'Query', proTradeRequirementsByTradeLevel: Array<{ __typename?: 'ProTradeRequirement', id: string, attemptsRemaining: number, hasPassed: boolean, hasCompletedPayment: boolean, scheduledFor?: any | null, waived?: boolean | null, canReschedule?: boolean | null, tradeLevelPayments: Array<{ __typename?: 'ProTradeLevelPayment', id: string }>, requirement: { __typename?: 'TradeRequirement', id: string, name: string, passingScore?: number | null, lmsId?: string | null, lmsCourseId?: string | null }, results: Array<{ __typename?: 'ProTradeRequirementResult', attemptId: number, scores: Array<number>, passed: boolean }>, events?: Array<{ __typename?: 'ProTradeRequirementInterviewEvent', id: string, attemptId: number, date: any, status: ProTradeRequirementInterviewEventStatus, cancellationUrl?: string | null, rescheduleUrl?: string | null }> | null }> };

export type AddDiscountCodeMutationVariables = Exact<{
  tradeLevelPaymentId: Scalars['String']['input'];
  discountCode: Scalars['String']['input'];
}>;


export type AddDiscountCodeMutation = { __typename?: 'Mutation', addDiscountToProTradeLevelPayment: { __typename?: 'ProTradeLevelPayment', id: string, affectedTradeRequirements: Array<{ __typename?: 'TradeRequirement', id: string, name: string, price: number }>, payments: Array<{ __typename?: 'Payment', id: string, amount: number, checkout?: string | null }>, discount?: { __typename?: 'ProTradeLevelDiscount', id: string, code: string, description: string, value: number } | null } };

export type InitiateProTradeRequirementRetakeMutationVariables = Exact<{
  tradeRequirementId: Scalars['String']['input'];
}>;


export type InitiateProTradeRequirementRetakeMutation = { __typename?: 'Mutation', initiateProTradeRequirementRetakeByPro: { __typename?: 'ProTradeLevelPayment', id: string } };

export type CancelMyInterviewMutationVariables = Exact<{
  tradeRequirementId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
}>;


export type CancelMyInterviewMutation = { __typename?: 'Mutation', cancelMyInterviewRequirement: { __typename?: 'ProTradeRequirement', id: string, attemptsRemaining: number, hasPassed: boolean, hasCompletedPayment: boolean, results: Array<{ __typename?: 'ProTradeRequirementResult', scores: Array<number>, passed: boolean }>, events?: Array<{ __typename?: 'ProTradeRequirementInterviewEvent', id: string, date: any, status: ProTradeRequirementInterviewEventStatus, cancellationUrl?: string | null, rescheduleUrl?: string | null }> | null } };

export type StartTradeRequirementPaymentMutationVariables = Exact<{
  tradeRequirementId: Scalars['String']['input'];
}>;


export type StartTradeRequirementPaymentMutation = { __typename?: 'Mutation', startTradeRequirementPayment: { __typename?: 'ProTradeRequirementPayment', id: string, proTradeRequirement: { __typename?: 'ProTradeRequirement', id: string, attemptsRemaining: number, hasPassed: boolean, hasCompletedPayment: boolean, requirement: { __typename?: 'TradeRequirement', id: string, name: string, price: number } }, discount?: { __typename?: 'ProTradeLevelDiscount', id: string, code: string, description: string, value: number } | null } };

export type GetPendingPaymentsQueryVariables = Exact<{
  proTradeRequirementId: Scalars['String']['input'];
}>;


export type GetPendingPaymentsQuery = { __typename?: 'Query', getPendingProTradeRequirementPayments: Array<{ __typename?: 'ProTradeRequirementPayment', id: string, proTradeRequirement: { __typename?: 'ProTradeRequirement', id: string, attemptsRemaining: number, hasPassed: boolean, hasCompletedPayment: boolean, requirement: { __typename?: 'TradeRequirement', id: string, name: string, price: number } }, discount?: { __typename?: 'ProTradeLevelDiscount', id: string, code: string, description: string, value: number } | null }> };

export type ScheduleInterviewRequirementMutationVariables = Exact<{
  proTradeRequirementId: Scalars['String']['input'];
  scheduledFor: Scalars['String']['input'];
}>;


export type ScheduleInterviewRequirementMutation = { __typename?: 'Mutation', scheduleInterviewRequirementWithCrm: { __typename?: 'ProTradeRequirement', id: string } };

export type RescheduleInterviewRequirementMutationVariables = Exact<{
  proTradeRequirementId: Scalars['String']['input'];
  scheduledFor: Scalars['String']['input'];
  oldEventId: Scalars['String']['input'];
}>;


export type RescheduleInterviewRequirementMutation = { __typename?: 'Mutation', rescheduleInterviewRequirement: { __typename?: 'ProTradeRequirement', id: string } };

export type GenerateProTradeRequirementPaymentLinkQueryVariables = Exact<{
  proTradeRequirementPaymentId: Scalars['String']['input'];
}>;


export type GenerateProTradeRequirementPaymentLinkQuery = { __typename?: 'Query', generateProTradeRequirementPaymentLink: string };

export type GetBackgroundCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBackgroundCheckQuery = { __typename?: 'Query', getBackgroundCheckByUserId?: { __typename?: 'BackgroundCheck', id: string, userId: string, isComplete: boolean, referees: Array<{ __typename?: 'Referee', name: string, phoneNumber: string, email: string, companyName: string, companyAddress: string, jobTitle: string, relationship: string }>, guarantors: Array<{ __typename?: 'Guarantor', name: string, phoneNumber: string, email: string, companyName: string, companyAddress: string, jobTitle: string, relationship: string }> } | null };

export type GetSavedBankAccountInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSavedBankAccountInfoQuery = { __typename?: 'Query', paymentProviderInformation?: { __typename?: 'PaymentProviderInformation', userId?: string | null, defaultAccountNumber: string, providerData: Array<{ __typename?: 'PaymentProviderData', accountNumber: string, providers: Array<{ __typename?: 'TransferRecipient', bankInformation?: { __typename?: 'BankAccountInformation', accountName: string, accountNumber: string, bankName?: string | null } | null }> }> } | null };

export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, name: string, proTitle?: string | null, isVisible: boolean }> };

export type GetPreferencesByUserIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreferencesByUserIdQuery = { __typename?: 'Query', getPreferencesByUserId?: { __typename?: 'Preferences', hasDisabledTelegramPopUp?: boolean | null } | null };

export type GetMyProApplicationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyProApplicationQuery = { __typename?: 'Query', myProApplication?: { __typename?: 'ProApplication', id: string, userId: string, firstName: string, lastName: string, dateOfBirth?: any | null, country: string, categoryId?: string | null, yearsOfExperience?: number | null, trainingType?: TrainingType | null, incomeLevel?: IncomeLevel | null, numberOfDaysWorkedPerWeek?: number | null, otherCategoryText?: string | null, employmentStatus?: EmploymentStatus | null, currentIndustry?: Industry | null, highestEducationLevel?: EducationLevel | null, otherOccupationText?: string | null, hasInternationalPassport?: boolean | null, emergencyContactName?: string | null, emergencyContactPhone?: string | null, yearOfGraduation?: number | null, passportNumber?: string | null, passportIssueDate?: any | null, passportExpiryDate?: any | null, passportIssueAuthority?: string | null } | null };

export type GetMyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyProfileQuery = { __typename?: 'Query', myProInformation: { __typename?: 'Pro', id: string, userId: string, firstName: string, lastName: string, email: string, jobTitle: string, yearsOfExperience?: number | null, phoneNumber: string, phoneNumberVerified: boolean, categoryIds: Array<string>, onboardedAt?: any | null, tracks: Array<ProTrack>, hasCommunityMembership: boolean, associatedLaborHackEmail: string, overview?: string | null, tags?: Array<{ __typename?: 'JobAdTag', id: string, name: string, group: string }> | null, customTags?: Array<{ __typename?: 'UserAddedTag', id: string, name: string }> | null, trades: Array<{ __typename?: 'Trade', id: string, name: string, levels: Array<{ __typename?: 'TradeLevel', certificate?: { __typename?: 'Certificate', id: string } | null }> }>, identityVerification?: { __typename?: 'IdentityVerification', id: string, status: IdentityVerificationStatus, identificationNumber: string, type: MeansOfIdentification, issues?: Array<{ __typename?: 'IdentityVerificationIssue', code: IdentityVerificationIssueCode, message: string }> | null } | null, proApplication?: { __typename?: 'ProApplication', country: string, dateOfBirth?: any | null, gender: Gender, incomeCurrency?: string | null, averageMonthlyIncome?: number | null, employmentStatus?: EmploymentStatus | null, numberOfDaysWorkedPerWeek?: number | null, phoneType?: PhoneType | null, leadSource: string, leadSourceText?: string | null, reasonForJoiningLaborHack?: string | null, reasonsForJoiningLaborHack: Array<string>, reasonForJoiningLaborHackOtherText?: string | null, category?: { __typename?: 'Category', id: string, proTitle?: string | null } | null, detailedAddress?: { __typename?: 'Address', address: string, formattedAddress: string, state: string, city: string, placeId?: string | null } | null } | null } };

export type GetTradesQueryVariables = Exact<{
  proId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTradesQuery = { __typename?: 'Query', trades: Array<{ __typename?: 'Trade', id: string, name: string, description: string, displayPriority?: number | null, imageUrl: string, currentLevel?: number | null, levels: Array<{ __typename?: 'TradeLevel', id: string, order: number, requirements: Array<{ __typename?: 'TradeRequirement', id: string, name: string, description: string, price: number, prompt: string, type: TradeRequirementType }>, certificate?: { __typename?: 'Certificate', issuedAt: any } | null }>, category: { __typename?: 'Category', id: string, name: string, proTitle?: string | null } }> };

export type SubmitApplicationMutationVariables = Exact<{
  input: SubmitProApplicationInput;
}>;


export type SubmitApplicationMutation = { __typename?: 'Mutation', submitProApplication: { __typename?: 'ProApplication', id: string, handle: string } };

export type CreateContactsMutationVariables = Exact<{
  payload: CreateContactsInput;
}>;


export type CreateContactsMutation = { __typename?: 'Mutation', createContacts: { __typename?: 'BackgroundCheck', id: string } };

export type ListBanksQueryVariables = Exact<{ [key: string]: never; }>;


export type ListBanksQuery = { __typename?: 'Query', listBanks: { __typename?: 'ListBanksResponse', data: Array<{ __typename?: 'ListBankItem', name: string, code: string }> } };

export type GetBankAccountInfoQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
}>;


export type GetBankAccountInfoQuery = { __typename?: 'Query', getBankAccountInformation: { __typename?: 'GetBankAccountInformationResponse', data: { __typename?: 'BankAccountInformation', accountName: string, accountNumber: string } } };

export type SaveBankAccountInfoMutationVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
}>;


export type SaveBankAccountInfoMutation = { __typename?: 'Mutation', addProPaymentInformation: { __typename?: 'Pro', userId: string } };

export type SubmitIdentityInformationMutationVariables = Exact<{
  input: SubmitIdentityInformationInput;
}>;


export type SubmitIdentityInformationMutation = { __typename?: 'Mutation', submitIdentityInformation: { __typename?: 'IdentityVerification', id: string, pro: { __typename?: 'Pro', id: string, identityVerification?: { __typename?: 'IdentityVerification', id: string, status: IdentityVerificationStatus, issues?: Array<{ __typename?: 'IdentityVerificationIssue', code: IdentityVerificationIssueCode }> | null } | null }, issues?: Array<{ __typename?: 'IdentityVerificationIssue', code: IdentityVerificationIssueCode, message: string }> | null } };

export type MyDiscardedApplicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyDiscardedApplicationsQuery = { __typename?: 'Query', myDiscardedApplications: Array<{ __typename?: 'DiscardedJobApplication', id: string, createdAt: any, ad: { __typename?: 'EmployerJobAd', id: string, title: string, companyName: string, organization: { __typename?: 'Organization', name: string } } }> };

export type GetJobAdNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobAdNotificationPreferencesQuery = { __typename?: 'Query', getJobAdNotificationPreferences?: { __typename?: 'JobAdNotificationsPreferences', communicationMethods: Array<JobAdCommunicationMethod>, employmentTypes: Array<EmploymentType>, categories: Array<{ __typename?: 'Category', id: string, name: string }> } | null };

export type CreateJobAdNotificationPreferencesMutationVariables = Exact<{
  categoryIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  employmentTypes: Array<EmploymentType> | EmploymentType;
  communicationMethods: Array<JobAdCommunicationMethod> | JobAdCommunicationMethod;
}>;


export type CreateJobAdNotificationPreferencesMutation = { __typename?: 'Mutation', createJobAdNotificationPreferences: { __typename?: 'JobAdNotificationsPreferences', communicationMethods: Array<JobAdCommunicationMethod>, employmentTypes: Array<EmploymentType>, categories: Array<{ __typename?: 'Category', id: string, name: string }> } };

export type UpdateJobAdNotificationPreferencesMutationVariables = Exact<{
  categoryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  employmentTypes?: InputMaybe<Array<EmploymentType> | EmploymentType>;
  communicationMethods?: InputMaybe<Array<JobAdCommunicationMethod> | JobAdCommunicationMethod>;
}>;


export type UpdateJobAdNotificationPreferencesMutation = { __typename?: 'Mutation', updateJobAdNotificationPreferences: { __typename?: 'JobAdNotificationsPreferences', employmentTypes: Array<EmploymentType>, communicationMethods: Array<JobAdCommunicationMethod>, categories: Array<{ __typename?: 'Category', id: string, name: string }> } };

export type AddPortfolioEducationMutationVariables = Exact<{
  schoolName: Scalars['String']['input'];
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  qualification: EducationLevel;
}>;


export type AddPortfolioEducationMutation = { __typename?: 'Mutation', addPortfolioEducation: { __typename?: 'PortfolioEducation', id?: string | null, schoolName: string } };

export type UpdateMyProfileMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gender?: InputMaybe<Gender>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customTagIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  yearsOfExperience?: InputMaybe<Scalars['Float']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  detailedAddress?: InputMaybe<AddressInput>;
  employmentStatus?: InputMaybe<EmploymentStatus>;
  incomeCurrency?: InputMaybe<Scalars['String']['input']>;
  averageMonthlyIncome?: InputMaybe<Scalars['Float']['input']>;
  numberOfDaysWorkedPerWeek?: InputMaybe<Scalars['Float']['input']>;
  phoneType?: InputMaybe<PhoneType>;
  leadSource?: InputMaybe<Scalars['String']['input']>;
  leadSourceText?: InputMaybe<Scalars['String']['input']>;
  reasonForJoiningLaborHack?: InputMaybe<Scalars['String']['input']>;
  reasonsForJoiningLaborHack?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  reasonForJoiningLaborHackOtherText?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMyProfileMutation = { __typename?: 'Mutation', updateMyProApplication: { __typename?: 'ProApplication', id: string, firstName: string, lastName: string, dateOfBirth?: any | null, gender: Gender, jobTitle?: string | null, yearsOfExperience?: number | null, phoneNumber: string, country: string, employmentStatus?: EmploymentStatus | null, incomeCurrency?: string | null, averageMonthlyIncome?: number | null, numberOfDaysWorkedPerWeek?: number | null, phoneType?: PhoneType | null, leadSource: string, leadSourceText?: string | null, reasonForJoiningLaborHack?: string | null, reasonsForJoiningLaborHack: Array<string>, reasonForJoiningLaborHackOtherText?: string | null, tags?: Array<{ __typename?: 'JobAdTag', id: string, name: string, group: string }> | null, customTags?: Array<{ __typename?: 'UserAddedTag', id: string, name: string }> | null, detailedAddress?: { __typename?: 'Address', address: string, formattedAddress: string, state: string, city: string, placeId?: string | null } | null } };

export type CreateProStudyWorkOpportunityMutationVariables = Exact<{
  opportunityId: Scalars['String']['input'];
}>;


export type CreateProStudyWorkOpportunityMutation = { __typename?: 'Mutation', createProStudyWorkOpportunity: { __typename?: 'ProStudyWorkOpportunity', id: string, opportunity: { __typename?: 'StudyWorkOpportunity', id: string, country: StudyWorkOpportunityCountry, description: string, price: number } } };

export type GetStudyWorkOpportunityQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetStudyWorkOpportunityQuery = { __typename?: 'Query', studyWorkOpportunity: { __typename?: 'StudyWorkOpportunity', id: string, country: StudyWorkOpportunityCountry, description: string, price: number } };

export type SetPreferredCourseForProStudyWorkOpportunityMutationVariables = Exact<{
  opportunityId: Scalars['String']['input'];
  preferredCourse: CanadaBasicApplicationCourseOfStudy;
}>;


export type SetPreferredCourseForProStudyWorkOpportunityMutation = { __typename?: 'Mutation', setPreferredCourseForProStudyWorkOpportunity: { __typename?: 'ProStudyWorkOpportunity', id: string, preferredCourse?: CanadaBasicApplicationCourseOfStudy | null } };

export type CreateCanadaBasicApplicationMutationVariables = Exact<{
  payload: CreateCanadaBasicApplicationInput;
}>;


export type CreateCanadaBasicApplicationMutation = { __typename?: 'Mutation', createCanadaBasicApplication: { __typename?: 'CanadaBasicApplication', id: string } };

export type UpdateMyStudyWorkProApplicationMutationVariables = Exact<{
  employmentStatus?: InputMaybe<EmploymentStatus>;
  currentIndustry?: InputMaybe<Industry>;
  highestEducationLevel?: InputMaybe<EducationLevel>;
  otherOccupationText?: InputMaybe<Scalars['String']['input']>;
  hasInternationalPassport?: InputMaybe<Scalars['Boolean']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  passportIssueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  passportIssueAuthority?: InputMaybe<Scalars['String']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
  yearOfGraduation?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateMyStudyWorkProApplicationMutation = { __typename?: 'Mutation', updateMyProApplication: { __typename?: 'ProApplication', id: string, employmentStatus?: EmploymentStatus | null, currentIndustry?: Industry | null, highestEducationLevel?: EducationLevel | null, otherOccupationText?: string | null, hasInternationalPassport?: boolean | null, passportNumber?: string | null, passportIssueDate?: any | null, passportExpiryDate?: any | null, passportIssueAuthority?: string | null, emergencyContactName?: string | null, emergencyContactPhone?: string | null, yearOfGraduation?: number | null } };

export type GetStudyWorkOpportunitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudyWorkOpportunitiesQuery = { __typename?: 'Query', studyWorkOpportunities: Array<{ __typename?: 'StudyWorkOpportunity', id: string, country: StudyWorkOpportunityCountry, description: string, price: number }> };

export type ConfirmStudyWorkOpportunityPaymentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConfirmStudyWorkOpportunityPaymentMutation = { __typename?: 'Mutation', confirmProStudyWorkOpportunityPayment: { __typename?: 'ProStudyWorkOpportunity', id: string, isPaid: boolean, opportunity: { __typename?: 'StudyWorkOpportunity', id: string }, payments: Array<{ __typename?: 'Payment', id: string, amount: number, status: TransactionStatus, checkout?: string | null }> } };

export type ConfirmTradeLevelPaymentMutationVariables = Exact<{
  tradeLevelPaymentId: Scalars['String']['input'];
}>;


export type ConfirmTradeLevelPaymentMutation = { __typename?: 'Mutation', confirmProTradeLevelPayment: { __typename?: 'ProTradeLevelPayment', id: string, isPaid: boolean } };

export type GetDiscountsQueryVariables = Exact<{
  tradeId: Scalars['String']['input'];
}>;


export type GetDiscountsQuery = { __typename?: 'Query', availableDiscounts: Array<{ __typename?: 'ProTradeLevelDiscount', id: string, code: string, description: string, prompt: string, value: number, applicableTradeLevels: Array<{ __typename?: 'TradeLevel', id: string }> }> };

export type GetTradeQueryVariables = Exact<{
  id: Scalars['String']['input'];
  proId: Scalars['String']['input'];
}>;


export type GetTradeQuery = { __typename?: 'Query', trade: { __typename?: 'Trade', id: string, name: string, description: string, currentLevel?: number | null, levels: Array<{ __typename?: 'TradeLevel', id: string, isAvailable?: boolean | null, order: number, requirements: Array<{ __typename?: 'TradeRequirement', id: string, name: string, description: string, price: number, prompt: string, type: TradeRequirementType, lmsCourseId?: string | null, invitationUrl?: string | null, actions: Array<{ __typename?: 'TradeRequirementActions', type: TradeRequirementActionTypes, url: string, label: string, prompt: string, external?: boolean | null }> }> }>, category: { __typename?: 'Category', id: string } } };

export type UpdateMyProApplicationMutationVariables = Exact<{
  categoryId?: InputMaybe<Scalars['String']['input']>;
  yearsOfExperience?: InputMaybe<Scalars['Float']['input']>;
  trainingType?: InputMaybe<TrainingType>;
  incomeLevel?: InputMaybe<IncomeLevel>;
  numberOfDaysWorkedPerWeek?: InputMaybe<Scalars['Float']['input']>;
  otherCategoryText?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMyProApplicationMutation = { __typename?: 'Mutation', updateMyProApplication: { __typename?: 'ProApplication', id: string, categoryId?: string | null, yearsOfExperience?: number | null, trainingType?: TrainingType | null, incomeLevel?: IncomeLevel | null, numberOfDaysWorkedPerWeek?: number | null, otherCategoryText?: string | null } };

export type ConfirmTradeRequirementPaymentMutationVariables = Exact<{
  proTradeRequirementPaymentId: Scalars['String']['input'];
}>;


export type ConfirmTradeRequirementPaymentMutation = { __typename?: 'Mutation', confirmTradeRequirementPayment: { __typename?: 'ProTradeRequirementPayment', id: string } };


export const GetTradesWithFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTradesWithFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTradesFilters"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"proTitle"}}]}}]}}]}}]} as unknown as DocumentNode<GetTradesWithFiltersQuery, GetTradesWithFiltersQueryVariables>;
export const AddTrackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddTrack"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"track"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProTrack"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addTrackToPro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"track"},"value":{"kind":"Variable","name":{"kind":"Name","value":"track"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tracks"}}]}}]}}]} as unknown as DocumentNode<AddTrackMutation, AddTrackMutationVariables>;
export const AddTradeToProDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddTradeToPro"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addTradeToPro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tradeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddTradeToProMutation, AddTradeToProMutationVariables>;
export const GetProTradeLevelPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProTradeLevelPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeLevelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"proTradeLevelPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tradeLevelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeLevelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"proId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"affectedTradeRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"isRevoked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"proId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proId"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}}]}}]}}]} as unknown as DocumentNode<GetProTradeLevelPaymentQuery, GetProTradeLevelPaymentQueryVariables>;
export const GetProTradeLevelPaymentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProTradeLevelPayments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeLevelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"proTradeLevelPayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tradeLevelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeLevelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"proId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"affectedTradeRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"isRevoked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"proId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proId"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetProTradeLevelPaymentsQuery, GetProTradeLevelPaymentsQueryVariables>;
export const GetRetryDiscountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRetryDiscounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeRequirementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableRetryDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tradeRequirementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeRequirementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetRetryDiscountsQuery, GetRetryDiscountsQueryVariables>;
export const StartProPhoneNumberVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartProPhoneNumberVerification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startProPhoneNumberVerification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}]}]}}]} as unknown as DocumentNode<StartProPhoneNumberVerificationMutation, StartProPhoneNumberVerificationMutationVariables>;
export const SendOtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendOTP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendOneTimePasscode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}]}]}}]} as unknown as DocumentNode<SendOtpMutation, SendOtpMutationVariables>;
export const VerifyProOtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyProOTP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyProPhoneNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<VerifyProOtpMutation, VerifyProOtpMutationVariables>;
export const AddPorfolioWorkHistoryItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPorfolioWorkHistoryItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"images"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobImage"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videos"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"budget"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proDoesNotWishToDiscloseBudget"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPorfolioWorkHistoryItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"startedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"images"},"value":{"kind":"Variable","name":{"kind":"Name","value":"images"}}},{"kind":"Argument","name":{"kind":"Name","value":"videos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videos"}}},{"kind":"Argument","name":{"kind":"Name","value":"budget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"budget"}}},{"kind":"Argument","name":{"kind":"Name","value":"proDoesNotWishToDiscloseBudget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proDoesNotWishToDiscloseBudget"}}},{"kind":"Argument","name":{"kind":"Name","value":"endedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endedAt"}}}]}]}}]} as unknown as DocumentNode<AddPorfolioWorkHistoryItemMutation, AddPorfolioWorkHistoryItemMutationVariables>;
export const AddPortfolioEmploymentHistoryItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPortfolioEmploymentHistoryItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proDoesNotWishToDiscloseMonthlySalary"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"images"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobImage"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"monthlySalary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPortfolioEmploymentHistoryItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}}},{"kind":"Argument","name":{"kind":"Name","value":"jobTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"startedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"proDoesNotWishToDiscloseMonthlySalary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proDoesNotWishToDiscloseMonthlySalary"}}},{"kind":"Argument","name":{"kind":"Name","value":"images"},"value":{"kind":"Variable","name":{"kind":"Name","value":"images"}}},{"kind":"Argument","name":{"kind":"Name","value":"endedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"monthlySalary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"monthlySalary"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}}]} as unknown as DocumentNode<AddPortfolioEmploymentHistoryItemMutation, AddPortfolioEmploymentHistoryItemMutationVariables>;
export const EditPortfolioEmploymentHistoryItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditPortfolioEmploymentHistoryItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"existingImageIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"images"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobImage"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"monthlySalary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proDoesNotWishToDiscloseMonthlySalary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editPortfolioEmploymentHistoryItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}}},{"kind":"Argument","name":{"kind":"Name","value":"jobTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"startedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"endedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"existingImageIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"existingImageIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"images"},"value":{"kind":"Variable","name":{"kind":"Name","value":"images"}}},{"kind":"Argument","name":{"kind":"Name","value":"monthlySalary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"monthlySalary"}}},{"kind":"Argument","name":{"kind":"Name","value":"proDoesNotWishToDiscloseMonthlySalary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proDoesNotWishToDiscloseMonthlySalary"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"originalUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"monthlySalary"}},{"kind":"Field","name":{"kind":"Name","value":"proDoesNotWishToDiscloseMonthlySalary"}}]}}]}}]} as unknown as DocumentNode<EditPortfolioEmploymentHistoryItemMutation, EditPortfolioEmploymentHistoryItemMutationVariables>;
export const EditPortfolioWorkHistoryItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditPortfolioWorkHistoryItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"existingImageIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"images"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobImage"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videos"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"budget"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proDoesNotWishToDiscloseBudget"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editPortfolioWorkHistoryItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"startedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"existingImageIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"existingImageIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"images"},"value":{"kind":"Variable","name":{"kind":"Name","value":"images"}}},{"kind":"Argument","name":{"kind":"Name","value":"videos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videos"}}},{"kind":"Argument","name":{"kind":"Name","value":"budget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"budget"}}},{"kind":"Argument","name":{"kind":"Name","value":"proDoesNotWishToDiscloseBudget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proDoesNotWishToDiscloseBudget"}}},{"kind":"Argument","name":{"kind":"Name","value":"endedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endedAt"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"budget"}},{"kind":"Field","name":{"kind":"Name","value":"proDoesNotWishToDiscloseBudget"}},{"kind":"Field","name":{"kind":"Name","value":"clientReview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}}]}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<EditPortfolioWorkHistoryItemMutation, EditPortfolioWorkHistoryItemMutationVariables>;
export const RemovePortfolioWorkHistoryItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePortfolioWorkHistoryItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePortfolioWorkHistoryItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemovePortfolioWorkHistoryItemMutation, RemovePortfolioWorkHistoryItemMutationVariables>;
export const RemovePortfolioEmploymentHistoryItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePortfolioEmploymentHistoryItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePortfolioEmploymentHistoryItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemovePortfolioEmploymentHistoryItemMutation, RemovePortfolioEmploymentHistoryItemMutationVariables>;
export const MyPortfolioWithMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyPortfolioWithMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myPortfolio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailHidden"}},{"kind":"Field","name":{"kind":"Name","value":"workHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"budget"}},{"kind":"Field","name":{"kind":"Name","value":"proDoesNotWishToDiscloseBudget"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"originalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientReview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}}]}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employmentHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"originalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"monthlySalary"}},{"kind":"Field","name":{"kind":"Name","value":"proDoesNotWishToDiscloseMonthlySalary"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundCheckStatus"}},{"kind":"Field","name":{"kind":"Name","value":"identityVerificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"certifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBy"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"issuerCertificationId"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"educationEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldOfStudy"}},{"kind":"Field","name":{"kind":"Name","value":"qualification"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"totalBudget"}},{"kind":"Field","name":{"kind":"Name","value":"averageRating"}},{"kind":"Field","name":{"kind":"Name","value":"averageLaborHackJobsRatings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"averageAppearanceRating"}},{"kind":"Field","name":{"kind":"Name","value":"averagePunctualityRating"}},{"kind":"Field","name":{"kind":"Name","value":"averagePostServiceCleanUpRating"}},{"kind":"Field","name":{"kind":"Name","value":"averageBehaviorRating"}},{"kind":"Field","name":{"kind":"Name","value":"averageProperToolUsageRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratingCount"}},{"kind":"Field","name":{"kind":"Name","value":"overview"}},{"kind":"Field","name":{"kind":"Name","value":"experience"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedRequiredPortfolioSteps"}}]}}]}}]} as unknown as DocumentNode<MyPortfolioWithMediaQuery, MyPortfolioWithMediaQueryVariables>;
export const MyPortfolioDashboardCompletionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyPortfolioDashboardCompletion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myPortfolio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"overview"}},{"kind":"Field","name":{"kind":"Name","value":"workHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employmentHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"certifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"educationEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<MyPortfolioDashboardCompletionQuery, MyPortfolioDashboardCompletionQueryVariables>;
export const ProExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProExists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"proExists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}]}]}}]} as unknown as DocumentNode<ProExistsQuery, ProExistsQueryVariables>;
export const JobAdTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobAdTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAdTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]} as unknown as DocumentNode<JobAdTagsQuery, JobAdTagsQueryVariables>;
export const MyJobApplicantProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyJobApplicantProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myJobApplicantProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"}}]}}]}}]} as unknown as DocumentNode<MyJobApplicantProfileQuery, MyJobApplicantProfileQueryVariables>;
export const GetPreSignedUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPreSignedUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileExtension"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProApplicationUploadPresignedUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileExtension"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileExtension"}}}]}]}}]} as unknown as DocumentNode<GetPreSignedUrlQuery, GetPreSignedUrlQueryVariables>;
export const UpdatePreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreferencesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasDisabledTelegramPopUp"}}]}}]}}]} as unknown as DocumentNode<UpdatePreferencesMutation, UpdatePreferencesMutationVariables>;
export const GetCommunityJobOpportunitiesForProDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCommunityJobOpportunitiesForPro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCommunityJobOpportunitiesForPro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"area"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"starting"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employmentType"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasApplied"}},{"kind":"Field","name":{"kind":"Name","value":"canApply"}},{"kind":"Field","name":{"kind":"Name","value":"applicationDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetCommunityJobOpportunitiesForProQuery, GetCommunityJobOpportunitiesForProQueryVariables>;
export const GetCommunityAnnouncementsForProDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCommunityAnnouncementsForPro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCommunityAnnouncementsForPro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"jobOpportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]} as unknown as DocumentNode<GetCommunityAnnouncementsForProQuery, GetCommunityAnnouncementsForProQueryVariables>;
export const MyCommunityJobApplicationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyCommunityJobApplications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myCommunityJobApplications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobOpportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"education"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldOfStudy"}},{"kind":"Field","name":{"kind":"Name","value":"qualification"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employmentHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"originalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"originalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"certifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"issuerCertificationId"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBy"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<MyCommunityJobApplicationsQuery, MyCommunityJobApplicationsQueryVariables>;
export const GetCommunityJobOpportunityForApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCommunityJobOpportunityForApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCommunityJobOpportunityForPro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobOpportunityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"employmentType"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"starting"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasApplied"}},{"kind":"Field","name":{"kind":"Name","value":"canApply"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"applicationDeadline"}}]}}]}}]} as unknown as DocumentNode<GetCommunityJobOpportunityForApplicationQuery, GetCommunityJobOpportunityForApplicationQueryVariables>;
export const CreateCommunityJobApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCommunityJobApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCommunityJobApplicationDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCommunityJobApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<CreateCommunityJobApplicationMutation, CreateCommunityJobApplicationMutationVariables>;
export const GetCommunityAnnouncementForProDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCommunityAnnouncementForPro"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"announcementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCommunityAnnouncementForPro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"announcementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"announcementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"jobOpportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]} as unknown as DocumentNode<GetCommunityAnnouncementForProQuery, GetCommunityAnnouncementForProQueryVariables>;
export const CommunityInviteMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommunityInviteMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"communityInviteMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}}]}}]} as unknown as DocumentNode<CommunityInviteMetadataQuery, CommunityInviteMetadataQueryVariables>;
export const InitialiseJoinByCommunityInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitialiseJoinByCommunityInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InitialiseJoinByCommunityInviteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initialiseJoinByCommunityInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteJoinSessionToken"}},{"kind":"Field","name":{"kind":"Name","value":"loginHint"}},{"kind":"Field","name":{"kind":"Name","value":"flowType"}},{"kind":"Field","name":{"kind":"Name","value":"redirectStrategy"}}]}}]}}]} as unknown as DocumentNode<InitialiseJoinByCommunityInviteMutation, InitialiseJoinByCommunityInviteMutationVariables>;
export const FinalizeJoinByCommunityInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FinalizeJoinByCommunityInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeJoinByCommunityInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sessionToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"redirectTo"}},{"kind":"Field","name":{"kind":"Name","value":"organizationReferralCode"}}]}}]}}]} as unknown as DocumentNode<FinalizeJoinByCommunityInviteMutation, FinalizeJoinByCommunityInviteMutationVariables>;
export const CommunityInviteOnboardingContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommunityInviteOnboardingContext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"communityInviteOnboardingContext"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sessionToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flowType"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}},{"kind":"Field","name":{"kind":"Name","value":"organizationReferralCode"}}]}}]}}]} as unknown as DocumentNode<CommunityInviteOnboardingContextQuery, CommunityInviteOnboardingContextQueryVariables>;
export const MyPortfolioForJobApplicationPrefillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyPortfolioForJobApplicationPrefill"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myPortfolio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"originalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employmentHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"originalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"certifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBy"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"issuerCertificationId"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"educationEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldOfStudy"}},{"kind":"Field","name":{"kind":"Name","value":"qualification"}}]}}]}}]}}]} as unknown as DocumentNode<MyPortfolioForJobApplicationPrefillQuery, MyPortfolioForJobApplicationPrefillQueryVariables>;
export const AllMyJobApplicationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllMyJobApplications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMyJobApplications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ad"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"principal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"communityJobOpportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"enhancementRequested"}},{"kind":"Field","name":{"kind":"Name","value":"education"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldOfStudy"}},{"kind":"Field","name":{"kind":"Name","value":"qualification"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employmentHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"originalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"originalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"certifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"issuerCertificationId"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBy"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<AllMyJobApplicationsQuery, AllMyJobApplicationsQueryVariables>;
export const GetJobAdForApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJobAdForApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEmployerJobAd"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"employmentType"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"principal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salaryDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"starting"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applicationDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"hasApplied"}},{"kind":"Field","name":{"kind":"Name","value":"canApply"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetJobAdForApplicationQuery, GetJobAdForApplicationQueryVariables>;
export const GetEmployerJobAdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEmployerJobAds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployerJobAdsDateFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentType"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEmployerJobAds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dateFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"employmentTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentTypes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applicationDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"salary"}},{"kind":"Field","name":{"kind":"Name","value":"salaryDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"starting"}},{"kind":"Field","name":{"kind":"Name","value":"cap"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"principal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"employmentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hasApplied"}},{"kind":"Field","name":{"kind":"Name","value":"canApply"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetEmployerJobAdsQuery, GetEmployerJobAdsQueryVariables>;
export const CreateRecruiterJobApplicationLoggedInDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRecruiterJobApplicationLoggedIn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateJobApplicationDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRecruiterJobApplicationLoggedIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<CreateRecruiterJobApplicationLoggedInMutation, CreateRecruiterJobApplicationLoggedInMutationVariables>;
export const AddPortfolioCertificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPortfolioCertification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issuedBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issuerCertificationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issuedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPortfolioCertification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"issuedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issuedBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"issuerCertificationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issuerCertificationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"issuedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issuedAt"}}}]}]}}]} as unknown as DocumentNode<AddPortfolioCertificationMutation, AddPortfolioCertificationMutationVariables>;
export const EditPortfolioCertificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditPortfolioCertification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issuedBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issuerCertificationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issuedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editPortfolioCertification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"issuedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issuedBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"issuerCertificationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issuerCertificationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"issuedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issuedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBy"}},{"kind":"Field","name":{"kind":"Name","value":"issuerCertificationId"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<EditPortfolioCertificationMutation, EditPortfolioCertificationMutationVariables>;
export const RemovePortfolioCertificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePortfolioCertification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePortfolioCertification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemovePortfolioCertificationMutation, RemovePortfolioCertificationMutationVariables>;
export const PrefillPortfolioFromCvDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PrefillPortfolioFromCV"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"professionalSummary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"educationItems"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrefillEducationInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentHistoryItems"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrefillEmploymentInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workHistoryItems"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrefillWorkHistoryInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"certificationItems"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrefillCertificationInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefillPortfolioFromCV"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"professionalSummary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professionalSummary"}}},{"kind":"Argument","name":{"kind":"Name","value":"educationItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"educationItems"}}},{"kind":"Argument","name":{"kind":"Name","value":"employmentHistoryItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentHistoryItems"}}},{"kind":"Argument","name":{"kind":"Name","value":"workHistoryItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workHistoryItems"}}},{"kind":"Argument","name":{"kind":"Name","value":"certificationItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"certificationItems"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"educationCount"}},{"kind":"Field","name":{"kind":"Name","value":"employmentHistoryCount"}},{"kind":"Field","name":{"kind":"Name","value":"workHistoryCount"}},{"kind":"Field","name":{"kind":"Name","value":"certificationCount"}},{"kind":"Field","name":{"kind":"Name","value":"professionalSummarySet"}},{"kind":"Field","name":{"kind":"Name","value":"laborpassCompleted"}}]}}]}}]} as unknown as DocumentNode<PrefillPortfolioFromCvMutation, PrefillPortfolioFromCvMutationVariables>;
export const EditPortfolioEducationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditPortfolioEducation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"schoolName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldOfStudy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EducationLevel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editPortfolioEducation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"schoolName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"schoolName"}}},{"kind":"Argument","name":{"kind":"Name","value":"fieldOfStudy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldOfStudy"}}},{"kind":"Argument","name":{"kind":"Name","value":"qualification"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"fieldOfStudy"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qualification"}},{"kind":"Field","name":{"kind":"Name","value":"schoolName"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<EditPortfolioEducationMutation, EditPortfolioEducationMutationVariables>;
export const RemovePortfolioEducationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePortfolioEducation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePortfolioEducation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemovePortfolioEducationMutation, RemovePortfolioEducationMutationVariables>;
export const ToggleEmploymentHistoryItemPinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ToggleEmploymentHistoryItemPin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"togglePortfolioEmploymentHistoryItemPin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}}]}}]}}]} as unknown as DocumentNode<ToggleEmploymentHistoryItemPinMutation, ToggleEmploymentHistoryItemPinMutationVariables>;
export const GeneratePortfolioOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GeneratePortfolioOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generatePortfolioOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"overview"}}]}}]}}]} as unknown as DocumentNode<GeneratePortfolioOverviewMutation, GeneratePortfolioOverviewMutationVariables>;
export const SetOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overview"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setProProfileOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"overview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"overview"}}]}}]}}]} as unknown as DocumentNode<SetOverviewMutation, SetOverviewMutationVariables>;
export const TogglePortfolioWorkHistoryItemPinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TogglePortfolioWorkHistoryItemPin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"togglePortfolioWorkHistoryItemPin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPinned"}}]}}]}}]} as unknown as DocumentNode<TogglePortfolioWorkHistoryItemPinMutation, TogglePortfolioWorkHistoryItemPinMutationVariables>;
export const GetProAccountTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProAccountType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProAccountType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}]}]}}]} as unknown as DocumentNode<GetProAccountTypeQuery, GetProAccountTypeQueryVariables>;
export const VerifyAndLinkUserToProDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyAndLinkUserToPro"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyAndLinkUserToWhatsappGeneratedPro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<VerifyAndLinkUserToProMutation, VerifyAndLinkUserToProMutationVariables>;
export const GetProStudyWorkOpportunityByOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProStudyWorkOpportunityByOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"proStudyWorkOpportunityByOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"opportunityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preferredCourse"}},{"kind":"Field","name":{"kind":"Name","value":"pro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"associatedLaborHackEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]} as unknown as DocumentNode<GetProStudyWorkOpportunityByOpportunityQuery, GetProStudyWorkOpportunityByOpportunityQueryVariables>;
export const InitiateProTradeLevelPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitiateProTradeLevelPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeLevelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiateProTradeLevelPaymentByPro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tradeLevelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeLevelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"affectedTradeRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<InitiateProTradeLevelPaymentMutation, InitiateProTradeLevelPaymentMutationVariables>;
export const RefreshProTradeLevelPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshProTradeLevelPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeLevelPaymentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshProTradeLevelPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tradeLevelPaymentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeLevelPaymentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"affectedTradeRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<RefreshProTradeLevelPaymentMutation, RefreshProTradeLevelPaymentMutationVariables>;
export const StartAssessmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartAssessment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proTradeRequirementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startAssessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"proTradeRequirementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proTradeRequirementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requirement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lmsId"}},{"kind":"Field","name":{"kind":"Name","value":"lmsCourseId"}}]}}]}}]}}]} as unknown as DocumentNode<StartAssessmentMutation, StartAssessmentMutationVariables>;
export const GetProTradeRequirementsByLevelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProTradeRequirementsByLevel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"levelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"proTradeRequirementsByTradeLevel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tradeLevelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"levelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tradeLevelPayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"passingScore"}},{"kind":"Field","name":{"kind":"Name","value":"lmsId"}},{"kind":"Field","name":{"kind":"Name","value":"lmsCourseId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attemptsRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassed"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedPayment"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attemptId"}},{"kind":"Field","name":{"kind":"Name","value":"scores"}},{"kind":"Field","name":{"kind":"Name","value":"passed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attemptId"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"rescheduleUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledFor"}},{"kind":"Field","name":{"kind":"Name","value":"waived"}},{"kind":"Field","name":{"kind":"Name","value":"canReschedule"}}]}}]}}]} as unknown as DocumentNode<GetProTradeRequirementsByLevelQuery, GetProTradeRequirementsByLevelQueryVariables>;
export const AddDiscountCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddDiscountCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeLevelPaymentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"discountCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addDiscountToProTradeLevelPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tradeLevelPaymentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeLevelPaymentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"discountCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"discountCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"affectedTradeRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<AddDiscountCodeMutation, AddDiscountCodeMutationVariables>;
export const InitiateProTradeRequirementRetakeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitiateProTradeRequirementRetake"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeRequirementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiateProTradeRequirementRetakeByPro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tradeRequirementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeRequirementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InitiateProTradeRequirementRetakeMutation, InitiateProTradeRequirementRetakeMutationVariables>;
export const CancelMyInterviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelMyInterview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeRequirementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelMyInterviewRequirement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tradeRequirementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeRequirementId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attemptsRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassed"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedPayment"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scores"}},{"kind":"Field","name":{"kind":"Name","value":"passed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"rescheduleUrl"}}]}}]}}]}}]} as unknown as DocumentNode<CancelMyInterviewMutation, CancelMyInterviewMutationVariables>;
export const StartTradeRequirementPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartTradeRequirementPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeRequirementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startTradeRequirementPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tradeRequirementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeRequirementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"proTradeRequirement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requirement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attemptsRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassed"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedPayment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<StartTradeRequirementPaymentMutation, StartTradeRequirementPaymentMutationVariables>;
export const GetPendingPaymentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPendingPayments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proTradeRequirementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPendingProTradeRequirementPayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"proTradeRequirementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proTradeRequirementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"proTradeRequirement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requirement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attemptsRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"hasPassed"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedPayment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetPendingPaymentsQuery, GetPendingPaymentsQueryVariables>;
export const ScheduleInterviewRequirementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScheduleInterviewRequirement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proTradeRequirementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledFor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleInterviewRequirementWithCrm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"proTradeRequirementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proTradeRequirementId"}}},{"kind":"Argument","name":{"kind":"Name","value":"scheduledFor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledFor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ScheduleInterviewRequirementMutation, ScheduleInterviewRequirementMutationVariables>;
export const RescheduleInterviewRequirementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RescheduleInterviewRequirement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proTradeRequirementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledFor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldEventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rescheduleInterviewRequirement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"proTradeRequirementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proTradeRequirementId"}}},{"kind":"Argument","name":{"kind":"Name","value":"scheduledFor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledFor"}}},{"kind":"Argument","name":{"kind":"Name","value":"oldEventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldEventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RescheduleInterviewRequirementMutation, RescheduleInterviewRequirementMutationVariables>;
export const GenerateProTradeRequirementPaymentLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerateProTradeRequirementPaymentLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proTradeRequirementPaymentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateProTradeRequirementPaymentLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"proTradeRequirementPaymentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proTradeRequirementPaymentId"}}}]}]}}]} as unknown as DocumentNode<GenerateProTradeRequirementPaymentLinkQuery, GenerateProTradeRequirementPaymentLinkQueryVariables>;
export const GetBackgroundCheckDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBackgroundCheck"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBackgroundCheckByUserId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"referees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"companyAddress"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guarantors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"companyAddress"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isComplete"}}]}}]}}]} as unknown as DocumentNode<GetBackgroundCheckQuery, GetBackgroundCheckQueryVariables>;
export const GetSavedBankAccountInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSavedBankAccountInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentProviderInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"providerData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"providers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSavedBankAccountInfoQuery, GetSavedBankAccountInfoQueryVariables>;
export const CategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"proTitle"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}}]}}]}}]} as unknown as DocumentNode<CategoriesQuery, CategoriesQueryVariables>;
export const GetPreferencesByUserIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPreferencesByUserId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPreferencesByUserId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasDisabledTelegramPopUp"}}]}}]}}]} as unknown as DocumentNode<GetPreferencesByUserIdQuery, GetPreferencesByUserIdQueryVariables>;
export const GetMyProApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyProApplication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myProApplication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"trainingType"}},{"kind":"Field","name":{"kind":"Name","value":"incomeLevel"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfDaysWorkedPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"otherCategoryText"}},{"kind":"Field","name":{"kind":"Name","value":"employmentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"currentIndustry"}},{"kind":"Field","name":{"kind":"Name","value":"highestEducationLevel"}},{"kind":"Field","name":{"kind":"Name","value":"otherOccupationText"}},{"kind":"Field","name":{"kind":"Name","value":"hasInternationalPassport"}},{"kind":"Field","name":{"kind":"Name","value":"emergencyContactName"}},{"kind":"Field","name":{"kind":"Name","value":"emergencyContactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"yearOfGraduation"}},{"kind":"Field","name":{"kind":"Name","value":"passportNumber"}},{"kind":"Field","name":{"kind":"Name","value":"passportIssueDate"}},{"kind":"Field","name":{"kind":"Name","value":"passportExpiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"passportIssueAuthority"}}]}}]}}]} as unknown as DocumentNode<GetMyProApplicationQuery, GetMyProApplicationQueryVariables>;
export const GetMyProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myProInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberVerified"}},{"kind":"Field","name":{"kind":"Name","value":"categoryIds"}},{"kind":"Field","name":{"kind":"Name","value":"onboardedAt"}},{"kind":"Field","name":{"kind":"Name","value":"tracks"}},{"kind":"Field","name":{"kind":"Name","value":"hasCommunityMembership"}},{"kind":"Field","name":{"kind":"Name","value":"trades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"identityVerification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"showDeclined"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"identificationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"associatedLaborHackEmail"}},{"kind":"Field","name":{"kind":"Name","value":"proApplication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"proTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"incomeCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"averageMonthlyIncome"}},{"kind":"Field","name":{"kind":"Name","value":"employmentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfDaysWorkedPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"phoneType"}},{"kind":"Field","name":{"kind":"Name","value":"leadSource"}},{"kind":"Field","name":{"kind":"Name","value":"leadSourceText"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForJoiningLaborHack"}},{"kind":"Field","name":{"kind":"Name","value":"reasonsForJoiningLaborHack"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForJoiningLaborHackOtherText"}},{"kind":"Field","name":{"kind":"Name","value":"detailedAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"placeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"overview"}}]}}]}}]} as unknown as DocumentNode<GetMyProfileQuery, GetMyProfileQueryVariables>;
export const GetTradesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTrades"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayPriority"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"certificate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"proId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentLevel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"proId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proId"}}}]},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"proTitle"}}]}}]}}]}}]} as unknown as DocumentNode<GetTradesQuery, GetTradesQueryVariables>;
export const SubmitApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitProApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitProApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}}]}}]}}]} as unknown as DocumentNode<SubmitApplicationMutation, SubmitApplicationMutationVariables>;
export const CreateContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateContactsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateContactsMutation, CreateContactsMutationVariables>;
export const ListBanksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListBanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listBanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<ListBanksQuery, ListBanksQueryVariables>;
export const GetBankAccountInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBankAccountInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBankAccountInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"bankCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}}]}}]}}]}}]} as unknown as DocumentNode<GetBankAccountInfoQuery, GetBankAccountInfoQueryVariables>;
export const SaveBankAccountInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveBankAccountInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addProPaymentInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"bankCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<SaveBankAccountInfoMutation, SaveBankAccountInfoMutationVariables>;
export const SubmitIdentityInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitIdentityInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitIdentityInformationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitIdentityInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identityVerification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"showDeclined"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SubmitIdentityInformationMutation, SubmitIdentityInformationMutationVariables>;
export const MyDiscardedApplicationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyDiscardedApplications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myDiscardedApplications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ad"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<MyDiscardedApplicationsQuery, MyDiscardedApplicationsQueryVariables>;
export const GetJobAdNotificationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJobAdNotificationPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJobAdNotificationPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"communicationMethods"}},{"kind":"Field","name":{"kind":"Name","value":"employmentTypes"}}]}}]}}]} as unknown as DocumentNode<GetJobAdNotificationPreferencesQuery, GetJobAdNotificationPreferencesQueryVariables>;
export const CreateJobAdNotificationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateJobAdNotificationPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentType"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"communicationMethods"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobAdCommunicationMethod"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createJobAdNotificationPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categoryIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"employmentTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentTypes"}}},{"kind":"Argument","name":{"kind":"Name","value":"communicationMethods"},"value":{"kind":"Variable","name":{"kind":"Name","value":"communicationMethods"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"communicationMethods"}},{"kind":"Field","name":{"kind":"Name","value":"employmentTypes"}}]}}]}}]} as unknown as DocumentNode<CreateJobAdNotificationPreferencesMutation, CreateJobAdNotificationPreferencesMutationVariables>;
export const UpdateJobAdNotificationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateJobAdNotificationPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentType"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"communicationMethods"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobAdCommunicationMethod"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJobAdNotificationPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categoryIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"employmentTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentTypes"}}},{"kind":"Argument","name":{"kind":"Name","value":"communicationMethods"},"value":{"kind":"Variable","name":{"kind":"Name","value":"communicationMethods"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employmentTypes"}},{"kind":"Field","name":{"kind":"Name","value":"communicationMethods"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateJobAdNotificationPreferencesMutation, UpdateJobAdNotificationPreferencesMutationVariables>;
export const AddPortfolioEducationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPortfolioEducation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"schoolName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldOfStudy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EducationLevel"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPortfolioEducation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"schoolName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"schoolName"}}},{"kind":"Argument","name":{"kind":"Name","value":"fieldOfStudy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldOfStudy"}}},{"kind":"Argument","name":{"kind":"Name","value":"qualification"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qualification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schoolName"}}]}}]}}]} as unknown as DocumentNode<AddPortfolioEducationMutation, AddPortfolioEducationMutationVariables>;
export const UpdateMyProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMyProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateOfBirth"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gender"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Gender"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customTagIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yearsOfExperience"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"detailedAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"incomeCurrency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"averageMonthlyIncome"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numberOfDaysWorkedPerWeek"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadSource"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadSourceText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reasonForJoiningLaborHack"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reasonsForJoiningLaborHack"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reasonForJoiningLaborHackOtherText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMyProApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateOfBirth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateOfBirth"}}},{"kind":"Argument","name":{"kind":"Name","value":"gender"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gender"}}},{"kind":"Argument","name":{"kind":"Name","value":"jobTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"tagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"customTagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customTagIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"yearsOfExperience"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yearsOfExperience"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"detailedAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"detailedAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"employmentStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"incomeCurrency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"incomeCurrency"}}},{"kind":"Argument","name":{"kind":"Name","value":"averageMonthlyIncome"},"value":{"kind":"Variable","name":{"kind":"Name","value":"averageMonthlyIncome"}}},{"kind":"Argument","name":{"kind":"Name","value":"numberOfDaysWorkedPerWeek"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numberOfDaysWorkedPerWeek"}}},{"kind":"Argument","name":{"kind":"Name","value":"phoneType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneType"}}},{"kind":"Argument","name":{"kind":"Name","value":"leadSource"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadSource"}}},{"kind":"Argument","name":{"kind":"Name","value":"leadSourceText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadSourceText"}}},{"kind":"Argument","name":{"kind":"Name","value":"reasonForJoiningLaborHack"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reasonForJoiningLaborHack"}}},{"kind":"Argument","name":{"kind":"Name","value":"reasonsForJoiningLaborHack"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reasonsForJoiningLaborHack"}}},{"kind":"Argument","name":{"kind":"Name","value":"reasonForJoiningLaborHackOtherText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reasonForJoiningLaborHackOtherText"}}},{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"employmentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"incomeCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"averageMonthlyIncome"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfDaysWorkedPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"phoneType"}},{"kind":"Field","name":{"kind":"Name","value":"leadSource"}},{"kind":"Field","name":{"kind":"Name","value":"leadSourceText"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForJoiningLaborHack"}},{"kind":"Field","name":{"kind":"Name","value":"reasonsForJoiningLaborHack"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForJoiningLaborHackOtherText"}},{"kind":"Field","name":{"kind":"Name","value":"detailedAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"placeId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>;
export const CreateProStudyWorkOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProStudyWorkOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProStudyWorkOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"opportunityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"opportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProStudyWorkOpportunityMutation, CreateProStudyWorkOpportunityMutationVariables>;
export const GetStudyWorkOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStudyWorkOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studyWorkOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<GetStudyWorkOpportunityQuery, GetStudyWorkOpportunityQueryVariables>;
export const SetPreferredCourseForProStudyWorkOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setPreferredCourseForProStudyWorkOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preferredCourse"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CanadaBasicApplicationCourseOfStudy"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPreferredCourseForProStudyWorkOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"opportunityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"preferredCourse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preferredCourse"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preferredCourse"}}]}}]}}]} as unknown as DocumentNode<SetPreferredCourseForProStudyWorkOpportunityMutation, SetPreferredCourseForProStudyWorkOpportunityMutationVariables>;
export const CreateCanadaBasicApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCanadaBasicApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCanadaBasicApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCanadaBasicApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCanadaBasicApplicationMutation, CreateCanadaBasicApplicationMutationVariables>;
export const UpdateMyStudyWorkProApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMyStudyWorkProApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentIndustry"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Industry"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highestEducationLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EducationLevel"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherOccupationText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasInternationalPassport"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"passportNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"passportIssueDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"passportExpiryDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"passportIssueAuthority"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emergencyContactName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emergencyContactPhone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yearOfGraduation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMyProApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"currentIndustry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentIndustry"}}},{"kind":"Argument","name":{"kind":"Name","value":"highestEducationLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highestEducationLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherOccupationText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherOccupationText"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasInternationalPassport"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasInternationalPassport"}}},{"kind":"Argument","name":{"kind":"Name","value":"passportNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"passportNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"passportIssueDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"passportIssueDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"passportExpiryDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"passportExpiryDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"passportIssueAuthority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"passportIssueAuthority"}}},{"kind":"Argument","name":{"kind":"Name","value":"emergencyContactName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emergencyContactName"}}},{"kind":"Argument","name":{"kind":"Name","value":"emergencyContactPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emergencyContactPhone"}}},{"kind":"Argument","name":{"kind":"Name","value":"yearOfGraduation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yearOfGraduation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employmentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"currentIndustry"}},{"kind":"Field","name":{"kind":"Name","value":"highestEducationLevel"}},{"kind":"Field","name":{"kind":"Name","value":"otherOccupationText"}},{"kind":"Field","name":{"kind":"Name","value":"hasInternationalPassport"}},{"kind":"Field","name":{"kind":"Name","value":"passportNumber"}},{"kind":"Field","name":{"kind":"Name","value":"passportIssueDate"}},{"kind":"Field","name":{"kind":"Name","value":"passportExpiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"passportIssueAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"emergencyContactName"}},{"kind":"Field","name":{"kind":"Name","value":"emergencyContactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"yearOfGraduation"}}]}}]}}]} as unknown as DocumentNode<UpdateMyStudyWorkProApplicationMutation, UpdateMyStudyWorkProApplicationMutationVariables>;
export const GetStudyWorkOpportunitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStudyWorkOpportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studyWorkOpportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<GetStudyWorkOpportunitiesQuery, GetStudyWorkOpportunitiesQueryVariables>;
export const ConfirmStudyWorkOpportunityPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmStudyWorkOpportunityPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmProStudyWorkOpportunityPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"opportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"checkout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}}]}}]}}]} as unknown as DocumentNode<ConfirmStudyWorkOpportunityPaymentMutation, ConfirmStudyWorkOpportunityPaymentMutationVariables>;
export const ConfirmTradeLevelPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmTradeLevelPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeLevelPaymentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmProTradeLevelPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tradeLevelPaymentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeLevelPaymentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}}]}}]}}]} as unknown as DocumentNode<ConfirmTradeLevelPaymentMutation, ConfirmTradeLevelPaymentMutationVariables>;
export const GetDiscountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDiscounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tradeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"applicableTradeLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetDiscountsQuery, GetDiscountsQueryVariables>;
export const GetTradeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTrade"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trade"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"external"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lmsCourseId"}},{"kind":"Field","name":{"kind":"Name","value":"invitationUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentLevel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"proId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proId"}}}]},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetTradeQuery, GetTradeQueryVariables>;
export const UpdateMyProApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMyProApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yearsOfExperience"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trainingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainingType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"incomeLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IncomeLevel"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numberOfDaysWorkedPerWeek"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCategoryText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMyProApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"yearsOfExperience"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yearsOfExperience"}}},{"kind":"Argument","name":{"kind":"Name","value":"trainingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trainingType"}}},{"kind":"Argument","name":{"kind":"Name","value":"incomeLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"incomeLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"numberOfDaysWorkedPerWeek"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numberOfDaysWorkedPerWeek"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherCategoryText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCategoryText"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"trainingType"}},{"kind":"Field","name":{"kind":"Name","value":"incomeLevel"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfDaysWorkedPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"otherCategoryText"}}]}}]}}]} as unknown as DocumentNode<UpdateMyProApplicationMutation, UpdateMyProApplicationMutationVariables>;
export const ConfirmTradeRequirementPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmTradeRequirementPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proTradeRequirementPaymentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmTradeRequirementPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"proTradeRequirementPaymentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proTradeRequirementPaymentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ConfirmTradeRequirementPaymentMutation, ConfirmTradeRequirementPaymentMutationVariables>;